import { Box, Checkbox, Collapse, Divider, Grid, IconButton, InputLabel, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
    AddCircleOutlineOutlined,
    Cancel,
    CancelOutlined,
    ClassOutlined,
    DeleteOutlineOutlined,
    ModeOutlined,
    SaveAlt,
    VisibilityOutlined,
    WarningAmber,
    WindowSharp,
    ExpandLess,
    ExpandMore,
    PersonOutlineOutlined,
    HealthAndSafetyOutlined,
    AttachFileOutlined,
    ContentPasteOutlined,
    SaveOutlined,
} from "@mui/icons-material";
import TextField from "../../common/TextField";
import Button from "../../common/Button";
import PageBackButton from "../../common/PageBackButton";
import { SectionHeader } from "../../ui/ContentSection";
import { useModalStyles } from "../../common/useModalStyles";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { PatientInfo, PatientInfoObject, SavePatientRequest, checkPatientExist, SaveWoundInfoRequest, checkWoundInfoIvrHasIvr, createPatient, getPatient, saveWoundInfo, updateElementInPatientSlice, updatePatientObjectReducer, usePatientReducer, resetPatientInfoObject, resetSecondaryInsuranceInfo, inactivatePatientWoundInfo, getSurgicalTemplateBasedOnProvider, getSurgicalTemplateByTemplateId, resetProviderTemplate, SurgicalTemplate } from "../../../redux/slice/patient/patientSlice";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import CustomNametField from "../../common/CustomNametField";
import CustomTextField from "../../common/CustomTextField";
import CustomCheckbox from "../../common/CustomCheckBox";
import CustomRadioButton from "../../common/CustomRadioButton";
import CustomDatePicker from "../../common/CustomDatePicker";
import CustomAddressTextField from "../../common/CustomAddressTextField";
import Dropzone, { ExtendedFile } from "../../common/Dropzone";
import { IVRDocumentInfo, removeIVRDocument, uploadIVRDocument } from "../../../redux/slice/ivr/ivrDocumentSlice";
import { convertBase64, formatWoundName, fullName, hideElement, sortNames } from "../../../utils/Utility";
import { validateMedicarePolicyNumber } from "../../../utils/medicareMbi";
import { Column, fetchAllPayers, setSingleAlertObj, showHideLoadingDialog, SingleAlertInfo, useCommonReducer } from "../../../redux/slice/commonSlice";
import dayjs from "dayjs";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import moment from "moment";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import { getPracticeListByUserRoleOrderSlice, useOrderSlice } from "../../../redux/slice/order/OrderSlice";
import { useUserReducer } from "../../../redux/slice/userSlice";
import { PracticeInfo } from "../../../redux/slice/practiceSlice";
import { AI_SERVICE_NAME, CAN_ACCESS_APPLICATION, PATIENT_IVR_INFO_TYPES, PATIENT_STATUS, PRACTICE_TYPE, RESPONSE_CODES,WOUND_TYPES, CREATE_PATIENT_FLOW_SOURCE } from "../../../constants/applicationConstants";
import CustomTable from "../../common/CustomTable";
import { WoundInfo } from "../ivr/IVRForm";
import IVRFormWoundInfoPopup from "../ivr/IVRFormWoundInfoPopup";
import CustomIconButton from "../../common/CustomIconButton";
import { fetchAllWoundCodes, getWoundCodeValuesByWoundCodeType, useWoundCodesSlice } from "../../../redux/slice/ivr/woundCodeSlice";
import StickTopStepper from "../../common/StickTopStepper";
import InfoPopup from "../../common/InfoPopup";
import { useNavigation } from "../../../hooks/useNavigation";
import { CodeTable, fetchAllCodeTablesValues, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import CustomAutocompleteField from "../../common/CustomAutocompleteField";
import { fetchActivePracticeProvidersData, usePracticeProvidersSlice } from "../../../redux/slice/practice/practiceProvidersSlice";
import IVRFormIncisionInfoPopup from "../ivr/IVRFormIncisionInfoPopup";
import { useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsTokenAvailable, selectIsValueFoundInToken, useAuthSlice } from "../../../redux/slice/authSlice";
import { uploadPDFForAudit, fetchAuditReport, getPatientAiAuditDataByPatientId, getRecentAiAuditDetailsByIdData, clearAuditJob, AuditJob } from "../../../redux/slice/AI/AiAuditSlice";
import AiMedicalAuditInfo from "../aiMedicalAudit/AiMedicalAuditInfo";
import FacesheetExtractionPopup from "../aiMedicalAudit/FacesheetExtractionPopup"; // CS-1758
import ConfirmationActionModal from "../../common/ConfirmationActionModal"; // CS-1758 - Facesheet cancel warning modal

type PatientResetObject = {
    practiceId: number | null;
    dateOfSurgery: string | null;
    providerId: number | null,
    patientInfo?: {
        patientId?: number;
        FirstName?: string;
        MiddleName?: string;
        LastName?: string;
        patientDOB?: string;
        gender?: string;
        StreetAddress?: string;
        UnitNumber?: string;
        City?: string;
        State?: string;
        Zipcode?: string;
        faceSheet?: number[];
        isFaceSheetSkipped?: boolean;
        patientEmail?: string;
    };
    insuranceInfo?: {
        insuranceName?: string;
        insuranceCategory?: string;
        insurancePayerCode?: string;
        primaryCommercialInsuranceName?: string;
        insuranceNameNotListed?: boolean;
        policy?: string;
        isPolicyUnderDifferentName?: boolean;
        policyholderFirstName?: string;
        policyholderMiddleName?: string;
        policyholderLastName?: string;
        policyHolderDOB?: string;
        insuranceCards?: number[];
        isInsuranceCardsSkipped?: boolean;
        isSecondaryInsurance?: boolean;
        secondaryInsuranceName?: string;
        secondaryInsuranceCategory?: string;
        secondaryInsurancePayerCode?: string;
        secondaryCommercialInsuranceName?: string;
        secondaryInsuranceNameNotListed?: boolean;
        secondaryPolicy?: string;
        isSecondaryPolicyUnderDifferentName?: boolean;
        secondarypolicyholderFirstName?: string;
        secondarypolicyholderMiddleName?: string;
        secondarypolicyholderLastName?: string;
        secondaryPolicyHolderDOB?: string;
        secondaryInsuranceCards?: number[];
        isSecondaryInsuranceCardsSkipped?: boolean;
    };
    supportingDocumentation?: {
        supportingDocuments?: number[];
        isSupportingDocumentsSkipped?: boolean;
        imageOfWounds?: number[];
        isImageOfWoundsSkipped?: boolean;
    };
    woundInfo?: {
        woundData?: any;
        totalSizeOfAllWounds?: number;
        isLoadedFromProviderTemplate?: boolean
    };
}

const CreatePatient: React.FC = () => {

    const { navigate } = useNavigation();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const {
        tokens: mTokens,
        isDark: isDarkModal,
        primaryBtnSx,
        cancelBtnSx,
        backBtnSx,
        inputFieldSx,
        dropdownWrapSx,
        datepickerWrapSx,
    } = useModalStyles();
    /* ── Modern card / field tokens (mirrors IVRForm.tsx) ── */
    const cardSx = {
        borderRadius: "16px",
        border: `1px solid ${mTokens.border}`,
        backgroundColor: mTokens.bg,
        backgroundImage: "none",
        overflow: "hidden" as const,
        boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
    };
    const sectionBodySx = { px: { xs: 2, md: 2.8 }, py: 2 };
    /* Wound/Incision table — matches the list-page table look (mirrors IVRForm.tsx's woundTableWrapSx) */
    const woundTableWrapSx = {
        "& .MuiTableContainer-root": {
            borderRadius: "12px",
            border: `1px solid ${mTokens.border}`,
            backgroundColor: mTokens.bg,
        },
        "& table": {
            
            borderCollapse: "collapse" as const,
            borderSpacing: 0,
        },
        "& .MuiTableCell-root": {
            borderBottom: `1px solid ${mTokens.border}`,
            py: 1.15,
            fontSize: "0.84rem",
        },
        "& .MuiTableHead-root .MuiTableCell-root": {
            height: "42px",
        },
        "& .MuiTableHead-root .MuiTypography-root": {
            color: "#00B8D9 !important",
            fontSize: "0.78rem",
            fontWeight: 800,
            letterSpacing: "0.02em",
        },
        "& .MuiTableBody-root .MuiTableRow-root": {
            transition: "background-color 0.18s ease, box-shadow 0.18s ease",
        },
        "& .MuiTableBody-root .MuiTableRow-root:hover": {
            backgroundColor: isDarkModal ? "rgba(20,184,166,0.06)" : "rgba(20,184,166,0.05)",
        },
        "& .MuiTableBody-root .MuiTableCell-root, & .MuiTableBody-root .MuiTypography-root": {
            color: mTokens.textPrimary,
            fontSize: "0.84rem",
        },
        "& .MuiIconButton-root": {
            color: isDarkModal ? "#94a3b8" : "#475569",
            borderRadius: "8px",
            "&:hover": {
                color: mTokens.accent,
                backgroundColor: isDarkModal ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)",
            },
        },
    };
    const FieldLabel = ({ label, required = false }: { label: string; required?: boolean }) => (
        <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, color: mTokens.textSecondary, mb: 0.7, display: "flex", alignItems: "center", gap: 0.4 }}>
            {label}{required && <Box component="span" sx={{ color: mTokens.accent }}>*</Box>}
        </Typography>
    );
    const inlineLabelSx = { mr: 3, fontSize: "0.8rem", fontWeight: 600, color: mTokens.textSecondary };
    const controlHeight = "42px";
    const controlHeightSx = {
        minHeight: `${controlHeight} !important`,
        height: `${controlHeight} !important`,
        maxHeight: `${controlHeight} !important`,
        boxSizing: "border-box !important",
        alignItems: "center",
    };
    const mergeControlSx = (base: object) => {
        const nested = (base as Record<string, unknown>)["& .MuiOutlinedInput-root, & .MuiInputBase-root"];
        return {
            ...(nested && typeof nested === "object" ? nested : {}),
            ...controlHeightSx,
        };
    };
    const dropdownFieldWrapSx = (hasError = false) => {
        const base = dropdownWrapSx(hasError);
        return {
            ...base,
            width: "100%",
            "& .MuiAutocomplete-root, & .MuiFormControl-root": { width: "100%", maxWidth: "100%" },
            "& .MuiOutlinedInput-root, & .MuiInputBase-root": mergeControlSx(base),
            "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
                padding: "0 38px 0 12px !important",
                flexWrap: "nowrap !important",
                overflow: "hidden !important",
            },
            "& .MuiAutocomplete-root .MuiInputBase-input, & .MuiAutocomplete-input, & .MuiOutlinedInput-input": {
                paddingTop: "8px !important",
                paddingBottom: "8px !important",
                height: "24px !important",
                lineHeight: "24px !important",
                boxSizing: "border-box",
            },
            "& .MuiAutocomplete-endAdornment": {
                top: "50% !important",
                transform: "translateY(-50%)",
                right: "8px !important",
            },
        };
    };
    const textFieldWrapSx = (hasError = false) => {
        const base = inputFieldSx(hasError);
        return {
            ...base,
            width: "100%",
            "& .MuiFormControl-root, & .MuiTextField-root": { width: "100%" },
            "& .MuiOutlinedInput-root:not(.MuiInputBase-multiline), & .MuiInputBase-root:not(.MuiInputBase-multiline)": mergeControlSx(base),
        };
    };
    const dateFieldWrapSx = (hasError = false) => {
        const base = datepickerWrapSx(hasError);
        return {
            ...base,
            width: "100%",
            "& .MuiFormControl-root, & .MuiTextField-root": { width: "100%" },
            "& .MuiOutlinedInput-root": {
                ...(base["& .MuiOutlinedInput-root"] as object),
                ...controlHeightSx,
            },
        };
    };
    /* Collapsible sections previously handled by BorderedSection's hasCollapse/defaultExpanded */
    const [patientInfoExpanded, setPatientInfoExpanded] = useState(true);
    const [insuranceInfoExpanded, setInsuranceInfoExpanded] = useState(true);
    const [supportingDocsExpanded, setSupportingDocsExpanded] = useState(true);
    const [woundDataExpanded, setWoundDataExpanded] = useState(true);
    const collapseToggleSx = {
        border: `1px solid ${mTokens.border}`,
        borderRadius: "10px",
        width: 30,
        height: 30,
        color: mTokens.textSecondary,
        "&:hover": { borderColor: mTokens.accent, color: mTokens.accent, backgroundColor: `${mTokens.accent}0d` },
    };
    /* Compact teal-outline action button for a SectionHeader's action slot (mirrors IVRForm.tsx's sectionActionBtnSx). */
    const sectionActionBtnSx = (hasError = false) => ({
        textTransform: "none" as const,
        fontWeight: 700,
        fontSize: "0.78rem",
        borderRadius: "8px",
        py: 0.55,
        px: 1.3,
        minHeight: "32px",
        color: hasError ? mTokens.error : mTokens.accent,
        borderColor: hasError ? `${mTokens.error}8c` : `${mTokens.accent}8c`,
        backgroundColor: hasError
            ? (isDarkModal ? "rgba(239,68,68,0.08)" : "rgba(239,68,68,0.04)")
            : (isDarkModal ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)"),
        "&:hover": {
            color: "#fff",
            borderColor: hasError ? mTokens.error : mTokens.accent,
            backgroundColor: hasError ? mTokens.error : mTokens.accent,
            boxShadow: hasError ? "0 6px 18px rgba(239,68,68,0.28)" : "0 6px 18px rgba(20,184,166,0.28)",
        },
        "& .MuiTypography-root": { color: "inherit", fontWeight: 700 },
        "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
    });
      const { allCodeTablesValuesMap ,allCodeTableValueFetchStatus } = useCodetablesSlice();
    const { patientInfoObject, woundInfoHasIvrByPatient,surgicalTemplateOptions, surgicalTemplate } = usePatientReducer();
    const { userInfo } = useAuthSlice(); // CS-1706 - Uncommented to check subscribedServices
    const { allPayerList } = useCommonReducer();
    const { practiceProvidersInfo } = usePracticeProvidersSlice();


    const { practiceByUserRoleOrderSlice } = useOrderSlice();
    const { control, handleSubmit, reset, getValues, setValue, trigger, clearErrors, setError, watch, formState: { errors } } = useForm<PatientInfoObject>();
    const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: '', show: false });
    const [isPolicyUnderDifferentNameCheck, setIsPolicyUnderDifferentNameCheck] = useState(false);
    const [isPolicyUnderDifferentNameCheckSecondary, setIsPolicyUnderDifferentNameCheckSecondary] = useState(false);
    const [isSecondaryInsurance, setIsSecondaryInsurance] = useState(false);
    const [insuranceNameNotListed, setInsuranceNameNotListed] = useState(false);
    const [secondaryInsuranceNameNotListed, setSecondaryInsuranceNameNotListed] = useState(false);
    const [patientEditDetails, setPatientEditDetails] = useState<{ isPatientEdit: boolean, patientId: number } | null>(null);
    const [uploadedWoundImageFilesMetaData, setUploadedWoundImageFilesMetaData] = useState<ExtendedFile[]>([]);
    const [uploadedFacesheetFilesMetaData, setUploadedFacesheetFilesMetaData] = useState<ExtendedFile[]>([]);
    const [uploadedPrimaryInsuranceFilesMetaData, setUploadedPrimaryInsuranceFilesMetaData] = useState<ExtendedFile[]>([]);
    const [uploadedSecondaryInsuranceFilesMetaData, setUploadedSecondaryInsuranceFilesMetaData] = useState<ExtendedFile[]>([]);

    const [uploadedSupportingDocumentFilesMetaData, setUploadedSupportingDocumentFilesMetaData] = useState<ExtendedFile[]>([]);
    const [isNameChange, setNameChange] = useState(false);
    const [showEditButton, setShowEditButton] = useState(false);
    const [disablePatientName, setDisablePatientName] = useState(false);
    const { allWoundCodesValuesMap, woundCodeFetchStatus } = useWoundCodesSlice();
    const [woundInfoRows, setWoundInfoRows] = useState<WoundInfo[]>([]);
    const [prevProviderTemplateId, setPrevProviderTemplateId] = useState<number | null>(null);
    const [prevProviderId, setPrevProviderId] = useState<number | null>(null);
    const [currentWoundInfo, setCurrentWoundInfo] = useState(null);
    const [activeStep, setActiveStep] = useState<number>(0);
    const [patientInfoValid, setPatientInfoValid] = useState(false);
    const [insuranceInfoValid, setInsuranceInfoValid] = useState(false);
    const [supportingDocumentationValid, setSupportingDocumentationValid] = useState(false);
    const [woundInfoValid, setWoundInfoValid] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const steps = [
        { stepName: "Patient Information", isCompleted: patientInfoValid },
        { stepName: "Insurance Information", isCompleted: insuranceInfoValid },
        { stepName: "Supporting Documentation", isCompleted: supportingDocumentationValid },
        { stepName: "Wound Data", isCompleted: woundInfoValid },
    ];
    const patientInformationRef = useRef<HTMLDivElement>(null);
    const insuranceInformationRef = useRef<HTMLDivElement>(null);
    const supportingDocumentationRef = useRef<HTMLDivElement>(null);
    const woundDataRef = useRef<HTMLDivElement>(null);
    const [maxWoundRowIndex, setMaxWoundRowIndex] = useState(0);
    const [showWoundInfoPopup, setShowWoundInfoPopup] = useState(false);

    const [patientCompleteData, setPatientCompleteData] = useState<PatientResetObject>();
    const [isPatientEdited, setIsPatientEdited] = useState(false);
    const [isOtherPatientDataEdited, setIsOtherPatientDataEdited] = useState(false);
    const [isPatientInfoEdited, setIsPatientInfoEdited] = useState(false);
    const [isFaceSheetEdited, setIsFaceSheetEdited] = useState(false);
    const [isPrimaryInsuranceInfoEdited, setIsPrimaryInsuranceInfoEdited] = useState(false);
    const [isSecondaryInsuranceInfoEdited, setIsSecondaryInsuranceInfoEdited] = useState(false);
    const [isSupportingDocumentsEdited, setIsSupportingDocumentsEdited] = useState(false);
    const [isImageOfWoundsEdited, setIsImageOfWoundsEdited] = useState(false);
    const [isWoundInfoEdited, setIsWoundInfoEdited] = useState(false);
    const [isEmailEdited, setIsEmailEdited] = useState(false);

    const [patientInfoIdAddress, setPatientInfoIdAddress] = useState<number | null>(null);
    const [patientInfoIdFaceSheet, setPatientInfoIdFaceSheet] = useState<number | null>(null);
    const [patientInfoIdSurgicalInfo, setPatientInfoIdSurgicalInfo] = useState<number | null>(null);
    const [patientInfoIdPrimaryInsurance, setPatientInfoIdPrimaryInsurance] = useState<number | null>(null);
    const [patientInfoIdSecondaryInsurance, setPatientInfoIdSecondaryInsurance] = useState<number | null>(null);
    const [patientInfoIdSupportingDocs, setPatientInfoIdSupportingDocs] = useState<number | null>(null);
    const [patientInfoIdWoundImages, setPatientInfoIdWoundImages] = useState<number | null>(null);
    const [patientWoundInfo, setPatientWoundInfo] = useState<number | null>(null);
    const [patientEmail, setPatientEmail] = useState<number | null>(null);
    const [patientNameChange, setPatientNameChange] = useState<number | null>(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [maxWoundIdFromMount, setMaxWoundIdFromMount] = useState<number | null>(null);
    const [showInfoPopup, setShowInfoPopup] = useState<{ message: string, show: boolean }>({ message: "", show: false });
    const [isWoundInfoAlreadySaved, setIsWoundInfoAlreadySaved] = useState(false);
    const [ selectedPractice, setSelectedPractice] = useState<PracticeInfo | null>(null);
    const [ selectedPracticeType, setSelectedPracticeType ] = useState("");
    const [practiceProvidersLoadedFor, setPracticeProvidersLoadedFor] = useState<string | null>(null);
    const practiceProvidersRequestRef = useRef(0);
    const [showIncisionInfoPopup, setShowIncisionInfoPopup] = useState(false);
    //CS-1244 - Start
    const [patientObjDetails, setPatientObjDetails] = useState<{ isPatientEdit: false, patientId: null, patientData: any }>();
    //CS-1244 - End
    const [showFacesheetExtractionPopup, setShowFacesheetExtractionPopup] = useState(false); // CS-1758
    const [selectedFacesheetReportData, setSelectedFacesheetReportData] = useState<any>(null);
    const [selectedFacesheetReportDocumentId, setSelectedFacesheetReportDocumentId] = useState<number | null>(null);
    const [showFacesheetCancelWarning, setShowFacesheetCancelWarning] = useState(false); // CS-1758 - Confirm cancel for unsaved facesheet patient flow
    const [isAddIncisionButtonDisabled, setIsAddIncisionButtonDisabled] = useState(false);
    const providerId = useWatch({ control, name: "providerId" });
    const providerTemplateId = useWatch({ control, name: "providerTemplateId" });
    //CS-1595
    const hasSubscribedAccessToMedicalAudit = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.MEDICAL_NOTE_AUDIT)(state));
    //CS-1758 : Token for facesheet extraction report access
    const hasAccessToFacesheetExtractionReport = useSelector((state: RootState) => selectIsTokenAvailable("canViewFacesheetAIExractReport")(state));
    
    // CS-1594 - Ref to track if API has been called
    const auditApiCalledRef = useRef(false);

    // CS-1773 - Run Medical Note Audit AI Tool in Background
    const formCommittedRef = useRef(false);

    // CS-1594 - Audit data management - Map of documentId to audit data
    const [auditDataByDocument, setAuditDataByDocument] = useState<Map<string, any>>(new Map());
    
    // CS-1595 - Individual audit state variables (legacy - kept for compatibility)
    const [auditData, setAuditData] = useState<any>(null);
    const [auditInProgress, setAuditInProgress] = useState(false);
    const [auditCompleted, setAuditCompleted] = useState(false);
    const [uploadedPdfFile, setUploadedPdfFile] = useState<File | null>(null);
    const [showFacesheetValidation, setShowFacesheetValidation] = useState(false); // CS-1758 - Enable required-field validation immediately after facesheet auto-fill
    const extractedFacesheetData = location.state?.patientDetails?.facesheetData;
    const extractedFacesheetFile = location.state?.patientDetails?.facesheetFile as File | undefined;
    const extractedFacesheetDocumentId = location.state?.patientDetails?.facesheetDocumentId as number | undefined;
    // CS-1758 - Track create patient entry source for request payload
    // Prefer location.state (fresh facesheet flow), then fall back to backend source on edit
    const createPatientFlowSourceFromNav =
        location.state?.patientDetails?.createPatientFlowSource ||
        (extractedFacesheetData
            ? CREATE_PATIENT_FLOW_SOURCE.FACESHEET
            : undefined);
    // CS-1758 - Use patientInfoObject?.source from backend when re-opening a saved facesheet patient
    const createPatientFlowSource =
        createPatientFlowSourceFromNav ||
        (patientInfoObject as any)?.source ||
        CREATE_PATIENT_FLOW_SOURCE.MANUAL;
    const hasTriggeredFacesheetValidationRef = useRef(false); // CS-1758 - Ensure auto-validation runs only once for the facesheet entry flow
    // CS-1758 - Cache facesheet-extracted insurance data keyed by category so re-selecting
    // the same category after a change restores the original AI-extracted values
    const facesheetPrimaryInsuranceCacheRef = useRef<Record<string, any>>({});
    const facesheetSecondaryInsuranceCacheRef = useRef<Record<string, any>>({});
    // const scrollToElement = (elementRef: any) => {
    //     if (elementRef && elementRef.current) {
    //         elementRef.current.scrollIntoView({ behavior: "smooth" });
    //     }
    // };
    const scrollToElement = (elementRef: any, offset = 100) => {
        if (elementRef && elementRef.current) {
            const elementPosition = elementRef.current.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;
    
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    // CS-1758 - Normalize extracted facesheet data so it can survive later form resets
    const applyExtractedFacesheetToPatientData = useCallback((basePatientData: any) => {
        if (!extractedFacesheetData) {
            return basePatientData;
        }

        const facesheet = extractedFacesheetData?.facesheet || extractedFacesheetData;
        // CS-1758 - Primary and secondary insurance now come from insurances array
        const primaryInsuranceExtracted = Array.isArray(facesheet.insurances) ? facesheet.insurances.find((ins: any) => ins.type === "Primary") || facesheet.insurances[0] : null;
        const secondaryInsuranceExtracted = Array.isArray(facesheet.insurances) ? facesheet.insurances.find((ins: any) => ins.type === "Secondary") : null;
        const updatedPatientData = {
            ...basePatientData,
            patientInfo: {
                ...basePatientData.patientInfo,
                FirstName: facesheet.first_name || basePatientData.patientInfo?.FirstName,
                MiddleName: facesheet.middle_name || basePatientData.patientInfo?.MiddleName,
                LastName: facesheet.last_name || basePatientData.patientInfo?.LastName,
                patientDOB: facesheet.dob || basePatientData.patientInfo?.patientDOB,
                gender: facesheet.sex || basePatientData.patientInfo?.gender,
                StreetAddress: facesheet.street_address || basePatientData.patientInfo?.StreetAddress,
                UnitNumber: facesheet.unit_number || basePatientData.patientInfo?.UnitNumber,
                City: facesheet.city || basePatientData.patientInfo?.City,
                State: facesheet.state || basePatientData.patientInfo?.State,
                Zipcode: facesheet.zip_code || basePatientData.patientInfo?.Zipcode,
                patientEmail: facesheet.email || basePatientData.patientInfo?.patientEmail,
                faceSheet: extractedFacesheetDocumentId
                    ? [extractedFacesheetDocumentId]
                    : basePatientData.patientInfo?.faceSheet,
                isFaceSheetSkipped: extractedFacesheetDocumentId
                    ? false
                    : basePatientData.patientInfo?.isFaceSheetSkipped,
            },
            insuranceInfo: {
                ...basePatientData.insuranceInfo,
                // CS-1758 - Map primary insurance from insurances array instead of flat fields
                // insuranceName: facesheet.insurance_name || basePatientData.insuranceInfo?.insuranceName,
                // insuranceCategory: facesheet.insurance_category || basePatientData.insuranceInfo?.insuranceCategory,
                // policy: facesheet.policy_number
                //     ? facesheet.policy_number.toUpperCase()
                //     : basePatientData.insuranceInfo?.policy,
                // CS-1758 - Only fall back to "Other" commercial plan when the payer code is "0" (plan not in system);
                // when a real payer code is provided, use the plan name directly from the dropdown
                insuranceName: (primaryInsuranceExtracted?.primaryCommercialInsuranceName && primaryInsuranceExtracted?.insurancePayerCode === "0")
                    ? "Other"
                    : (primaryInsuranceExtracted?.name || basePatientData.insuranceInfo?.insuranceName),
                insuranceCategory: primaryInsuranceExtracted?.category || basePatientData.insuranceInfo?.insuranceCategory,
                // CS-1758 - Map insurancePayerCode and primaryCommercialInsuranceName from facesheet insurances array
                insurancePayerCode: primaryInsuranceExtracted?.insurancePayerCode ?? basePatientData.insuranceInfo?.insurancePayerCode,
                primaryCommercialInsuranceName: (primaryInsuranceExtracted?.primaryCommercialInsuranceName && primaryInsuranceExtracted?.insurancePayerCode === "0")
                    ? primaryInsuranceExtracted.primaryCommercialInsuranceName
                    : basePatientData.insuranceInfo?.primaryCommercialInsuranceName,
                insuranceNameNotListed: (primaryInsuranceExtracted?.primaryCommercialInsuranceName && primaryInsuranceExtracted?.insurancePayerCode === "0")
                    ? true
                    : basePatientData.insuranceInfo?.insuranceNameNotListed,
                policy: primaryInsuranceExtracted?.policy_number
                    ? primaryInsuranceExtracted.policy_number.toUpperCase()
                    : basePatientData.insuranceInfo?.policy,
            },
        };

        // CS-1758 - Map primary insurance subscriber_name from insurances array
        // if (facesheet.subscriber_name) {
        //     const nameParts = (facesheet.subscriber_name || "").trim().split(/\s+/).filter(Boolean);
        if (primaryInsuranceExtracted?.subscriber_name) {
            const nameParts = (primaryInsuranceExtracted.subscriber_name || "").trim().split(/\s+/).filter(Boolean);
            updatedPatientData.insuranceInfo.isPolicyUnderDifferentName = true;
            if (nameParts.length >= 1) {
                updatedPatientData.insuranceInfo.policyholderFirstName = nameParts[0];
            }
            if (nameParts.length === 2) {
                updatedPatientData.insuranceInfo.policyholderLastName = nameParts[1];
            }
            if (nameParts.length >= 3) {
                updatedPatientData.insuranceInfo.policyholderMiddleName = nameParts.slice(1, -1).join(" ");
                updatedPatientData.insuranceInfo.policyholderLastName = nameParts[nameParts.length - 1];
            }
        }

        // CS-1758 - Map secondary insurance from insurances array
        if (secondaryInsuranceExtracted) {
            updatedPatientData.insuranceInfo.isSecondaryInsurance = true;
            // CS-1758 - Only fall back to "Other" when payer code is "0" (plan not in system)
            // CS-1758 - API uses secondaryInsurancePayerCode for secondary insurance
            const secondaryPayerCode = secondaryInsuranceExtracted.secondaryInsurancePayerCode ?? secondaryInsuranceExtracted.insurancePayerCode;
            if (secondaryInsuranceExtracted.secondaryCommercialInsuranceName && secondaryPayerCode === "0") {
                updatedPatientData.insuranceInfo.secondaryInsuranceName = "Other";
                updatedPatientData.insuranceInfo.secondaryCommercialInsuranceName = secondaryInsuranceExtracted.secondaryCommercialInsuranceName;
                updatedPatientData.insuranceInfo.secondaryInsuranceNameNotListed = true;
            } else {
                updatedPatientData.insuranceInfo.secondaryInsuranceName = secondaryInsuranceExtracted.name || basePatientData.insuranceInfo?.secondaryInsuranceName;
            }
            updatedPatientData.insuranceInfo.secondaryInsuranceCategory = secondaryInsuranceExtracted.category || basePatientData.insuranceInfo?.secondaryInsuranceCategory;
            updatedPatientData.insuranceInfo.secondaryInsurancePayerCode = secondaryPayerCode ?? basePatientData.insuranceInfo?.secondaryInsurancePayerCode;
            updatedPatientData.insuranceInfo.secondaryPolicy = secondaryInsuranceExtracted.policy_number
                ? secondaryInsuranceExtracted.policy_number.toUpperCase()
                : basePatientData.insuranceInfo?.secondaryPolicy;

            if (secondaryInsuranceExtracted.subscriber_name) {
                const secNameParts = (secondaryInsuranceExtracted.subscriber_name || "").trim().split(/\s+/).filter(Boolean);
                updatedPatientData.insuranceInfo.isSecondaryPolicyUnderDifferentName = true;
                if (secNameParts.length >= 1) {
                    updatedPatientData.insuranceInfo.secondarypolicyholderFirstName = secNameParts[0];
                }
                if (secNameParts.length === 2) {
                    updatedPatientData.insuranceInfo.secondarypolicyholderLastName = secNameParts[1];
                }
                if (secNameParts.length >= 3) {
                    updatedPatientData.insuranceInfo.secondarypolicyholderMiddleName = secNameParts.slice(1, -1).join(" ");
                    updatedPatientData.insuranceInfo.secondarypolicyholderLastName = secNameParts[secNameParts.length - 1];
                }
            }
        }

        return updatedPatientData;
    }, [extractedFacesheetData, extractedFacesheetDocumentId]);

    useEffect(() => {
        if (!firstLoad) {
            switch (activeStep) {
                case 0:
                    scrollToElement(patientInformationRef);
                    break;
                case 1:
                    scrollToElement(insuranceInformationRef);
                    break;
                case 2:
                    scrollToElement(supportingDocumentationRef);
                    break;
                case 3:
                    scrollToElement(woundDataRef);
                    break;
                default:
                    break;
            }
        } else {
            setFirstLoad(false);
        }
    }, [activeStep]);

    useEffect(() => {
        const handleScroll = () => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const generateUniqueId = (index: number): string => {
        return `${`WOUND`}_${index}`;
    };

    
    const getMaxWoundInfoKey = (rows: WoundInfo[]): number => {
        const maxKey = rows.reduce((max, row) => {
            if (row.woundInfoKey) {
                const parts = row.woundInfoKey.split('_');
                const num = parseInt(parts[parts.length - 1], 10);
                if (!isNaN(num) && num > max) {
                    return num;
                }
            }
            return max;
        }, 0);
        return maxKey;
    };

    useEffect(() => {
        if (maxWoundIdFromMount) {
            setMaxWoundRowIndex(maxWoundIdFromMount);
            setMaxWoundIdFromMount(null);
        } else if (!isDeleting && woundInfoRows && woundInfoRows.length > 0) {
            const maxNumber = getMaxWoundInfoKey(woundInfoRows);
            setMaxWoundRowIndex(maxNumber);
        }

        if (isDeleting) {
            saveWoundInfoRows(woundInfoRows, "DELETE");
            setIsDeleting(false);
        }
    }, [woundInfoRows]);


    const checkPatientInfoValidity = (data: any, initialChange?: boolean) => {
        const { patientInfo, practiceId, dateOfSurgery, providerId } = data;

        if (patientInfo) {
            const { FirstName, MiddleName, LastName, patientDOB, gender, StreetAddress, City, UnitNumber, State, Zipcode, faceSheet, patientEmail } = patientInfo;
            const isValid = !!practiceId && !!FirstName && !!LastName && !!patientDOB && !!gender && !!providerId && !!StreetAddress && !!City && !!State && !!Zipcode && (Array.isArray(faceSheet) ? faceSheet.length > 0 ? true : getValues("patientInfo.isFaceSheetSkipped") : !!faceSheet);
            setPatientInfoValid(isValid);

            if (patientCompleteData !== undefined) {
                if (patientCompleteData?.patientInfo?.FirstName !== undefined) {
                    const isPatientDataEdited =
                        FirstName !== patientCompleteData?.patientInfo?.FirstName ||
                        MiddleName !== patientCompleteData?.patientInfo?.MiddleName ||
                        LastName !== patientCompleteData?.patientInfo?.LastName ||
                        patientDOB !== patientCompleteData?.patientInfo?.patientDOB
                    // gender !== patientCompleteData?.patientInfo?.gender;

                    setIsPatientEdited(initialChange ? false : isPatientDataEdited);

                    const isOtherPatientDataEdited = gender !== patientCompleteData?.patientInfo?.gender ||
                    dateOfSurgery !== patientCompleteData?.dateOfSurgery ||
                    providerId !== patientCompleteData?.providerId

                    setIsOtherPatientDataEdited(initialChange ? false : isOtherPatientDataEdited);
                }
                if (patientCompleteData?.patientInfo?.StreetAddress !== undefined) {
                    const isPatientInfoEdited =
                        StreetAddress !== patientCompleteData?.patientInfo?.StreetAddress ||
                        UnitNumber !== patientCompleteData?.patientInfo?.UnitNumber ||
                        City !== patientCompleteData?.patientInfo?.City ||
                        State !== patientCompleteData?.patientInfo?.State ||
                        Zipcode !== patientCompleteData?.patientInfo?.Zipcode;

                    setIsPatientInfoEdited(initialChange ? false : isPatientInfoEdited);
                }
                if (patientCompleteData?.patientInfo?.faceSheet !== undefined) {
                    const isFaceSheetEdited =
                        JSON.stringify(faceSheet) !==
                        JSON.stringify(patientCompleteData?.patientInfo?.faceSheet);
                    setIsFaceSheetEdited(initialChange ? false : isFaceSheetEdited);
                }

                if (patientCompleteData?.patientInfo?.patientEmail !== undefined) {
                    const isEmailInfoEdited = patientEmail !== patientCompleteData?.patientInfo?.patientEmail;
                    setIsEmailEdited(initialChange ? false : isEmailInfoEdited);
                }
            }
        };
    }
  const checkInsuranceInfoValidity = (data: any, initialChange?: boolean) => {
        const { insuranceInfo } = data;
        if (insuranceInfo) {
            const { insuranceName, policy, isPolicyUnderDifferentName, policyholderFirstName, policyholderMiddleName, policyholderLastName, policyHolderDOB, insuranceType, insuranceCards,
                secondaryInsuranceName, secondaryPolicy, isSecondaryPolicyUnderDifferentName, secondarypolicyholderFirstName, secondarypolicyholderMiddleName, secondarypolicyholderLastName,
                secondaryPolicyHolderDOB, secondaryInsuranceType, secondaryInsuranceCards } = insuranceInfo;
                let isValid = false;
                
            if (isPolicyUnderDifferentName === "yes") {
                isValid = !!insuranceName && !!policy && !!isPolicyUnderDifferentName && !!policyholderFirstName && !!policyholderLastName && !!policyHolderDOB &&
                    (Array.isArray(insuranceCards) ? insuranceCards.length > 0 ? true : getValues("insuranceInfo.isInsuranceCardsSkipped") : !!insuranceCards);
            } else {
                isValid = !!insuranceName && !!policy && !!isPolicyUnderDifferentName &&
                    (Array.isArray(insuranceCards) ? insuranceCards.length > 0 ? true : getValues("insuranceInfo.isInsuranceCardsSkipped") : !!insuranceCards);
            }
            setInsuranceInfoValid(isValid);

            if (patientCompleteData?.insuranceInfo?.insuranceName !== undefined) {
                const isPrimaryInsuranceInfoEdited =
                    insuranceName !== patientCompleteData?.insuranceInfo?.insuranceName ||
                    policy !== patientCompleteData?.insuranceInfo?.policy ||
                    isPolicyUnderDifferentName !== patientCompleteData?.insuranceInfo?.isPolicyUnderDifferentName ||
                    policyholderFirstName !== patientCompleteData?.insuranceInfo?.policyholderFirstName ||
                    policyholderMiddleName !== patientCompleteData?.insuranceInfo?.policyholderMiddleName ||
                    policyholderLastName !== patientCompleteData?.insuranceInfo?.policyholderLastName ||
                    policyHolderDOB !== patientCompleteData?.insuranceInfo?.policyHolderDOB ||
                    // insuranceType !== patientCompleteData?.insuranceInfo?.insuranceType ||
                    JSON.stringify(insuranceCards) !== JSON.stringify(patientCompleteData?.insuranceInfo?.insuranceCards);

                setIsPrimaryInsuranceInfoEdited(initialChange ? false : isPrimaryInsuranceInfoEdited);
            }

            if (patientCompleteData?.insuranceInfo?.secondaryInsuranceName !== undefined) {
                const isSecondaryInsuranceDetailsEdited =
                    secondaryInsuranceName !== patientCompleteData?.insuranceInfo?.secondaryInsuranceName ||
                    secondaryPolicy !== patientCompleteData?.insuranceInfo?.secondaryPolicy ||
                    isSecondaryPolicyUnderDifferentName !== patientCompleteData?.insuranceInfo?.isSecondaryPolicyUnderDifferentName ||
                    secondarypolicyholderFirstName !== patientCompleteData?.insuranceInfo?.secondarypolicyholderFirstName ||
                    secondarypolicyholderMiddleName !== patientCompleteData?.insuranceInfo?.secondarypolicyholderMiddleName ||
                    secondarypolicyholderLastName !== patientCompleteData?.insuranceInfo?.secondarypolicyholderLastName ||
                    secondaryPolicyHolderDOB !== patientCompleteData?.insuranceInfo?.secondaryPolicyHolderDOB ||
                    // secondaryInsuranceType !== patientCompleteData?.insuranceInfo?.secondaryInsuranceType ||
                    JSON.stringify(secondaryInsuranceCards) !== JSON.stringify(patientCompleteData?.insuranceInfo?.secondaryInsuranceCards);

                setIsSecondaryInsuranceInfoEdited(initialChange ? false : isSecondaryInsuranceDetailsEdited);
            }
        };
    }

    const checkSupportingDocumentationValidity = (data: any, initialChange?: boolean) => {
        const { supportingDocumentation } = data;
        if (supportingDocumentation) {
            const { supportingDocuments, imageOfWounds } = supportingDocumentation;
            const isValid = (Array.isArray(supportingDocuments) ? supportingDocuments.length > 0 ? true : getValues("supportingDocumentation.isSupportingDocumentsSkipped") : !!supportingDocuments) &&
                (Array.isArray(imageOfWounds) ? imageOfWounds.length > 0 ? true : getValues("supportingDocumentation.isImageOfWoundsSkipped") : !!imageOfWounds);
            setSupportingDocumentationValid(isValid);

            if (patientCompleteData?.supportingDocumentation?.supportingDocuments !== undefined) {
                const IsSupportingDocumentsEdited = JSON.stringify(supportingDocuments) !== JSON.stringify(patientCompleteData?.supportingDocumentation?.supportingDocuments);
                setIsSupportingDocumentsEdited(initialChange ? false : IsSupportingDocumentsEdited);
            }

            if (patientCompleteData?.supportingDocumentation?.imageOfWounds !== undefined) {
                const IsImageOfWoundsEdited = JSON.stringify(imageOfWounds) !== JSON.stringify(patientCompleteData?.supportingDocumentation?.imageOfWounds);
                setIsImageOfWoundsEdited(initialChange ? false : IsImageOfWoundsEdited);
            }
        };
    }

    const checkWoundInfoValidity = (data: any, initialChange?: boolean) => {
        const { woundInfo } = data;
        if (woundInfo) {
            const { totalSizeOfAllWounds } = woundInfo;
            const isValid =
                !!totalSizeOfAllWounds &&
                Array.isArray(woundInfoRows) &&
                woundInfoRows.length > 0;
            setWoundInfoValid(isValid);

            // if (patientCompleteData?.woundInfo?.woundData?.length > 0) {
            //     if(isAddIncisionButtonDisabled){
            //         const IsWoundInfoEdited = woundInfoRows[0].otherDxCodes !== patientCompleteData?.woundInfo?.woundData?.[0].otherDxCodes
            //         setIsWoundInfoEdited(initialChange ? false : IsWoundInfoEdited)
            //     }else{
            //         const IsWoundInfoEdited = woundInfoRows.length !== patientCompleteData?.woundInfo?.woundData?.length
            //         console.log(IsWoundInfoEdited)
            //         setIsWoundInfoEdited(initialChange ? false : IsWoundInfoEdited)
            //     }
            // }

        } else {
            setWoundInfoValid(false);
        }
    };

    useEffect(() => {
        checkWoundInfoValidity({ ...watch() });
    }, [woundInfoRows, getValues("woundInfo.totalSizeOfAllWounds")]);

    const hasNestedErrors = (obj: any) => {
        for (const key in obj) {
            if (obj[key] && typeof obj[key] === 'object') {
                if (hasNestedErrors(obj[key])) {
                    return true;
                }
            } else {
                return true;
            }
        }
        return false;
    };

    const defaultValues = useCallback(() => {

        const activePatientInfo = patientInfoObject?.patientInfo?.filter(info => info.inactiveDate === null) ?? [];

        activePatientInfo.reduce((acc: any, info: any) => {

            switch (info.infoType) {
                case PATIENT_IVR_INFO_TYPES.ADDRESS:
                    setPatientInfoIdAddress(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.FACE_SHEET:
                    setPatientInfoIdFaceSheet(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE:
                    setPatientInfoIdPrimaryInsurance(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE:
                    setPatientInfoIdSecondaryInsurance(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.MEDICAL_NOTES:
                    setPatientInfoIdSupportingDocs(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.IMAGE_OF_WOUNDS:
                    setPatientInfoIdWoundImages(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.WOUND_INFO:
                    setPatientWoundInfo(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.EMAIL:
                    setPatientEmail(info.patientinfoId);
                    break;
                case PATIENT_IVR_INFO_TYPES.NAME_CHANGE:
                    setPatientNameChange(info.patientinfoId);
                    break;
                default:
                    break;
            }
            return acc;
        }, []);

        const address = activePatientInfo?.find((info: { infoType: string; inactiveDate: string }) => info.infoType === PATIENT_IVR_INFO_TYPES.ADDRESS && info.inactiveDate === null);
        const faceSheet = activePatientInfo?.find(info => info.infoType === PATIENT_IVR_INFO_TYPES.FACE_SHEET);
        const primaryInsurance = activePatientInfo.find(info => info.infoType === PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE);
        
        const imageOfWounds = activePatientInfo?.find(info => info.infoType === PATIENT_IVR_INFO_TYPES.IMAGE_OF_WOUNDS);
        const secondaryInsurance = activePatientInfo?.find(info => info.infoType === PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE);
        const supportingDocs = activePatientInfo?.find(info => info.infoType === PATIENT_IVR_INFO_TYPES.MEDICAL_NOTES);
        const woundInfo = activePatientInfo?.find(info => info.infoType === PATIENT_IVR_INFO_TYPES.WOUND_INFO);
        const emailInfo = activePatientInfo?.find(info => info.infoType === PATIENT_IVR_INFO_TYPES.EMAIL);

        setIsPolicyUnderDifferentNameCheck(
            primaryInsurance?.patientinfoData?.isPolicyUnderDifferentName === 'yes' ? true : false
        )

        setIsPolicyUnderDifferentNameCheckSecondary(
            secondaryInsurance?.patientinfoData?.isPolicyUnderDifferentName === 'yes' ? true : false
        )
        setInsuranceNameNotListed(primaryInsurance?.patientinfoData?.insuranceNameNotListed === true ? true : false)
        setSecondaryInsuranceNameNotListed(secondaryInsurance?.patientinfoData?.secondaryInsuranceNameNotListed === true ? true : false)
        if (secondaryInsurance?.patientinfoData?.insuranceName !== undefined && secondaryInsurance?.patientinfoData?.insuranceName !== "") {
            setIsSecondaryInsurance(true);
        }

        if (woundInfo?.patientinfoData?.woundInfo?.maxWoundId) {
            setMaxWoundIdFromMount(woundInfo?.patientinfoData?.woundInfo?.maxWoundId);
            setMaxWoundRowIndex(woundInfo?.patientinfoData?.woundInfo?.maxWoundId);
        }

        let processedWoundData = woundInfo?.patientinfoData?.woundInfo?.woundData?.map((woundData: WoundInfo, i: number) => {
            const totalSize = parseFloat(woundData.totalSize as unknown as string);
            const totalSizeFormatted = isNaN(totalSize) ? '0.00' : totalSize.toFixed(2);
            const cptFormatted = Array.isArray(woundData.cpt) ? woundData.cpt.join(', ') : woundData.cpt;
            const lengthValue = parseFloat(woundData.length as unknown as string);
            const widthValue = parseFloat(woundData.width as unknown as string);
            const depthValue = parseFloat(woundData.depth as unknown as string);
            const estimateSurfaceArea = (!isNaN(lengthValue) && !isNaN(widthValue))
                ? (lengthValue * widthValue).toFixed(2)
                : '0.00';
            const totalWoundVolume = (!isNaN(lengthValue) && !isNaN(widthValue) && !isNaN(depthValue))
                ? (lengthValue * widthValue * depthValue).toFixed(2)
                : '0.00';
            const woundInfoKey =  woundData.woundInfoKey ? woundData.woundInfoKey : generateUniqueId(maxWoundRowIndex > 0 ? maxWoundRowIndex + 1 : i)
            return {
                woundType: woundData.woundType,
                procedureLocation: woundData.procedureLocation,
                cpt: cptFormatted,
                cptIds: woundData.cptIds,
                lCode: woundData.lCode || '',
                lCodeIds: woundData.lCodeIds,
                icd10: woundData.icd10,
                icdIds: woundData.icdIds,
                eCode: woundData.eCode || '',
                eCodeIds: woundData.eCodeIds,
                iCode: woundData.iCode || '',
                iCodeIds: woundData.iCodeIds,
                otherDxCodes: woundData.woundType === WOUND_TYPES.SURGICAL_INCISION ? woundData.icd10 : woundData.otherDxCodes,
                noOfApplications: woundData.noOfApplications,
                length: woundData.length,
                width: woundData.width,
                depth: woundData.depth,
                totalSize: totalSizeFormatted,
                displayWoundDimensions: `${woundData.length}cm X ${woundData.width}cm X ${woundData.depth}cm`,
                displayEstimateSurfaceArea: `${estimateSurfaceArea}cm²`,
                displayTotalWoundVolume: `${totalWoundVolume}cm³`,
                woundInfoKey: woundInfoKey,
                incisionMeasurement: woundData.incisionMeasurement,
                surgicalIncision: woundData.surgicalIncision,
                exudateDrainage: woundData.exudateDrainage,
                odor: woundData.odor,
                periIncisionErythema: woundData.periIncisionErythema,
                periIncisionSkin: woundData.periIncisionSkin,
                dateOfSurgery: woundData.dateOfSurgery,
                periIncisionTemperature: woundData.periIncisionTemperature,
                edema: woundData.edema,
                exudate: woundData.exudate,
                drainage: woundData.drainage,
                erythema: woundData.erythema,
                skin: woundData.skin,
                temperature: woundData.temperature,
                cellulitis: woundData.cellulitis,
                debrided: woundData.debrided,
                eschar: woundData.eschar,
                undermining: woundData.undermining,
                tunneling: woundData.tunneling,
                woundStage: woundData.woundStage,
                pain: woundData.pain,
                severity: woundData.severity,
                woundKeyDisplayValue: formatWoundName(woundData.woundType, woundInfoKey)
            };
        });
        setWoundInfoRows(processedWoundData || []);
        setPrevProviderTemplateId(patientInfoObject?.providerTemplateId);
        setPrevProviderId(patientInfoObject?.providerId);
        let patientData = {
            practiceId: patientInfoObject?.practiceId,
            dateOfSurgery: patientInfoObject?.dateOfSurgery,
            providerId: patientInfoObject?.providerId,
            providerTemplateId: patientInfoObject?.providerTemplateId, //CS-1244
            patientInfo: {
                patientId: patientInfoObject?.patientId,
                FirstName: patientInfoObject?.firstName,
                MiddleName: patientInfoObject?.middleName,
                LastName: patientInfoObject?.lastName,
                patientDOB: patientInfoObject?.birthDate,
                gender: patientInfoObject?.gender,
                StreetAddress: address?.patientinfoData?.patientStreetAddress,
                UnitNumber: address?.patientinfoData?.patientUnitNumber,
                City: address?.patientinfoData?.patientCity,
                State: address?.patientinfoData?.patientState,
                Zipcode: address?.patientinfoData?.patientZip,
                faceSheet: faceSheet?.patientinfoData?.documentIds,
                isFaceSheetSkipped: faceSheet?.patientinfoData.isSkipped,
                patientEmail: emailInfo?.patientinfoData?.patientEmail
            },
            insuranceInfo: {
                insuranceName: primaryInsurance?.patientinfoData?.insuranceCategory === "Commercial" && primaryInsurance?.patientinfoData?.primaryCommercialInsuranceName ? "Other" : primaryInsurance?.patientinfoData?.insuranceName,
                insuranceCategory: primaryInsurance?.patientinfoData?.insuranceCategory,
                insuranceNameNotListed: primaryInsurance?.patientinfoData?.insuranceNameNotListed,
                primaryCommercialInsuranceName: primaryInsurance?.patientinfoData?.primaryCommercialInsuranceName,
                insurancePayerCode:primaryInsurance?.patientinfoData?.insuranceCategory === "Commercial" && primaryInsurance?.patientinfoData?.primaryCommercialInsuranceName ?"0": primaryInsurance?.patientinfoData?.insurancePayerCode,
                policy: primaryInsurance?.patientinfoData?.policy,
                isPolicyUnderDifferentName: primaryInsurance?.patientinfoData?.isPolicyUnderDifferentName || (!patientEditDetails?.isPatientEdit ? "no" : undefined),
                policyholderFirstName: primaryInsurance?.patientinfoData?.policyHolderFirstName,
                policyholderMiddleName: primaryInsurance?.patientinfoData?.policyHolderMiddleName,
                policyholderLastName: primaryInsurance?.patientinfoData?.policyHolderLastName,
                policyHolderDOB: primaryInsurance?.patientinfoData?.policyHolderDOB,
                // insuranceType: primaryInsurance?.patientinfoData?.patientStreetAddress,
                insuranceCards: primaryInsurance?.patientinfoData?.documentIds,
                isInsuranceCardsSkipped: primaryInsurance?.patientinfoData?.isSkipped,


                isSecondaryInsurance: secondaryInsurance?.patientinfoData?.insuranceName !== undefined
                    && secondaryInsurance?.patientinfoData?.insuranceName !== "" ? true : false,
                secondaryInsuranceName: secondaryInsurance?.patientinfoData?.insuranceCategory === "Commercial" && secondaryInsurance?.patientinfoData?.secondaryCommercialInsuranceName ? "Other" : secondaryInsurance?.patientinfoData?.insuranceName,
                secondaryCommercialInsuranceName: secondaryInsurance?.patientinfoData?.secondaryCommercialInsuranceName,
                secondaryInsuranceCategory: secondaryInsurance?.patientinfoData?.insuranceCategory,
                secondaryInsurancePayerCode: secondaryInsurance?.patientinfoData?.insuranceCategory === "Commercial" && secondaryInsurance?.patientinfoData?.secondaryCommercialInsuranceName ?"0":secondaryInsurance?.patientinfoData?.insurancePayerCode,
                secondaryPolicy: secondaryInsurance?.patientinfoData?.policy,
                isSecondaryPolicyUnderDifferentName: secondaryInsurance?.patientinfoData?.isPolicyUnderDifferentName,
                secondarypolicyholderFirstName: secondaryInsurance?.patientinfoData?.policyHolderFirstName,
                secondarypolicyholderMiddleName: secondaryInsurance?.patientinfoData?.policyHolderMiddleName,
                secondarypolicyholderLastName: secondaryInsurance?.patientinfoData?.policyHolderLastName,
                secondaryPolicyHolderDOB: secondaryInsurance?.patientinfoData?.policyHolderDOB,
                // secondaryInsuranceType: primaryInsurance?.patientinfoData?.patientStreetAddress,
                secondaryInsuranceCards: secondaryInsurance?.patientinfoData?.documentIds,
                isSecondaryInsuranceCardsSkipped: secondaryInsurance?.patientinfoData?.isSkipped,
            },
            supportingDocumentation: {
                supportingDocuments: supportingDocs?.patientinfoData?.documentIds,
                isSupportingDocumentsSkipped: supportingDocs?.patientinfoData?.isSkipped,
                imageOfWounds: imageOfWounds?.patientinfoData?.documentIds,
                isImageOfWoundsSkipped: imageOfWounds?.patientinfoData?.isSkipped,
            },
            woundInfo: {
                woundData: processedWoundData,
                totalSizeOfAllWounds: woundInfo?.totalSizeOfAllWounds,
            }
        };
        patientData = applyExtractedFacesheetToPatientData(patientData);
        reset(patientData);
        setPatientCompleteData(patientData);
        checkPatientInfoValidity(getValues(), true);
        checkInsuranceInfoValidity(getValues(), true);
        checkSupportingDocumentationValidity(getValues(), true);
        checkWoundInfoValidity(getValues(), true);

        // CS-1758 - Populate the facesheet insurance cache from saved patient data during edit
        // so that re-selecting the same category restores the original values (facesheet source only)
        if (createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET && patientData.insuranceInfo) {
            const pi = patientData.insuranceInfo;
            if (pi.insuranceCategory) {
                facesheetPrimaryInsuranceCacheRef.current[pi.insuranceCategory] = {
                    insuranceName: pi.insuranceName || "",
                    insurancePayerCode: pi.insurancePayerCode || "",
                    primaryCommercialInsuranceName: pi.primaryCommercialInsuranceName || "",
                    insuranceNameNotListed: pi.insuranceNameNotListed || false,
                    policy: pi.policy || "",
                    isPolicyUnderDifferentName: pi.isPolicyUnderDifferentName === true || pi.isPolicyUnderDifferentName === "yes",
                    subscriberName: [pi.policyholderFirstName, pi.policyholderMiddleName, pi.policyholderLastName].filter(Boolean).join(" "),
                };
            }
            if (pi.secondaryInsuranceCategory) {
                facesheetSecondaryInsuranceCacheRef.current[pi.secondaryInsuranceCategory] = {
                    secondaryInsuranceName: pi.secondaryInsuranceName || "",
                    secondaryInsurancePayerCode: pi.secondaryInsurancePayerCode || "",
                    secondaryCommercialInsuranceName: pi.secondaryCommercialInsuranceName || "",
                    secondaryInsuranceNameNotListed: secondaryInsurance?.patientinfoData?.secondaryInsuranceNameNotListed || false,
                    secondaryPolicy: pi.secondaryPolicy || "",
                    isSecondaryPolicyUnderDifferentName: pi.isSecondaryPolicyUnderDifferentName === true || pi.isSecondaryPolicyUnderDifferentName === "yes",
                    subscriberName: [pi.secondarypolicyholderFirstName, pi.secondarypolicyholderMiddleName, pi.secondarypolicyholderLastName].filter(Boolean).join(" "),
                };
            }
        }

        if (extractedFacesheetDocumentId && extractedFacesheetFile) {
            const extFile = Object.assign(extractedFacesheetFile, { documentId: String(extractedFacesheetDocumentId) }) as ExtendedFile;
            setUploadedFacesheetFilesMetaData([extFile]);
            // CS-1758 - Read subscriber_name from insurances array instead of flat field
            // setIsPolicyUnderDifferentNameCheck(
            //     !!(extractedFacesheetData?.facesheet || extractedFacesheetData)?.subscriber_name
            // );
            const facesheetObj = extractedFacesheetData?.facesheet || extractedFacesheetData;
            const primaryIns = Array.isArray(facesheetObj?.insurances) ? facesheetObj.insurances.find((ins: any) => ins.type === "Primary") || facesheetObj.insurances[0] : null;
            setIsPolicyUnderDifferentNameCheck(!!primaryIns?.subscriber_name);
            // CS-1758 - Only set insuranceNameNotListed when payer code is "0" (plan not in system)
            if (primaryIns?.primaryCommercialInsuranceName && primaryIns?.insurancePayerCode === "0") {
                setInsuranceNameNotListed(true);
            }
            // CS-1758 - Set secondary insurance checkbox if secondary insurance exists in facesheet
            const secondaryIns = Array.isArray(facesheetObj?.insurances) ? facesheetObj.insurances.find((ins: any) => ins.type === "Secondary") : null;
            if (secondaryIns) {
                setIsSecondaryInsurance(true);
                setIsPolicyUnderDifferentNameCheckSecondary(!!secondaryIns.subscriber_name);
                // CS-1758 - Only set secondaryInsuranceNameNotListed when payer code is "0" (plan not in system)
                // CS-1758 - API uses secondaryInsurancePayerCode for secondary insurance
                const secPayerCode = secondaryIns.secondaryInsurancePayerCode ?? secondaryIns.insurancePayerCode;
                if (secondaryIns.secondaryCommercialInsuranceName && secPayerCode === "0") {
                    setSecondaryInsuranceNameNotListed(true);
                }
            }
        }

    }, [applyExtractedFacesheetToPatientData, extractedFacesheetData, extractedFacesheetDocumentId, extractedFacesheetFile, patientInfoObject?.patientInfo])

    useEffect(() => {
        defaultValues();
    }, [patientInfoObject?.patientInfo])

    // CS-1594 - Separate effect to call API only once when patientId is available
    useEffect(() => {
        const fetchAuditData = async () => {
            if(patientInfoObject?.patientId && !auditApiCalledRef.current){
                const response = await dispatch(getPatientAiAuditDataByPatientId(patientInfoObject?.patientId));
                auditApiCalledRef.current = true;
                
                // CS-1594 - Process response and populate audit data map
                if (response.meta.requestStatus === "fulfilled" && response.payload?.data) {
                    const auditResults = response.payload.data;
                    console.log("CS-1594: Audit results from API", auditResults);
                    const newAuditMap = new Map<string, any>();
                    
                    // Response format: array of audit objects with documentId
                    if (Array.isArray(auditResults)) {
                        auditResults.forEach((auditItem: any) => {
                            if (auditItem.documentId) {
                                // Store the complete audit object
                                newAuditMap.set(String(auditItem.documentId), auditItem);
                            }
                        });
                    }
                    
                    setAuditDataByDocument(newAuditMap);
                    console.log("CS-1594: Loaded audit data for", newAuditMap.size, "documents");
                }
            }
        };
        
        fetchAuditData();
    }, [patientInfoObject?.patientId, dispatch]);

    // CS-1594 - Reset the ref when component unmounts or patientId changes to null
    useEffect(() => {
        return () => {
            auditApiCalledRef.current = false;
        };
    }, []);

   
    // CS-1773 - Run Medical Note Audit AI Tool in Background
    const isCreateFlowRef = useRef<boolean>(
        !location?.state?.patientDetails?.isPatientEdit,
    );
    isCreateFlowRef.current = !location?.state?.patientDetails?.isPatientEdit;

    useEffect(() => {
        return () => {
            if (formCommittedRef.current) return;
            if (!isCreateFlowRef.current) return;
            const jobs = auditJobsRef.current;
            if (!jobs) return;
            Object.entries(jobs).forEach(([docId, job]) => {
                if (!job?.fileMetadata) return;
                if (job.fileMetadata.docType !== "medical notes") return;
                if (
                    job.fileMetadata.patientIdAtStart !== null &&
                    job.fileMetadata.patientIdAtStart !== undefined
                ) {
                    return;
                }
                if (job.status !== "uploading" && job.status !== "processing") {
                    return;
                }
                dispatch(clearAuditJob(docId));
            });
        };
    }, [dispatch]);

    // CS-1773 - Run Medical Note Audit AI Tool in Background
    const allAuditJobs = useSelector(
        (state: RootState) => state.aiAuditSlice.auditJobs,
    );
    const auditJobsRef = useRef(allAuditJobs);
    auditJobsRef.current = allAuditJobs;
    const orphanRestoredDocIdsRef = useRef<Set<string>>(new Set());
    useEffect(() => {
        if (!hasSubscribedAccessToMedicalAudit) return;

        const aliveJobIds = new Set(Object.keys(allAuditJobs));
        orphanRestoredDocIdsRef.current.forEach((id) => {
            if (!aliveJobIds.has(id)) {
                orphanRestoredDocIdsRef.current.delete(id);
            }
        });

        const currentPatientId = patientInfoObject?.patientId ?? null;
        const currentPatientIdStr =
            currentPatientId !== null && currentPatientId !== undefined
                ? String(currentPatientId)
                : null;

        const existingDocs =
            (getValues("supportingDocumentation.supportingDocuments") as number[] | undefined) || [];
        const existingDocIdSet = new Set(existingDocs.map((d) => String(d)));
        const existingMetaSet = new Set(
            uploadedSupportingDocumentFilesMetaData.map((f) => String(f.documentId)),
        );

        const filesToAddToMeta: ExtendedFile[] = [];
        const docIdsToAddToForm: number[] = [];

        Object.entries(allAuditJobs).forEach(([docId, job]: [string, AuditJob]) => {
            if (!job.fileMetadata) return;
            if (job.fileMetadata.docType !== "medical notes") return;

            const auditPatientId = job.fileMetadata.patientIdAtStart;
            const auditPatientIdStr =
                auditPatientId !== null && auditPatientId !== undefined
                    ? String(auditPatientId)
                    : null;
            if (currentPatientIdStr !== auditPatientIdStr) return;

            const inForm = existingDocIdSet.has(docId);
            const inMeta = existingMetaSet.has(docId);
            // Already represented in BOTH places → nothing to do
            if (inForm && inMeta) return;

            const wasOrphanRestored = orphanRestoredDocIdsRef.current.has(docId);

            if (inForm && !inMeta && !wasOrphanRestored) return;

            if (!inMeta) {
                filesToAddToMeta.push({
                    name: job.fileMetadata.fileName,
                    size: 0,
                    type: job.fileMetadata.fileType,
                    documentId: docId,
                } as unknown as ExtendedFile);
                orphanRestoredDocIdsRef.current.add(docId);
            }
            if (!inForm) {
                docIdsToAddToForm.push(Number(docId));
                orphanRestoredDocIdsRef.current.add(docId);
            }
        });

        if (filesToAddToMeta.length > 0) {
            setUploadedSupportingDocumentFilesMetaData((prev) => {
                const have = new Set(prev.map((f) => String(f.documentId)));
                const merged = [...prev];
                filesToAddToMeta.forEach((f) => {
                    if (!have.has(String(f.documentId))) merged.push(f);
                });
                return merged;
            });
        }
        if (docIdsToAddToForm.length > 0) {
            setValue(
                "supportingDocumentation.supportingDocuments",
                [...existingDocs, ...docIdsToAddToForm],
            );
        }
    }, [
        patientInfoObject?.patientId,
        patientInfoObject?.patientInfo,
        allAuditJobs,
        uploadedSupportingDocumentFilesMetaData,
        hasSubscribedAccessToMedicalAudit,
    ]);

    // CS-1594 - Handler for when audit completes
    const handleAuditComplete = (documentId: string, auditData: any) => {
        console.log("CS-1594: Audit completed for document", documentId);
        setAuditDataByDocument(prev => {
            const newMap = new Map(prev);
            // Store the complete audit response object
            newMap.set(documentId, auditData);
            return newMap;
        });
    };

    const handleOpenFacesheetReport = async (facesheetAuditData: any, documentId: number | null) => {
        const auditId = facesheetAuditData?.auditId || facesheetAuditData?.audit_id;

        if (!auditId) {
            dispatch(setSingleAlertObj({
                message: "Facesheet report is not available for this document.",
                alertType: "error",
            }));
            return;
        }

        try {
            const response = await dispatch(getRecentAiAuditDetailsByIdData(auditId));

            if (response.meta.requestStatus === "fulfilled") {
                setSelectedFacesheetReportData(response.payload?.data?.responseJson || response.payload?.data);
                setSelectedFacesheetReportDocumentId(documentId);
                setShowFacesheetExtractionPopup(true);
            } else {
                dispatch(setSingleAlertObj({
                    message: "Failed to load facesheet report. Please try again.",
                    alertType: "error",
                }));
            }
        } catch (error) {
            dispatch(setSingleAlertObj({
                message: "Error loading facesheet report. Please try again.",
                alertType: "error",
            }));
        }
    };

    useEffect(() => {
        if(location?.state?.patientDetails?.pverifyPopup){
            scrollToElement(insuranceInformationRef)
        }
    },[location?.state?.patientDetails?.pverifyPopup])
    //mount
    useEffect(() => {
        dispatch(updatePatientObjectReducer(null));

        if (!patientEditDetails?.isPatientEdit) {
            dispatch(resetPatientInfoObject());
        }

        clearFormData();

        const patientDetails = location.state?.patientDetails;

        if (patientDetails) {
            setPatientEditData(patientDetails);
            setPatientEditDetails(patientDetails);
            setPatientObjDetails(patientDetails);
        }

        fetchInitialLists();
        dispatch(fetchAllPayers());

    }, [location.state]);

    //CS-1244 - Start
    useEffect(() => {
        const patientData = patientObjDetails?.patientData;
        // CS-1244 - Start
        if (patientData?.practiceId !== null && patientData?.patientAddedFromEmrPopup === true) {
            setValue("practiceId", patientData.practiceId);
            setValue("patientInfo.FirstName", patientData.firstName);
            setValue("patientInfo.MiddleName", patientData.middleName);
            setValue("patientInfo.LastName", patientData.lastName);
            setValue("patientInfo.patientDOB", patientData.dateOfBirth);
            setValue("providerId", patientData.providerId);
            setPrevProviderId(patientData.providerId);
            setValue("dateOfSurgery", patientData.dateOfSurgery);
        }
        //CS-1244 -End
    }, [patientObjDetails])

    useEffect(()=>{
        if(patientObjDetails?.patientData?.providerTemplateId && patientObjDetails?.patientData?.providerId){
        dispatch(getSurgicalTemplateBasedOnProvider(patientObjDetails?.patientData?.providerId));
        setValue("providerTemplateId",patientObjDetails?.patientData?.providerTemplateId);
        setPrevProviderTemplateId(patientObjDetails?.patientData?.providerTemplateId);
        };
        fetchProviderData(getValues('providerId'));
        if(!location?.state?.patientDetails?.isPatientEdit) {
            fetchProviderTemplateData(getValues('providerTemplateId'), true);
        }
    },[patientObjDetails?.patientData]);

    // CS-1758 - Auto-fill form from facesheet extraction data
    useEffect(() => {
        if (!extractedFacesheetData) return;

        const facesheet = extractedFacesheetData?.facesheet || extractedFacesheetData;

        // Auto-fill patient demographics
        if (facesheet.first_name) setValue("patientInfo.FirstName", facesheet.first_name);
        if (facesheet.middle_name) setValue("patientInfo.MiddleName", facesheet.middle_name);
        if (facesheet.last_name) setValue("patientInfo.LastName", facesheet.last_name);
        if (facesheet.dob) setValue("patientInfo.patientDOB", facesheet.dob);
        if (facesheet.sex) setValue("patientInfo.gender", facesheet.sex);
        if (facesheet.email) setValue("patientInfo.patientEmail", facesheet.email);

        // Auto-fill address
        if (facesheet.street_address) setValue("patientInfo.StreetAddress", facesheet.street_address);
        if (facesheet.unit_number) setValue("patientInfo.UnitNumber", facesheet.unit_number);
        if (facesheet.city) setValue("patientInfo.City", facesheet.city);
        if (facesheet.state) setValue("patientInfo.State", facesheet.state);
        if (facesheet.zip_code) setValue("patientInfo.Zipcode", facesheet.zip_code);

        // CS-1758 - Auto-fill primary insurance from insurances array instead of flat fields
        // if (facesheet.insurance_name) setValue("insuranceInfo.insuranceName", facesheet.insurance_name);
        // if (facesheet.insurance_category) setValue("insuranceInfo.insuranceCategory", facesheet.insurance_category);
        // if (facesheet.policy_number) setValue("insuranceInfo.policy", facesheet.policy_number.toUpperCase());
        // if (facesheet.subscriber_name) {
        //     setValue("insuranceInfo.isPolicyUnderDifferentName", true);
        //     setIsPolicyUnderDifferentNameCheck(true);
        //     const nameParts = (facesheet.subscriber_name || "").trim().split(/\s+/).filter(Boolean);
        //     if (nameParts.length >= 1) setValue("insuranceInfo.policyholderFirstName", nameParts[0]);
        //     if (nameParts.length === 2) setValue("insuranceInfo.policyholderLastName", nameParts[1]);
        //     if (nameParts.length >= 3) {
        //         setValue("insuranceInfo.policyholderMiddleName", nameParts.slice(1, -1).join(" "));
        //         setValue("insuranceInfo.policyholderLastName", nameParts[nameParts.length - 1]);
        //     }
        // }
        const primaryInsuranceExtracted = Array.isArray(facesheet.insurances) ? facesheet.insurances.find((ins: any) => ins.type === "Primary") || facesheet.insurances[0] : null;
        const secondaryInsuranceExtracted = Array.isArray(facesheet.insurances) ? facesheet.insurances.find((ins: any) => ins.type === "Secondary") : null;

        // CS-1758 - Only fall back to "Other" commercial plan when payer code is "0" (plan not in system);
        // when a real payer code is provided, use the plan name directly
        if (primaryInsuranceExtracted?.primaryCommercialInsuranceName && primaryInsuranceExtracted?.insurancePayerCode === "0") {
            setValue("insuranceInfo.insuranceName", "Other");
            setValue("insuranceInfo.primaryCommercialInsuranceName", primaryInsuranceExtracted.primaryCommercialInsuranceName);
            setValue("insuranceInfo.insuranceNameNotListed", true);
            setInsuranceNameNotListed(true);
        } else if (primaryInsuranceExtracted?.name) {
            setValue("insuranceInfo.insuranceName", primaryInsuranceExtracted.name);
        }
        if (primaryInsuranceExtracted?.category) setValue("insuranceInfo.insuranceCategory", primaryInsuranceExtracted.category);
        // CS-1758 - Map insurancePayerCode from facesheet insurances array
        if (primaryInsuranceExtracted?.insurancePayerCode != null) setValue("insuranceInfo.insurancePayerCode", primaryInsuranceExtracted.insurancePayerCode);
        if (primaryInsuranceExtracted?.policy_number) setValue("insuranceInfo.policy", primaryInsuranceExtracted.policy_number.toUpperCase());
        if (primaryInsuranceExtracted?.subscriber_name) {
            setValue("insuranceInfo.isPolicyUnderDifferentName", true);
            setIsPolicyUnderDifferentNameCheck(true);
            const nameParts = (primaryInsuranceExtracted.subscriber_name || "").trim().split(/\s+/).filter(Boolean);
            if (nameParts.length >= 1) setValue("insuranceInfo.policyholderFirstName", nameParts[0]);
            if (nameParts.length === 2) setValue("insuranceInfo.policyholderLastName", nameParts[1]);
            if (nameParts.length >= 3) {
                setValue("insuranceInfo.policyholderMiddleName", nameParts.slice(1, -1).join(" "));
                setValue("insuranceInfo.policyholderLastName", nameParts[nameParts.length - 1]);
            }
        }

        // CS-1758 - Cache primary insurance data by category so re-selecting the same
        // category after a change restores the original AI-extracted values
        if (primaryInsuranceExtracted?.category) {
            facesheetPrimaryInsuranceCacheRef.current[primaryInsuranceExtracted.category] = {
                insuranceName: (primaryInsuranceExtracted.primaryCommercialInsuranceName && primaryInsuranceExtracted.insurancePayerCode === "0")
                    ? "Other" : (primaryInsuranceExtracted.name || ""),
                insurancePayerCode: primaryInsuranceExtracted.insurancePayerCode || "",
                primaryCommercialInsuranceName: (primaryInsuranceExtracted.primaryCommercialInsuranceName && primaryInsuranceExtracted.insurancePayerCode === "0")
                    ? primaryInsuranceExtracted.primaryCommercialInsuranceName : "",
                insuranceNameNotListed: !!(primaryInsuranceExtracted.primaryCommercialInsuranceName && primaryInsuranceExtracted.insurancePayerCode === "0"),
                policy: primaryInsuranceExtracted.policy_number?.toUpperCase() || "",
                isPolicyUnderDifferentName: !!primaryInsuranceExtracted.subscriber_name,
                subscriberName: primaryInsuranceExtracted.subscriber_name || "",
            };
        }

        // CS-1758 - Auto-fill secondary insurance from insurances array
        if (secondaryInsuranceExtracted) {
            setIsSecondaryInsurance(true);
            setValue("insuranceInfo.isSecondaryInsurance", true);
            // CS-1758 - API uses secondaryInsurancePayerCode for secondary insurance
            const secondaryPayerCode = secondaryInsuranceExtracted.secondaryInsurancePayerCode ?? secondaryInsuranceExtracted.insurancePayerCode;
            // CS-1758 - Only fall back to "Other" when payer code is "0" (plan not in system)
            if (secondaryInsuranceExtracted.secondaryCommercialInsuranceName && secondaryPayerCode === "0") {
                setValue("insuranceInfo.secondaryInsuranceName", "Other");
                setValue("insuranceInfo.secondaryCommercialInsuranceName", secondaryInsuranceExtracted.secondaryCommercialInsuranceName);
                setValue("insuranceInfo.secondaryInsuranceNameNotListed", true);
                setSecondaryInsuranceNameNotListed(true);
            } else if (secondaryInsuranceExtracted.name) {
                setValue("insuranceInfo.secondaryInsuranceName", secondaryInsuranceExtracted.name);
            }
            if (secondaryInsuranceExtracted.category) setValue("insuranceInfo.secondaryInsuranceCategory", secondaryInsuranceExtracted.category);
            if (secondaryPayerCode != null) setValue("insuranceInfo.secondaryInsurancePayerCode", secondaryPayerCode);
            if (secondaryInsuranceExtracted.policy_number) setValue("insuranceInfo.secondaryPolicy", secondaryInsuranceExtracted.policy_number.toUpperCase());
            if (secondaryInsuranceExtracted.subscriber_name) {
                setValue("insuranceInfo.isSecondaryPolicyUnderDifferentName", true);
                setIsPolicyUnderDifferentNameCheckSecondary(true);
                const secNameParts = (secondaryInsuranceExtracted.subscriber_name || "").trim().split(/\s+/).filter(Boolean);
                if (secNameParts.length >= 1) setValue("insuranceInfo.secondarypolicyholderFirstName", secNameParts[0]);
                if (secNameParts.length === 2) setValue("insuranceInfo.secondarypolicyholderLastName", secNameParts[1]);
                if (secNameParts.length >= 3) {
                    setValue("insuranceInfo.secondarypolicyholderMiddleName", secNameParts.slice(1, -1).join(" "));
                    setValue("insuranceInfo.secondarypolicyholderLastName", secNameParts[secNameParts.length - 1]);
                }
            }

            // CS-1758 - Cache secondary insurance data by category so re-selecting the same
            // category after a change restores the original AI-extracted values
            if (secondaryInsuranceExtracted.category) {
                facesheetSecondaryInsuranceCacheRef.current[secondaryInsuranceExtracted.category] = {
                    secondaryInsuranceName: (secondaryInsuranceExtracted.secondaryCommercialInsuranceName && secondaryPayerCode === "0")
                        ? "Other" : (secondaryInsuranceExtracted.name || ""),
                    secondaryInsurancePayerCode: secondaryPayerCode || "",
                    secondaryCommercialInsuranceName: (secondaryInsuranceExtracted.secondaryCommercialInsuranceName && secondaryPayerCode === "0")
                        ? secondaryInsuranceExtracted.secondaryCommercialInsuranceName : "",
                    secondaryInsuranceNameNotListed: !!(secondaryInsuranceExtracted.secondaryCommercialInsuranceName && secondaryPayerCode === "0"),
                    secondaryPolicy: secondaryInsuranceExtracted.policy_number?.toUpperCase() || "",
                    isSecondaryPolicyUnderDifferentName: !!secondaryInsuranceExtracted.subscriber_name,
                    subscriberName: secondaryInsuranceExtracted.subscriber_name || "",
                };
            }
        }

        if (extractedFacesheetDocumentId && extractedFacesheetFile) {
            setValue("patientInfo.faceSheet", [extractedFacesheetDocumentId]);
            setValue("patientInfo.isFaceSheetSkipped", false);
            const extFile = Object.assign(extractedFacesheetFile, { documentId: String(extractedFacesheetDocumentId) }) as ExtendedFile;
            setUploadedFacesheetFilesMetaData([extFile]);
        }
    }, [extractedFacesheetData, extractedFacesheetDocumentId, extractedFacesheetFile, setValue]);

    // CS-1758 - Trigger required-field validation automatically after facesheet auto-fill
    useEffect(() => {
        if (!extractedFacesheetData) return;
        if (createPatientFlowSource !== CREATE_PATIENT_FLOW_SOURCE.FACESHEET) return;
        if (hasTriggeredFacesheetValidationRef.current) return;

        hasTriggeredFacesheetValidationRef.current = true;
        setShowFacesheetValidation(true);

        // CS-1758 - Removed setTimeout trigger here; validation is now triggered
        // by a dedicated useEffect that fires after showFacesheetValidation state is committed
        // setTimeout(() => {
        //     void trigger(undefined, { shouldFocus: false });
        // }, 0);
    }, [createPatientFlowSource, extractedFacesheetData, trigger]);

    // CS-1758 - Trigger full-form validation once showFacesheetValidation is committed to state.
    useEffect(() => {
        if (showFacesheetValidation && practiceByUserRoleOrderSlice && practiceByUserRoleOrderSlice.length > 0) {
            void trigger(undefined, { shouldFocus: false });
        }
    }, [showFacesheetValidation, practiceByUserRoleOrderSlice, trigger]);
    // CS-1758 - End

    useEffect(() => {
        if (!showFacesheetValidation) {
            return;
        }

        // CS-1758 - Revalidate only the field the user changes so existing required errors clear generically across the form
        const subscription = watch((_value, { name, type }) => {
            if (!name || type !== "change") {
                return;
            }

            void trigger(name as any, { shouldFocus: false });
        });

        return () => subscription.unsubscribe();
    }, [showFacesheetValidation, trigger, watch]);

    const fetchProviderData = (providerId: number | null) => {
        if (providerId) {
            dispatch(getSurgicalTemplateBasedOnProvider(String(providerId)));
        };
    };

    const fetchProviderTemplateData = (providerTemplateId: number | null | undefined, initialLoad?: boolean) => {
        if (providerTemplateId != null) {
            fetchSurgicalTemplate(providerTemplateId, initialLoad);
        };
    };

    const fetchSurgicalTemplate = async (providerTemplateId: number, initialLoad?: boolean) => {
        const response = await dispatch(getSurgicalTemplateByTemplateId(providerTemplateId));
        const surgicalTemplateData = response.payload;
        const incisionObj = setIncisionRowsFromIncisionArray(surgicalTemplateData);
        setIsWoundInfoEdited(true);
        setWoundInfoRows(incisionObj);
        setIsAddIncisionButtonDisabled(true);
        checkWoundInfoValidity(getValues());
    }

    const setIncisionRowsFromIncisionArray = (surgicalTemplate: SurgicalTemplate | null) => {
        let incisionObj: any[] = [];
        if (surgicalTemplate && surgicalTemplate.templateJson?.incisionArray.length > 0) {
            surgicalTemplate.templateJson.incisionArray.map((option: any, index: number) => {
                const woundInfoKey = option.incisionId || generateUniqueId(index + 1);
                const length = parseFloat(option.length);
                const width = parseFloat(option.width);
                const depth = parseFloat(option.depth);
                const totalSize = (length * width).toFixed(2);
                const estimateSurfaceArea = (!isNaN(length) && !isNaN(width)) ? (length * width).toFixed(2) : '0.00';
                const totalWoundVolume = (!isNaN(length) && !isNaN(width) && !isNaN(depth))
                    ? (length * width * depth).toFixed(2)
                    : '0.00';
                incisionObj.push({
                    woundType: "Surgical Incision",
                    otherDxCodes: option.icd10Code || option.dx,
                    icd10: option.icd10Code || option.dx,
                    woundInfoKey: woundInfoKey,
                    woundKeyDisplayValue: formatWoundName("Surgical Incision", woundInfoKey),
                    displayWoundDimensions: `${option.length}cm X ${option.width}cm X ${option.depth}cm`,
                    displayEstimateSurfaceArea: `${estimateSurfaceArea}cm²`,
                    displayTotalWoundVolume: `${totalWoundVolume}cm³`,
                    procedureLocation: surgicalTemplate.templateJson?.location,
                    length: length,
                    width: width,
                    depth: depth,
                    totalSize: totalSize
                })
            });
        }
        return incisionObj;
    };

    const surgicalTemplateOptionData = useMemo(() => {
        let options: Option[] = []
        if (surgicalTemplateOptions && surgicalTemplateOptions?.length > 0) {
            const activeSurgicalTemplateOptions = surgicalTemplateOptions?.filter((option: any) => option.inactiveDate === null);
            activeSurgicalTemplateOptions?.map((option: any) => {
                options.push({
                    label: option.procedureName,
                    value: option.templateId
                })
            })
            return options;
        }
    }, [surgicalTemplateOptions])

    // useEffect(() => {
    //     if (((!patientEditDetails?.isPatientEdit) || (patientEditDetails?.isPatientEdit && isProviderTemplateChanged)) 
    //             && surgicalTemplate && surgicalTemplate.templateJson?.incisionArray.length > 0) {
    //         let incisionObj: any[] = [];
    //         surgicalTemplate.templateJson.incisionArray.map((option: any, index: number) => {
    //             const woundInfoKey = option.incisionId || generateUniqueId(index + 1);
    //             const length = parseFloat(option.length);
    //             const width = parseFloat(option.width);
    //             const depth = parseFloat(option.depth);
    //             const totalSize = (length * width).toFixed(2);
    //             const totalSizeFormatted = `${totalSize}cm²`;
    //             const dimensions = `(${option.length} X ${option.width} X ${option.depth})`;
    //             const displayTotalSize = `${totalSizeFormatted}\u000A${dimensions}`;
    //             incisionObj.push({
    //                 woundType: "Surgical Incision",
    //                 otherDxCodes: option.icd10Code || option.dx,
    //                 icd10: option.icd10Code || option.dx,
    //                 woundInfoKey: woundInfoKey,
    //                 woundKeyDisplayValue: formatWoundName("Surgical Incision", woundInfoKey),
    //                 displayTotalSize: displayTotalSize,
    //                 procedureLocation: surgicalTemplate.templateJson?.location,
    //                 length: length,
    //                 width: width,
    //                 depth: depth,
    //                 totalSize: totalSize
    //             })
    //         });
    //         setIsWoundInfoEdited(true);
    //         setWoundInfoRows(incisionObj);
    //         if(patientEditDetails?.isPatientEdit) {
    //             !isProviderTemplateChanged && setPrevWoundInfoRows(incisionObj); 
    //         } else {
    //             if(prevWoundInfoRows?.length === 0) {
    //             setPrevWoundInfoRows(incisionObj)
    //             }
    //         }
    //         setIsAddIncisionButtonDisabled(true);
    //         checkWoundInfoValidity(getValues());
    //         dispatch(resetProviderTemplate());
    //     }
    // }, [surgicalTemplate, isProviderTemplateChanged])

        // handleProviderChange function will be only called  when any providerTemplateDropwown is available
    const handleProviderChange = (data: any) => {
        if (data?.value !== undefined && data?.value !== null) {
            dispatch(getSurgicalTemplateBasedOnProvider(data?.value));
            setPrevProviderId(data?.value);
        } else {
            setValue("providerId", null);
        };
        setShowOptionsPopup({ show: false, message: "" });
        setValue("providerTemplateId", null);
        setPrevProviderTemplateId(null);
        setWoundInfoRows([]);
    };
           
    const providerChangeConfirmation = (data: any) => {
        const woundType = woundInfoRows[0]?.woundType === 'Surgical Incision' ? 'incision' : 'wound';
        if (getValues("providerTemplateId") || woundInfoRows?.length > 0) {
            setShowOptionsPopup({
                show: true,
                variant: "error",
                message: (
                    <>
                        <strong>Changing Provider will erase all {woundType} data.</strong>
                    </>
                ),
                buttons: [
                    {
                        name: "OK",
                        color: "success",
                        onClick: () => {
                            setIsWoundInfoEdited(true);
                            handleProviderChange(data);
                        },
                    },
                    {
                        name: "Cancel",
                        color: "error",
                        onClick: () => {
                            setValue('providerId', prevProviderId);
                            setShowOptionsPopup({ show: false, message: "" });
                        },
                    },
                ],
            });
        } else {
            handleProviderChange(data);
        };
    }


    //CS-1244 - End
    //unmount
    useEffect(() => () => {
        dispatch(updatePatientObjectReducer(null));
        dispatch(updateElementInPatientSlice({
            elementName: "woundInfoHasIvrByPatient",
            value: []
        }));
        dispatch(resetProviderTemplate());
    }, []);
    const clearFormData = () => {
        setValue("patientInfo.faceSheet", []);
        setUploadedFacesheetFilesMetaData([]);
        setValue("insuranceInfo.insuranceCards", []);
        setUploadedPrimaryInsuranceFilesMetaData([]);
        setValue("insuranceInfo.secondaryInsuranceCards", []);

        setUploadedSecondaryInsuranceFilesMetaData([]);
        setValue("supportingDocumentation.imageOfWounds", []);
        setUploadedWoundImageFilesMetaData([]);
        setValue("supportingDocumentation.supportingDocuments", []);
        setUploadedSupportingDocumentFilesMetaData([]);
    }

    const setPatientEditData = async (patientDetails: { isPatientEdit: boolean, patientId: number }) => {
        if (patientDetails?.isPatientEdit && patientDetails?.patientId !== null) {
            const responseGetPatient = await dispatch(getPatient({ patientId: patientDetails.patientId.toString() }));
            const responseWoundInfoHasIvr = await dispatch(checkWoundInfoIvrHasIvr(patientDetails.patientId))
            setShowEditButton(true);
            setDisablePatientName(true);
        }
    }

    const fetchInitialLists = async () => {
        const responsePractices = await dispatch(
            getPracticeListByUserRoleOrderSlice(true)
        );
    };
     const insuranceCategory = useMemo(() => {
        let insuranceCategory: CodeTable[] = [];
        if (allCodeTablesValuesMap) {
            insuranceCategory = getCodeTableValuesByTableName(allCodeTablesValuesMap, "InsuranceCategory");
        }
        if (!insuranceCategory || insuranceCategory.length === 0) {
          dispatch(fetchAllCodeTablesValues());
        }
        let options: { label: string, value: any }[] = [];
        insuranceCategory?.map((option) => {
          options.push({ label: option.displayValue, value: option.keyName });
    
        });
        return options;
      }, [allCodeTablesValuesMap]);

      useEffect(() => {
        if (insuranceNameNotListed) {
            // CS-1758 - Facesheet-created patients (including re-opened edits) already have
            // the correct category, payerCode, and name saved; do not override them.
            if (createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET) {
                return;
            }
            setValue('insuranceInfo.insuranceCategory', "Commercial");
            setValue('insuranceInfo.insurancePayerCode', "0");
            setValue('insuranceInfo.insuranceName', "Other");
            //CS-1335 - Start
            trigger('insuranceInfo');
        }
      }, [insuranceNameNotListed, createPatientFlowSource, setValue, trigger])
      useEffect(() => {
        if (secondaryInsuranceNameNotListed) {
            // CS-1758 - Facesheet-created patients (including re-opened edits) already have
            // the correct category, payerCode, and name saved; do not override them.
            if (createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET) {
                return;
            }
            setValue('insuranceInfo.secondaryInsuranceCategory', "Commercial");
            setValue('insuranceInfo.secondaryInsurancePayerCode', "0");
            setValue('insuranceInfo.secondaryInsuranceName', "Other");
            trigger('insuranceInfo');
            //CS-1335 - End
        }
      }, [secondaryInsuranceNameNotListed, createPatientFlowSource, setValue, trigger])
    const savePatient = async (data: SavePatientRequest) => {
        const response = await dispatch(createPatient(data));
        if (response.payload?.code === SUCCESS_CODE) {
            formCommittedRef.current = true;
            let successObj: SingleAlertInfo = {
                message: `The patient's record was saved successfully.`,
                alertType: "success"
            };
            // dispatch(setSingleAlertObj(successObj));
            dispatch(updatePatientObjectReducer(null));
            if (data.patientDataRequest.patientId && data.patientDataRequest.patientId !== 0) {
                //CS-1297 - Start (Handle Create IVR for draft patient)
                if (submitAction === "saveAction") {
                    navigate("/patients");
                } else if(patientInfoObject?.status === PATIENT_STATUS.DRAFTED) {
                    navigate("/patientDetails", {
                        replace: true,
                        state: {
                            patientDetails: {
                                patientId: data.patientDataRequest.patientId,
                                patientName:
                                    data.patientDataRequest.firstName +
                                    " " +
                                    data.patientDataRequest.lastName,
                                dob: data.patientDataRequest.birthDate,
                                isAutoPverify: response.payload?.data.isAutoPverify
                            },
                            alert: {
                                message: "Patient details are received. Please proceed to create IVR.",
                                showButton: true,
                                buttonText: "CREATE IVR"
                            },
                            fromEdit: true
                        },
                    });
                }else{
                     navigate("/patientDetails", {
                        replace: true,
                        state: {
                            patientDetails: {
                                patientId: data.patientDataRequest.patientId,
                                patientName:
                                    data.patientDataRequest.firstName +
                                    " " +
                                    data.patientDataRequest.lastName,
                                dob: data.patientDataRequest.birthDate,
                                isAutoPverify: response.payload?.data.isAutoPverify
                            },
                            fromEdit: true
                        },
                    });
                }
                //CS-1297 - End
            } else {
                //CS-1148 - start
                // if (data?.patientDataRequest?.status === PATIENT_STATUS.ACTIVE) {
                //     navigate("/patients", { state: { openCreateIvrPopup: true, patientId: response?.payload?.data?.patientId, practiceId: data?.practiceId } });
                // } else {
                //     navigate("/patients");
                // }
                //CS-1148 - end
                if (submitAction === "saveAction") {
                    navigate("/patients");
                } else {
                    navigate("/patientDetails", {
                        replace: true,
                        state: {
                            patientDetails: {
                                patientId: response.payload?.data.patientId,
                                isAutoPverify: response.payload?.data.isAutoPverify,
                                patientName:
                                    response.payload?.data.firstName +
                                    " " +
                                    response.payload?.data.lastName,
                                dob: response.payload?.data.birthDate,
                            },
                            alert: {
                                message: "Patient details are received. Please proceed to create IVR.",
                                showButton: true,
                                buttonText: "CREATE IVR"
                            },
                            fromEdit: true
                        },
                    });
                    // let successObj: SingleAlertInfo = {
                    //     message: `Patient details are received. Please proceed to create IVR.`,
                    //     alertType: "success"
                    // };
                    // dispatch(setSingleAlertObj(successObj));
                }
            }
        }
        setShowOptionsPopup({ message: "", show: false });
    }

    const cancelOptionPopup = () => {
        setShowOptionsPopup({ message: "", show: false });
    };

    const mapPatientData = (data: PatientInfoObject) => {
        const patientInfo = getValues('patientInfo');
        const insuranceInformation = getValues('insuranceInfo');
        const supportingDocs = getValues('supportingDocumentation');
        const woundData = woundInfoRows?.map((row) => ({
            woundType: row.woundType,
            procedureLocation: row.procedureLocation,
            cpt: row.cpt,
            cptIds: row.cptIds,
            lCode: row.lCode,
            lCodeIds: row.lCodeIds,
            icd10: row.icd10,
            icdIds: row.icdIds,
            eCode: row.eCode,
            eCodeIds: row.eCodeIds,
            iCode: row.iCode,
            iCodeIds: row.iCodeIds,
            otherDxCodes: row.otherDxCodes,
            noOfApplications: row.noOfApplications,
            length: row.length,
            width: row.width,
            depth: row.depth,
            woundInfoKey: row.woundInfoKey,
            totalSize: row.totalSize.toString(),
            incisionMeasurement: row.incisionMeasurement,
            surgicalIncision: row.surgicalIncision,
            exudateDrainage: row.exudateDrainage,
            odor: row.odor,
            //CS-1193 -Start
            dateOfSurgery: row.dateOfSurgery ? moment(row.dateOfSurgery?.toString())?.format("MM/DD/YYYY") : "",
            //CS-1193 -End
            periIncisionErythema: row.periIncisionErythema,
            periIncisionSkin: row.periIncisionSkin,
            periIncisionTemperature: row.periIncisionTemperature,
            edema: row.edema,
            exudate: row.exudate,
            drainage: row.drainage,
            erythema: row.erythema,
            skin: row.skin,
            temperature: row.temperature,
            cellulitis: row.cellulitis,
            debrided: row.debrided,
            eschar: row.eschar,
            undermining: row.undermining,
            tunneling: row.tunneling,
            pain: row.pain,
            severity: row.severity,
            woundStage:row.woundStage
        }));

        const woundInfo = {
            woundData: woundData,
            totalSizeOfAllWounds: parseFloat(getValues('woundInfo.totalSizeOfAllWounds')),
            isLoadedFromProviderTemplate: isAddIncisionButtonDisabled,
        };

        const mappedPatientInfo = {
            patientCode: patientInfoObject?.patientCode,
            patientId: patientEditDetails?.patientId ? patientEditDetails.patientId : patientInfo.patientId,
            isPatientEdited: isPatientEdited,
            isOtherPatientDataEdited: isOtherPatientDataEdited,
            firstName: patientInfo.FirstName,
            middleName: patientInfo.MiddleName,
            lastName: patientInfo.LastName,
            birthDate: patientInfo.patientDOB
                ? moment(patientInfo.patientDOB?.toString())?.format("MM/DD/YYYY")
                : "",
            gender: patientInfo.gender,
            // CS-1758 - Pass create patient flow source in patient payload
            source: createPatientFlowSource,
            status: submitAction === 'submitAction' 
                ? (patientInfoObject?.status && patientInfoObject?.status !== PATIENT_STATUS.DRAFTED 
                    ? patientInfoObject.status 
                    : PATIENT_STATUS.ACTIVE) 
                : PATIENT_STATUS.DRAFTED,
            patientInfo: [
                {
                    infoType: PATIENT_IVR_INFO_TYPES.EMAIL,
                    isEdited: isEmailEdited,
                    patientinfoId: patientEmail,
                    infoTypeData: {
                        patientEmail: patientInfo.patientEmail,
                    },
                },
                {
                    infoType: PATIENT_IVR_INFO_TYPES.ADDRESS,
                    isEdited: isPatientInfoEdited,
                    patientinfoId: patientInfoIdAddress,
                    infoTypeData: {
                        patientStreetAddress: patientInfo.StreetAddress,
                        patientUnitNumber: patientInfo.UnitNumber,
                        patientCity: patientInfo.City,
                        patientState: patientInfo.State,
                        patientZip: patientInfo.Zipcode,
                    },
                },
                {
                    infoType: PATIENT_IVR_INFO_TYPES.FACE_SHEET,
                    isEdited: isFaceSheetEdited,
                    patientinfoId: patientInfoIdFaceSheet,
                    infoTypeData: {
                        documentIds: patientInfo.faceSheet,
                        isSkipped: patientInfo.isFaceSheetSkipped,
                    },
                },
                {
                    infoType: PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE,
                    isEdited: isPrimaryInsuranceInfoEdited,
                    patientinfoId: patientInfoIdPrimaryInsurance,
                    infoTypeData: {
                        insuranceName:insuranceInformation.insuranceCategory==="Commercial" && insuranceInformation.primaryCommercialInsuranceName ? insuranceInformation.primaryCommercialInsuranceName : insuranceInformation.insuranceName,
                        insuranceCategory: insuranceInformation.insuranceCategory,
                        insuranceNameNotListed: insuranceInformation.insuranceNameNotListed||false,
                        insurancePayerCode:insuranceInformation.insuranceCategory==="Commercial" && insuranceInformation.primaryCommercialInsuranceName? "":insuranceInformation.insurancePayerCode,
                        policy: insuranceInformation.policy ? insuranceInformation.policy.toUpperCase() : "",
                        isPolicyUnderDifferentName:
                            insuranceInformation.isPolicyUnderDifferentName,
                        policyHolderFirstName: insuranceInformation.policyholderFirstName,
                        policyHolderMiddleName: insuranceInformation.policyholderMiddleName,
                        policyHolderLastName: insuranceInformation.policyholderLastName,
                        policyHolderDOB: insuranceInformation.policyHolderDOB
                            ? moment(insuranceInformation.policyHolderDOB?.toString())?.format(
                                "MM/DD/YYYY"
                            )
                            : "",
                        insuranceType: insuranceInformation.insuranceType,
                        documentIds: insuranceInformation.insuranceCards,
                        isSkipped: insuranceInformation.isInsuranceCardsSkipped,
                        primaryCommercialInsuranceName: insuranceInformation.primaryCommercialInsuranceName,
                    },
                },
                ...(isSecondaryInsurance || isSecondaryInsuranceInfoEdited 
                ? [
                    {
                        infoType: PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE,
                        isEdited: isSecondaryInsuranceInfoEdited,
                        patientinfoId: patientInfoIdSecondaryInsurance,
                        infoTypeData: {
                          insuranceName:insuranceInformation.secondaryInsuranceCategory==="Commercial" && insuranceInformation.secondaryCommercialInsuranceName ? insuranceInformation.secondaryCommercialInsuranceName : insuranceInformation.secondaryInsuranceName,
                          insuranceCategory: insuranceInformation.secondaryInsuranceCategory,
                          secondaryInsuranceNameNotListed: insuranceInformation.secondaryInsuranceNameNotListed||false,
                          insurancePayerCode:insuranceInformation.secondaryInsuranceCategory==="Commercial" && insuranceInformation.secondaryCommercialInsuranceName ? "":insuranceInformation.secondaryInsurancePayerCode,
                          policy: insuranceInformation?.secondaryPolicy?.toUpperCase(),
                          isPolicyUnderDifferentName:
                          insuranceInformation.isSecondaryPolicyUnderDifferentName,
                          policyHolderFirstName: insuranceInformation.secondarypolicyholderFirstName,
                          policyHolderMiddleName:
                          insuranceInformation.secondarypolicyholderMiddleName,
                          policyHolderLastName: insuranceInformation.secondarypolicyholderLastName,
                          policyHolderDOB: insuranceInformation.secondaryPolicyHolderDOB
                            ? moment(
                              insuranceInformation.secondaryPolicyHolderDOB?.toString()
                            )?.format("MM/DD/YYYY")
                            : "",
                          insuranceType: insuranceInformation.secondaryInsuranceType,
                          documentIds: insuranceInformation.secondaryInsuranceCards,
                          isSkipped: insuranceInformation.isSecondaryInsuranceCardsSkipped,
                          secondaryCommercialInsuranceName: insuranceInformation.secondaryCommercialInsuranceName,
                        },
                      },
                  ]
                : []),
                {
                    infoType: PATIENT_IVR_INFO_TYPES.MEDICAL_NOTES,
                    isEdited: isSupportingDocumentsEdited,
                    patientinfoId: patientInfoIdSupportingDocs,
                    infoTypeData: {
                        documentIds: supportingDocs.supportingDocuments,
                        isSkipped: supportingDocs.isSupportingDocumentsSkipped,
                    },
                },
                {
                    infoType: PATIENT_IVR_INFO_TYPES.IMAGE_OF_WOUNDS,
                    isEdited: isImageOfWoundsEdited,
                    patientinfoId: patientInfoIdWoundImages,
                    infoTypeData: {
                        documentIds: supportingDocs.imageOfWounds,
                        isSkipped: supportingDocs.isImageOfWoundsSkipped,
                    },
                },
                ...((patientEditDetails?.patientId == null || (patientEditDetails?.patientId && isWoundInfoEdited))
                    ? [
                        {
                            infoType: PATIENT_IVR_INFO_TYPES.WOUND_INFO,
                            isEdited: true,
                            patientinfoId: patientWoundInfo,
                            infoTypeData: {
                                woundInfo: woundInfo,
                            },
                        },
                    ]
                    : []),
                ...(patientEditDetails?.patientId !== null && isPatientEdited
                    ? [
                        {
                            infoType: PATIENT_IVR_INFO_TYPES.NAME_CHANGE,
                            isEdited: isPatientEdited,
                            patientinfoId: patientNameChange,
                            infoTypeData: {
                                oldDetails: {
                                    name: fullName(null, patientCompleteData?.patientInfo?.FirstName, patientCompleteData?.patientInfo?.MiddleName, patientCompleteData?.patientInfo?.LastName),
                                    dob: patientCompleteData?.patientInfo?.patientDOB
                                },
                                newDetails: {
                                    name: fullName(null, patientInfo?.FirstName, patientInfo?.MiddleName, patientInfo?.LastName),
                                    dob: patientInfo?.patientDOB
                                }
                            }
                        },
                    ]
                    : [])
            ],
        };

        return mappedPatientInfo;
    }

    const onSubmit = async (data: PatientInfoObject) => {
        
        const isPatientExist = await checkPatientExistance()
        if(isPatientExist){
            return;
        }
        if (!isSecondaryInsurance && patientCompleteData?.insuranceInfo?.secondaryInsuranceName) {
            setIsSecondaryInsuranceInfoEdited(true);
        }
        const mappedObj = mapPatientData(data);
        const savePatientRequest: SavePatientRequest = {
            practiceId: getValues('practiceId'),
            dateOfSurgery: selectedPracticeType !== PRACTICE_TYPE.WOUND_CARE ? getValues('dateOfSurgery') : null,
            providerId: getValues('providerId'),
            providerTemplateId: getValues("providerTemplateId")||null,
            patientDataRequest: mappedObj
        }
        setShowOptionsPopup({
            message: `Do you really want to save the patient?`,
            show: true,
            variant: "confirm",
            buttons: [{ name: "Confirm", color: 'primary', onClick: () => savePatient(savePatientRequest) }, { name: "Cancel", color: 'secondary', onClick: cancelOptionPopup }]
        });

    }

    const patientGenderOptions = [
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" },
    ];

    const removeDataUriPrefix = (dataUri: string): string => {
        const base64String = dataUri.split(",")[1];
        return base64String || "";
    };

    const filterEmptyFiles = (files: ExtendedFile[]): { valid: ExtendedFile[]; emptyCount: number } => {
        const valid = files.filter((f) => f.size > 0);
        return { valid, emptyCount: files.length - valid.length };
      };

    const handleFaceSheetChange = async (uploadedFiles: ExtendedFile[]) => {
        const newFiles = uploadedFiles.filter((file) => !file.documentId);
        const { valid: nonEmptyFiles, emptyCount } = filterEmptyFiles(newFiles);

if (emptyCount > 0) {
    dispatch(setSingleAlertObj({
        message: emptyCount === 1
        ? "Upload failed: Empty files (0 KB) are not allowed. Please select a valid file."
        : `${emptyCount} files were not added. Empty files (0 KB) are not allowed. Please select a valid file.`,
        alertType: "warning",
    }));
}
        const faceSheetIds = getValues('patientInfo.faceSheet') || [];
        if (nonEmptyFiles.length > 0) {
            dispatch(showHideLoadingDialog(true));
            try {
                setValue("patientInfo.isFaceSheetSkipped", false, { shouldValidate: true, shouldDirty: true });
                for (const fileData of nonEmptyFiles) {
                    let base64File = String(await convertBase64(fileData));
                    const FaceSheetObject: IVRDocumentInfo = {
                        ivrId: null,
                        documentName: fileData.name,
                        content: removeDataUriPrefix(base64File),
                        type: "IVR",
                        fileType: fileData.type,
                    };
                    const response = await dispatch(uploadIVRDocument(FaceSheetObject));
                    let documentId = response.payload.data.documentId;
                    fileData.documentId = documentId;
                    faceSheetIds.push(documentId);
                }
                setValue("patientInfo.faceSheet", faceSheetIds);
                checkPatientInfoValidity({ ...watch() });
                trigger("patientInfo.faceSheet");
            } catch (error) {
                console.error("Error uploading files:", error);
            } finally {
                dispatch(showHideLoadingDialog(false));
            }
        }
    };

    const handleDeleteFacesheetDocument = async (documentId: number) => {
        let faceSheetIds = getValues('patientInfo.faceSheet') || [];
        faceSheetIds = faceSheetIds.filter(id => String(id) !== String(documentId));
        setValue("patientInfo.faceSheet", faceSheetIds);
        if (faceSheetIds.length === 0) {
            setValue("patientInfo.isFaceSheetSkipped", false, { shouldValidate: true, shouldDirty: true });
        }
        checkPatientInfoValidity({ ...watch() })
    };

    const policyOptions = [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
    ];
    const handleInsuranceCardChange = async (uploadedFiles: ExtendedFile[]) => {
        const newFiles = uploadedFiles.filter((file) => !file.documentId);
        const { valid: nonEmptyFiles, emptyCount } = filterEmptyFiles(newFiles);
        if (emptyCount > 0) {
            dispatch(setSingleAlertObj({
                message: emptyCount === 1
                ? "1 file was not added. Empty files are not allowed."
                : `${emptyCount} files were not added. Empty files are not allowed.`,
                alertType: "warning",
            }));
        }
        let insuranceCardIds = getValues('insuranceInfo.insuranceCards') || [];
        if (nonEmptyFiles.length > 0) {
            dispatch(showHideLoadingDialog(true));
            try {
                setValue("insuranceInfo.isInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
                for (const fileData of nonEmptyFiles) {
                    let base64File = String(await convertBase64(fileData));
                    const FaceSheetObject: IVRDocumentInfo = {
                        ivrId: null,
                        documentName: fileData.name,
                        content: removeDataUriPrefix(base64File),
                        type: "IVR",
                        fileType: fileData.type,
                    };
                    const response = await dispatch(uploadIVRDocument(FaceSheetObject));
                    let documentId = response.payload.data.documentId;
                    fileData.documentId = documentId;
                    insuranceCardIds.push(documentId)
                }

                setValue(
                    "insuranceInfo.insuranceCards",
                    insuranceCardIds
                );
                checkInsuranceInfoValidity({ ...watch() });
                trigger("insuranceInfo.insuranceCards");
            } catch (error) {
                console.error("Error uploading files:", error);
            } finally {
                dispatch(showHideLoadingDialog(false));
            }
        }
    };

    const handleDeleteInsuranceDocument = async (documentId: number) => {
        let insuranceCardIds = getValues('insuranceInfo.insuranceCards') || [];
        insuranceCardIds = insuranceCardIds.filter(id => String(id) !== String(documentId));
        setValue("insuranceInfo.insuranceCards", insuranceCardIds);
        if (insuranceCardIds.length === 0) {
            setValue("insuranceInfo.isInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
        }
        checkInsuranceInfoValidity({ ...watch() });
    };

    const handleSupportingDocsChange = async (uploadedFiles: ExtendedFile[]) => {
        const newFiles = uploadedFiles.filter((file) => !file.documentId);
        const { valid: nonEmptyFiles, emptyCount } = filterEmptyFiles(newFiles);
        if (emptyCount > 0) {
            dispatch(setSingleAlertObj({
                message: emptyCount === 1
                ? "1 file was not added. Empty files are not allowed."
                : `${emptyCount} files were not added. Empty files are not allowed.`,
                alertType: "warning",
            }));
        }
        const supportingDocIds = getValues('supportingDocumentation.supportingDocuments') || [];
        if (nonEmptyFiles.length > 0) {
            dispatch(showHideLoadingDialog(true));
            try {
                setValue("supportingDocumentation.isSupportingDocumentsSkipped", false, { shouldValidate: true, shouldDirty: true });
                for (const fileData of nonEmptyFiles) {
                    let base64File = String(await convertBase64(fileData));
                    const FaceSheetObject: IVRDocumentInfo = {
                        ivrId: null,
                        documentName: fileData.name,
                        content: removeDataUriPrefix(base64File),
                        type: "IVR",
                        fileType: fileData.type,
                    };

                    const response = await dispatch(uploadIVRDocument(FaceSheetObject));
                    let documentId = response.payload.data.documentId;
                    fileData.documentId = documentId;
                    supportingDocIds.push(documentId);
                    
                    // CS-1595 - Store PDF file for later audit and reset audit state for new file
                    if (hasSubscribedAccessToMedicalAudit && fileData.type === 'application/pdf') {
                        // Clear previous audit data to ensure fresh audit for new file
                        setAuditData(null);
                        setAuditInProgress(false);
                        setAuditCompleted(false);
                        // Set new PDF file (this will trigger auto-audit when popup opens)
                        setUploadedPdfFile(fileData);
                    }
                }

                setValue(
                    "supportingDocumentation.supportingDocuments",
                    supportingDocIds
                );
                checkSupportingDocumentationValidity({ ...watch() });
                trigger("supportingDocumentation.supportingDocuments");
            } catch (error) {
                console.error("Error uploading files:", error);
            } finally {
                dispatch(showHideLoadingDialog(false));
            }
        }
    };

    const handleDeleteSupportingDocument = async (documentId: number) => {
        let supportingDocIds = getValues('supportingDocumentation.supportingDocuments') || [];
        supportingDocIds =
            supportingDocIds.filter(id => String(id) !== String(documentId));
        setValue(
            "supportingDocumentation.supportingDocuments",
            supportingDocIds
        );
        if (supportingDocIds.length === 0) {
            setValue("supportingDocumentation.isSupportingDocumentsSkipped", false, { shouldValidate: true, shouldDirty: true });
        }
        checkSupportingDocumentationValidity({ ...watch() });
        
        // CS-1594 - Clean up audit data when file is deleted
        if (hasSubscribedAccessToMedicalAudit) {
            setAuditDataByDocument(prev => {
                const newMap = new Map(prev);
                newMap.delete(String(documentId));
                return newMap;
            });
            // CS-1773 - Run Medical Note Audit AI Tool in Background
            dispatch(clearAuditJob(String(documentId)));
        }
    };

    const handleSecondaryInsuranceCardChange = async (
        uploadedFiles: ExtendedFile[]
    ) => {
        const newFiles = uploadedFiles.filter((file) => !file.documentId);
        const { valid: nonEmptyFiles, emptyCount } = filterEmptyFiles(newFiles);
        if (emptyCount > 0) {
            dispatch(setSingleAlertObj({
                message: emptyCount === 1
                ? "1 file was not added. Empty files are not allowed."
                : `${emptyCount} files were not added. Empty files are not allowed.`,
                alertType: "warning",
            }));
        }
        const secondaryInsuranceIds = getValues('insuranceInfo.secondaryInsuranceCards') || [];

        if (nonEmptyFiles.length > 0) {
            dispatch(showHideLoadingDialog(true));
            try {
                setValue("insuranceInfo.isSecondaryInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
                for (const fileData of nonEmptyFiles) {
                    let base64File = String(await convertBase64(fileData));
                    const FaceSheetObject: IVRDocumentInfo = {
                        ivrId: null,
                        documentName: fileData.name,
                        content: removeDataUriPrefix(base64File),
                        type: "IVR",
                        fileType: fileData.type,
                    };

                    const response = await dispatch(uploadIVRDocument(FaceSheetObject));
                    let documentId = response.payload.data.documentId;
                    fileData.documentId = documentId;
                    secondaryInsuranceIds.push(documentId);
                }

                setValue(
                    "insuranceInfo.secondaryInsuranceCards",
                    secondaryInsuranceIds
                );
                checkInsuranceInfoValidity({ ...watch() });
                trigger("insuranceInfo.secondaryInsuranceCards");
            } catch (error) {
                console.error("Error uploading files:", error);
            } finally {
                dispatch(showHideLoadingDialog(false));
            }
        }
    };

    const handleDeleteSecondaryInsuranceDocument = async (documentId: number) => {
        let secondaryInsuranceIds = getValues('insuranceInfo.secondaryInsuranceCards') || [];
        secondaryInsuranceIds =
            secondaryInsuranceIds.filter(id => String(id) !== String(documentId));
        setValue(
            "insuranceInfo.secondaryInsuranceCards",
            secondaryInsuranceIds
        );
        if (secondaryInsuranceIds.length === 0) {
            setValue("insuranceInfo.isSecondaryInsuranceCardsSkipped", false, { shouldValidate: true, shouldDirty: true });
        }
        // setUploadedSecondaryInsuranceFilesMetaData([])
        checkInsuranceInfoValidity({ ...watch() });
    };

    const handleImageOfWoundsChange = async (uploadedFiles: ExtendedFile[]) => {
        const newFiles = uploadedFiles.filter((file) => !file.documentId);
        const { valid: nonEmptyFiles, emptyCount } = filterEmptyFiles(newFiles);
        if (emptyCount > 0) {
            dispatch(setSingleAlertObj({
                    message: emptyCount === 1
                ? "1 file was not added. Empty files are not allowed."
                : `${emptyCount} files were not added. Empty files are not allowed.`,
                alertType: "warning",
            }));
        }
        const imageOfWoundIds = getValues('supportingDocumentation.imageOfWounds') || [];
        if (nonEmptyFiles.length > 0) {
            dispatch(showHideLoadingDialog(true));
            try {
                setValue("supportingDocumentation.isImageOfWoundsSkipped", false, { shouldValidate: true, shouldDirty: true });
                for (const fileData of nonEmptyFiles) {
                    let base64File = String(await convertBase64(fileData));
                    const FaceSheetObject: IVRDocumentInfo = {
                        ivrId: null,
                        documentName: fileData.name,
                        content: removeDataUriPrefix(base64File),
                        type: "IVR",
                        fileType: fileData.type,
                    };

                    const response = await dispatch(uploadIVRDocument(FaceSheetObject));
                    let documentId = response.payload.data.documentId;
                    fileData.documentId = documentId;
                    imageOfWoundIds.push(documentId);
                }

                setValue(
                    "supportingDocumentation.imageOfWounds",
                    imageOfWoundIds
                );
                checkSupportingDocumentationValidity({ ...watch() });
                trigger("supportingDocumentation.imageOfWounds");
            } catch (error) {
                console.error("Error uploading files:", error);
            } finally {
                dispatch(showHideLoadingDialog(false));
            }
        }
    };

    const handleDeleteImageOfWoundsDocument = async (documentId: number) => {
        let imageOfWoundIds = getValues('supportingDocumentation.imageOfWounds') || [];
        imageOfWoundIds =
            imageOfWoundIds.filter(id => String(id) !== String(documentId));
        setValue(
            "supportingDocumentation.imageOfWounds",
            imageOfWoundIds
        );
        if (imageOfWoundIds.length === 0) {
            setValue("supportingDocumentation.isImageOfWoundsSkipped", false, { shouldValidate: true, shouldDirty: true });
        }
        checkSupportingDocumentationValidity({ ...watch() });
    };

    const handleBirthDayChange = (date: Date | null) => {
        if (date) {
            setValue('patientInfo.patientDOB', dayjs(date).format("MM/DD/YYYY"));
        }
    };

    const handleDateOfSurgeryChange = (date: Date | null) => {
        if (date) {
            setValue('dateOfSurgery', dayjs(date).format("MM/DD/YYYY"));
        }
    };

    // CS-1758 - Reuse the existing cancel cleanup before navigating away from the form
    const handleCancelNavigation = () => {
        const faceSheetDocumentIds = getValues("patientInfo.faceSheet") || [];
        const insuranceCardsDocumentIds = getValues(
            "insuranceInfo.insuranceCards"
        ) || [];
        const secondaryInsuranceCardsDocumentIds = getValues(
            "insuranceInfo.secondaryInsuranceCards"
        ) || [];
        const supportingDocsDocumentIds = getValues(
            "supportingDocumentation.supportingDocuments"
        ) || [];
        const imagesOfWOundsDocumentIds = getValues(
            "supportingDocumentation.imageOfWounds"
        ) || [];

        const allDocumentIds = [
            ...faceSheetDocumentIds,
            ...insuranceCardsDocumentIds,
            ...secondaryInsuranceCardsDocumentIds,
            ...supportingDocsDocumentIds,
            ...imagesOfWOundsDocumentIds,
        ];

        if (!patientEditDetails?.isPatientEdit) {
            if (allDocumentIds && allDocumentIds.length > 0) {
                const removePromises = allDocumentIds.map((id) =>
                    dispatch(removeIVRDocument(id.toString()))
                );
            }
        }
        navigate(-1);
    };

    // CS-1758 - Facesheet entry flow should warn before cancelling the unsaved patient form
    const onCancelClick = () => {
        const shouldShowFacesheetCancelConfirmation =
            createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET &&
            !patientEditDetails?.isPatientEdit;

        if (shouldShowFacesheetCancelConfirmation) {
            setShowFacesheetCancelWarning(true);
            return;
        }

        handleCancelNavigation();
    };

    const setInsurancePolicyNameChange = () => {
        const value = getValues('insuranceInfo.isPolicyUnderDifferentName');
        if (value?.toString() === "yes") {
            setIsPolicyUnderDifferentNameCheck(true);
        } else {
            setValue('insuranceInfo.policyholderFirstName', '');
            setValue('insuranceInfo.policyholderMiddleName', '');
            setValue('insuranceInfo.policyholderLastName', '');
            setValue('insuranceInfo.policyHolderDOB', '');
            setIsPolicyUnderDifferentNameCheck(false);
        }
    }

    const setSecondaryInsurancePolicyNameChange = () => {
        const value = getValues('insuranceInfo.isSecondaryPolicyUnderDifferentName');

        if (value?.toString() === "yes") {
            setIsPolicyUnderDifferentNameCheckSecondary(true);
        } else {
            setValue('insuranceInfo.secondarypolicyholderFirstName', '');
            setValue('insuranceInfo.secondarypolicyholderMiddleName', '');
            setValue('insuranceInfo.secondarypolicyholderLastName', '');
            setValue('insuranceInfo.secondaryPolicyHolderDOB', '');
            setIsPolicyUnderDifferentNameCheckSecondary(false);
        }
    }

    const [submitAction, setSubmitAction] = useState<string | null>(null);

    const onError = (_error: any, e: any) => {
        if (submitAction === "saveAction") {
            clearErrors();
            let hasError = false;

            if (!getValues("practiceId")) {
                setError("practiceId", { type: "required", message: "Practice Name is required." });
                hasError = true;
            }

            if (!getValues("patientInfo.FirstName")) {
                setError("patientInfo.FirstName", { type: "required", message: "Patient First Name is required." });
                hasError = true;
            }

            if (!getValues("patientInfo.LastName")) {
                setError("patientInfo.LastName", { type: "required", message: "Patient Last Name is required." });
                hasError = true;
            }

            if (!getValues("patientInfo.patientDOB")) {
                setError("patientInfo.patientDOB", { type: "required", message: "Patient Date of Birth is required." });
                hasError = true;
            }

            if (!getValues("patientInfo.gender")) {
                setError("patientInfo.gender", { type: "required", message: "Patient Gender is required." });
                hasError = true;
            }

            if (!getValues("providerId")) {
                setError("providerId", { type: "required", message: "Provider is required." });
                hasError = true;
            }

            if (hasError) {
                scrollToElement(patientInformationRef);
            }

            if (!hasError) {
                onSubmit(getValues());
            }
        } else if (submitAction === "submitAction") {
            let hasError = true;
            let faceSheetUploaded = false;
            let supportingDocsUploaded = false;
            let imageOfWoundsUploaded = false;
            let insuranceCardsUploaded = false;
            let secondatyInsuranceCardsUploaded = false;

            if (getValues("patientInfo.faceSheet")?.length !== 0) {
                faceSheetUploaded = true;
                clearErrors("patientInfo.faceSheet");
            }

            if (getValues("supportingDocumentation.imageOfWounds").length !== 0) {
                imageOfWoundsUploaded = true;
                clearErrors("supportingDocumentation.imageOfWounds");
            }

            if (getValues("supportingDocumentation.supportingDocuments").length !== 0) {
                supportingDocsUploaded = true;
                clearErrors("supportingDocumentation.supportingDocuments");
            }

            if (getValues("insuranceInfo.insuranceCards")?.length !== 0) {
                insuranceCardsUploaded = true;
                clearErrors("insuranceInfo.insuranceCards");
            }

            if (getValues("insuranceInfo.secondaryInsuranceCards") && getValues("insuranceInfo.secondaryInsuranceCards").length !== 0) {
                secondatyInsuranceCardsUploaded = true;
                clearErrors("insuranceInfo.secondaryInsuranceCards");
            }

            if (getValues("patientInfo.isFaceSheetSkipped")) {
                clearErrors("patientInfo.faceSheet");
            }

            if (getValues("supportingDocumentation.isSupportingDocumentsSkipped")) {
                clearErrors("supportingDocumentation.supportingDocuments");
            }

            if (getValues("supportingDocumentation.isImageOfWoundsSkipped")) {
                clearErrors("supportingDocumentation.imageOfWounds");
            }

            if (getValues("insuranceInfo.isInsuranceCardsSkipped")) {
                clearErrors("insuranceInfo.insuranceCards");
            }

            if (getValues("insuranceInfo.isSecondaryInsuranceCardsSkipped")) {
                clearErrors("insuranceInfo.secondaryInsuranceCards");
            }

            if (hasNestedErrors(_error)) {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
                return;
            }

            if ((faceSheetUploaded || getValues("patientInfo.isFaceSheetSkipped")) && (supportingDocsUploaded || getValues("supportingDocumentation.isSupportingDocumentsSkipped")) && (imageOfWoundsUploaded || getValues("supportingDocumentation.isImageOfWoundsSkipped")) && (insuranceCardsUploaded || getValues("insuranceInfo.isInsuranceCardsSkipped"))) {
                hasError = false;
            } else {
                hasError = true;
            }

            if (!hasError) {
                onSubmit(getValues());
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }
            return;
        } else {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }

    type Option = {
        value: string;
        label: string;
    };


    const practiceOptions = useMemo(() => {
        let options: Option[] = [];
        if (
            practiceByUserRoleOrderSlice &&
            practiceByUserRoleOrderSlice.length > 0
        ) {
            if (practiceByUserRoleOrderSlice.length === 1) {
                setValue("practiceId", Number(practiceByUserRoleOrderSlice[0]?.practiceId),
                );
            }
            const sortedPracticeInfo: PracticeInfo[] = sortNames(
                practiceByUserRoleOrderSlice,
                "practiceName"
            );
            sortedPracticeInfo?.map((practice) => {
                options.push({
                    value: practice.practiceId,
                    label: practice.practiceName,
                });
            });
        }
        return options;
    }, [practiceByUserRoleOrderSlice]);

    //Commented for live release
    const primaryPayersOptions = useMemo(() => {
        let options: Option[] = [];
        const primaryInsuranceCategory = watch('insuranceInfo.insuranceCategory');
        const primaryInsurancePayerCode = watch('insuranceInfo.insurancePayerCode');
        const shouldPreservePrimaryOtherSelection =
            insuranceNameNotListed || String(primaryInsurancePayerCode ?? "") === "0";
        // CS-1758 - Skip auto-selection when facesheet has already provided a valid payer code
        const hasFacesheetPayerCode = createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET
            && !!primaryInsurancePayerCode && String(primaryInsurancePayerCode) !== "0";

        if(primaryInsuranceCategory !== "Commercial"){
        allPayerList?.filter((payers: any) => payers.category === primaryInsuranceCategory).map((payers: any) => {
            options.push({
                value: payers.payerCode,
                label: payers.payerName,
            });
        });
        // CS-1758 - Only add "Other" option for non-Commercial categories when patient is from facesheet;
        // manual mode should not show "Other" for categories like Medicare, Medicaid, etc.
        const shouldAddOtherOption =
            primaryInsuranceCategory &&
            createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET &&
            !options.some((option) => String(option.value) === "0" || option.label === "Other");

        if (shouldAddOtherOption) {
            options.push({ value: "0", label: "Other" });
        }

        if(options.length === 1 && !shouldPreservePrimaryOtherSelection && !hasFacesheetPayerCode){
            setValue('insuranceInfo.insurancePayerCode', options[0].value);
            setValue('insuranceInfo.insuranceName', options[0].label);
            //CS-1335
            trigger('insuranceInfo.insurancePayerCode');
        }
    }else{
        allPayerList
          ?.filter((payers: any) => payers.category === primaryInsuranceCategory)
          .forEach((payers: any) => {
            options.push({
              value: payers.payerCode,
              label: payers.payerName,
            });
          });
        if (!options.some((option) => String(option.value) === "0" || option.label === "Other")) {
            options.push({ value: "0", label: "Other" });
        }

    }
        return options;
    }, [allPayerList, insuranceNameNotListed, watch('insuranceInfo.insuranceCategory'), watch('insuranceInfo.insurancePayerCode')]);
    useEffect(()=>{
        if(watch('insuranceInfo.insuranceCategory')){
            setValue('insuranceInfo.insuranceCategory',watch('insuranceInfo.insuranceCategory'))
        }else{
            setValue('insuranceInfo.insuranceName', '');
            setValue('insuranceInfo.insurancePayerCode', '');
            setValue('insuranceInfo.insuranceCategory','');
            setValue('insuranceInfo.primaryCommercialInsuranceName', '');

        }
    },[ watch('insuranceInfo.insuranceCategory')])
    useEffect(()=>{
        if(watch('insuranceInfo.secondaryInsuranceCategory')){
            setValue('insuranceInfo.secondaryInsuranceCategory',watch('insuranceInfo.secondaryInsuranceCategory'))
        }else{
            setValue('insuranceInfo.secondaryInsuranceName', '');
            setValue('insuranceInfo.secondaryInsurancePayerCode', '');
            setValue('insuranceInfo.secondaryInsuranceCategory','');
            setValue('insuranceInfo.secondaryCommercialInsuranceName', '');

        }
    },[ watch('insuranceInfo.secondaryInsuranceCategory')])
    const secondaryPayersOptions = useMemo(() => {
        let options: Option[] = [];
        const secondaryInsurancecategory = watch('insuranceInfo.secondaryInsuranceCategory');
        const secondaryInsurancePayerCode = watch('insuranceInfo.secondaryInsurancePayerCode');
        const shouldPreserveSecondaryOtherSelection =
            secondaryInsuranceNameNotListed || String(secondaryInsurancePayerCode ?? "") === "0";
        // CS-1758 - Skip auto-selection when facesheet has already provided a valid payer code
        const hasFacesheetSecondaryPayerCode = createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET
            && !!secondaryInsurancePayerCode && String(secondaryInsurancePayerCode) !== "0";

        if(secondaryInsurancecategory !== "Commercial"){
            allPayerList?.filter((payers: any) => payers.category === secondaryInsurancecategory).map((payers: any) => {
                options.push({
                    value: payers.payerCode,
                    label: payers.payerName,
                });
            });
            // CS-1758 - Only add "Other" option for non-Commercial categories when patient is from facesheet;
            // manual mode should not show "Other" for categories like Medicare, Medicaid, etc.
            const shouldAddOtherOption =
                secondaryInsurancecategory &&
                createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET &&
                !options.some((option) => String(option.value) === "0" || option.label === "Other");

            if (shouldAddOtherOption) {
                options.push({ value: "0", label: "Other" });
            }

            if(options.length === 1 && !shouldPreserveSecondaryOtherSelection && !hasFacesheetSecondaryPayerCode){
                setValue('insuranceInfo.secondaryInsurancePayerCode', options[0].value);
                setValue('insuranceInfo.secondaryInsuranceName', options[0].label);
                //CS-1335
                trigger('insuranceInfo.secondaryInsurancePayerCode');

            }
        }else{
            allPayerList
              ?.filter((payers: any) => payers.category === secondaryInsurancecategory)
              .forEach((payers: any) => {
                options.push({
                  value: payers.payerCode,
                  label: payers.payerName,
                });
              });
            if (!options.some((option) => String(option.value) === "0" || option.label === "Other")) {
                options.push({ value: "0", label: "Other" });
            }
        }
        return options;
    }, [allPayerList, secondaryInsuranceNameNotListed, watch('insuranceInfo.secondaryInsuranceCategory'), watch('insuranceInfo.secondaryInsurancePayerCode')]);

    useEffect(() => {
        if (!patientInfoObject?.patientInfo || !patientEditDetails?.isPatientEdit) return;
        // Mapping infoTypes to the appropriate setter functions
        const infoTypeMapping = {
            IMAGEOF_WOUNDS: setUploadedWoundImageFilesMetaData,
            FACESHEET: setUploadedFacesheetFilesMetaData,
            PRIMARY_INSURANCE: setUploadedPrimaryInsuranceFilesMetaData,
            SUPPORTING_DOCUMENT: setUploadedSupportingDocumentFilesMetaData,
            SECONDARY_INSURANCE: setUploadedSecondaryInsuranceFilesMetaData,
        };

        // Get patientInfo from the patientCompleteData
        const patientCompleteInfo = patientInfoObject?.patientInfo;

        const filteredEntries = patientCompleteInfo?.filter(entry => {
            const docs = entry?.patientinfoData?.ivrDocumentListDTOs ?? [];
            return docs.some((doc: any) => doc.isActive === true);
          });

        Object.entries(infoTypeMapping).forEach(([infoType, setter]) => {

            const data = filteredEntries.find(info => info.infoType === infoType);

            if (data?.patientinfoData.ivrDocumentListDTOs) {

                const documentsMetaData = data.patientinfoData.ivrDocumentListDTOs.map(
                    ({ documentId, documentName, documentType, size }: any) => ({

                        documentId: documentId ? documentId.toString() : "",
                        name: documentName ? documentName : "",
                        type: documentType || "Unknown",
                        size: size ? size : 0,
                        timestamp: '',
                        lastModified: 0,
                        webkitRelativePath: "",
                        arrayBuffer: async () => new ArrayBuffer(0),
                        bytes: async () => new Uint8Array(0),
                        slice: () => new Blob(),
                        stream: () => new ReadableStream(),
                        text: async () => "",
                    })
                );
                setter(documentsMetaData);

            } else {
                setter([]);
            }
        });

    }, [patientInfoObject]);

  /* Codes (CPT/L/E/I) and Measurements (dimensions/area/volume) are each
     consolidated into a single compact multi-line cell — see `codes`/
     `measurements` synthesized in `woundInfoTableRows` below — so the table
     reads in fewer columns and no longer needs a horizontal scrollbar on a
     typical desktop width, without dropping any of the underlying data.
     (Mirrors IVRForm.tsx's baseWoundColumns.) */
  const baseWoundColumns: Column[] = [
    { id: "woundKeyDisplayValue", label: "ID", minWidth: 20 },
    { id: "woundType", label: "Type", minWidth: 80 },
    { id: "codes", label: "Codes (CPT/L Code/E Code/I Code)", minWidth: 90 },
    { id: "procedureLocation", label: "Location", minWidth: 80 },
    { id: "otherDxCodes", label: "Dx Code(s) / ICD-10", minWidth: 80 },
    { id: "exudate", label: "Exudate", minWidth: 80 },
    { id: "measurements", label: "Measurements (L, W, D / Area / Volume)", minWidth: 160 },
    { id: "action", label: "Action", minWidth: 20, align: "center" },
];

// const shouldShowExudate = useMemo(() => {
//     return woundInfoRows.some(row => row.woundType === "Surgical Incision");
// }, [woundInfoRows]);

const woundInfoTableColumns: Column[] = useMemo(() => {
    const filteredColumns = baseWoundColumns.filter(
        column => !((column.id === "codes" || column.id === "exudate") && selectedPracticeType === PRACTICE_TYPE.SURGICAL)
    );
    // const insertIndex = filteredColumns.findIndex(col => col.id === "displayTotalSize");
    // if (shouldShowExudate && insertIndex !== -1) {
    //     const exudateColumn = { id: "exudate", label: "Exudate", minWidth: 80 };
    //     return [
    //         ...filteredColumns.slice(0, insertIndex),
    //         exudateColumn,
    //         ...filteredColumns.slice(insertIndex)
    //     ];
    // }
    return filteredColumns;
}, [selectedPracticeType]);

const woundInfoTableRows = useMemo(() => {
    return (woundInfoRows || []).map((row: any) => {
        const codeParts = [
            row.cpt && `CPT: ${row.cpt}`,
            row.lCode && `L Code: ${row.lCode}`,
            row.eCode && `E Code: ${row.eCode}`,
            row.iCode && `I Code: ${row.iCode}`,
        ].filter(Boolean);
        const measurementParts = [
            row.displayWoundDimensions && `Dimensions: ${row.displayWoundDimensions}`,
            row.displayEstimateSurfaceArea && `Area: ${row.displayEstimateSurfaceArea}`,
            row.displayTotalWoundVolume && `Volume: ${row.displayTotalWoundVolume}`,
        ].filter(Boolean);
        return {
            ...row,
            codes: codeParts.length > 0 ? codeParts.join(" • ") : "-",
            measurements: measurementParts.length > 0 ? measurementParts.join(" • ") : "-",
        };
    });
}, [woundInfoRows]);

    const clickShowWoundInfoPopup = () => {
        setShowWoundInfoPopup(true);
    };

    const onEditClick = useCallback(
        (row: any, rowIndex: number, fieldName: string) => {
            setCurrentWoundInfo(row);
            if(row?.woundType === "Surgical Incision"){
                // if (isAddIncisionButtonDisabled) {
                    // setShowOptionsPopup({
                    //     show: true,
                    //     variant: "error",
                    //     message: (
                    //         <>
                    //             <strong>Unable to Modify Incision Details:</strong> Cannot modify incision details from this action because this data is populated from the provider templates. Please update the template details instead.
                    //         </>
                    //     ),
                    //     buttons: [
                    //         {
                    //             name: "OK",
                    //             color: "error",
                    //             onClick: () => {
                    //                 setShowOptionsPopup({ show: false, message: "" });
                    //             },
                    //         },
                    //     ],
                    // });
                // } else {
                //     setShowIncisionInfoPopup(true);
                // }
                setShowIncisionInfoPopup(true);
            }else{
                setShowWoundInfoPopup(true);
            }
        },
        [isAddIncisionButtonDisabled]
    );

    const isDeletingRef = useRef(false); // flag to restrict double calling of the function

    const deleteWoundInfoRow = (rowIndex: number) => {
        if (isDeletingRef.current) return;
        isDeletingRef.current = true;
        setIsDeleting(true);
        onDeleteClick(rowIndex);

        setTimeout(() => {
            isDeletingRef.current = false;
        }, 100);
    };

    const onDeleteClick = (rowIndex: number) => {
        setWoundInfoRows((currentRows) => {
            const updatedRows = currentRows.filter((_, index) => index !== rowIndex);
            return updatedRows;
        });
        checkWoundInfoValidity({ ...watch() });
        cancelOptionPopup();
    };

    const checkHasIvr = (woundInfoKey: string) => {
        if (woundInfoHasIvrByPatient && woundInfoKey) {
            const hasIvr = woundInfoHasIvrByPatient.find(wound => wound.woundInfoKey === woundInfoKey)?.hasIvr;
            return !!hasIvr;
        }
        return false;
    };

    const setWoundInfoDeletePopup = (rowIndex: number, woundInfoKey?: string) => {
        setShowOptionsPopup({
            message: `Wound information will be deleted from the patient profile permanently. Do you wish to proceed?`,
            show: true,
            variant: "warning",
            buttons: [{ name: "Yes", color: 'primary', onClick: () => deleteWoundInfoRow(rowIndex) }, { name: "No", color: 'error', onClick: cancelOptionPopup }]
        });
    }

    const woundInfoActionComponent = (
        row: any,
        rowIndex: number
    ): JSX.Element => {
        return (
            <>
                <CustomIconButton
                    color="info"
                    size="small"
                    variant="outlined"
                    tooltipMessage="Edit"
                    tooltipPlacement="top"
                    onClick={() => onEditClick(row, rowIndex, "woundInfo")}
                // style={{ display: `${hideElement(checkHasIvr(row?.woundInfoKey))}` }}
                >
                    <ModeOutlined fontSize="small" />
                </CustomIconButton>{" "}
                {!row.productItemId || row.productItemId === 0 ? (
                    <CustomIconButton
                        color="error"
                        size="small"
                        variant="outlined"
                        tooltipMessage="Delete"
                        tooltipPlacement="top"
                        onClick={() => {
                            // if (isAddIncisionButtonDisabled) {
                            //     setShowOptionsPopup({
                            //         show: true,
                            //         variant: "error",
                            //         message: (
                            //             <>
                            //                 <strong>Unable to Delete Incision Details:</strong> Cannot delete incision details from this action because this data is populated from the provider templates. Please update the template details instead.
                            //             </>
                            //         ),
                            //         buttons: [
                            //             {
                            //                 name: "OK",
                            //                 color: "error",
                            //                 onClick: () => {
                            //                     setShowOptionsPopup({ show: false, message: "" });
                            //                 },
                            //             },
                            //         ],
                            //     });
                            // } else {
                            //     setWoundInfoDeletePopup(rowIndex, row?.woundInfoKey)
                            // }
                            setWoundInfoDeletePopup(rowIndex, row?.woundInfoKey)
                        }}
                    // style={{ display: `${hideElement(checkHasIvr(row?.woundInfoKey))}` }}
                    >
                        <DeleteOutlineOutlined fontSize="small" />
                    </CustomIconButton>
                ) : null}
            </>
        );
    };


    const handleAddWoundInfo = (woundInfoData: WoundInfo) => {
        const lengthValue = parseFloat(woundInfoData.length as unknown as string);
        const widthValue = parseFloat(woundInfoData.width as unknown as string);
        const depthValue = parseFloat(woundInfoData.depth as unknown as string);
        const estimateSurfaceArea = (!isNaN(lengthValue) && !isNaN(widthValue))
            ? (lengthValue * widthValue).toFixed(2)
            : '0.00';
        const totalWoundVolume = (!isNaN(lengthValue) && !isNaN(widthValue) && !isNaN(depthValue))
            ? (lengthValue * widthValue * depthValue).toFixed(2)
            : '0.00';
        const displayWoundDimensions = `${woundInfoData.length}cm X ${woundInfoData.width}cm X ${woundInfoData.depth}cm`;
        const displayEstimateSurfaceArea = `${estimateSurfaceArea}cm²`;
        const displayTotalWoundVolume = `${totalWoundVolume}cm³`;

        const updatedWoundInfoData = {
            ...woundInfoData,
            displayWoundDimensions,
            displayEstimateSurfaceArea,
            displayTotalWoundVolume,
        };
        let updatedWoundInfoData2 = { ...updatedWoundInfoData };
        if(woundInfoData){
            const cptFormatted = Array.isArray(updatedWoundInfoData2.cpt) ? updatedWoundInfoData2.cpt.join(', ') : updatedWoundInfoData2.cpt;
            const eCodesFormatted = Array.isArray(updatedWoundInfoData2.eCode) ? updatedWoundInfoData2.eCode.join(', ') : updatedWoundInfoData2.eCode;
            const iCodesFormatted = Array.isArray(updatedWoundInfoData2.iCode) ? updatedWoundInfoData2.iCode.join(', ') : updatedWoundInfoData2.iCode;
            const lCodesFormatted = Array.isArray(updatedWoundInfoData2.lCode) ? updatedWoundInfoData2.lCode.join(', ') : updatedWoundInfoData2.lCode;
            const icd10Formatted = Array.isArray(updatedWoundInfoData2.icd10) ? updatedWoundInfoData2.icd10.join(', ') : updatedWoundInfoData2.icd10;
            const woundInfoKey = updatedWoundInfoData2?.woundInfoKey ? updatedWoundInfoData2?.woundInfoKey : generateUniqueId(maxWoundRowIndex + 1);

            updatedWoundInfoData2 = {
                ...updatedWoundInfoData2,
                cptIds: (woundInfoData.cptIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
                eCodeIds: (woundInfoData.eCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),   
                iCodeIds: (woundInfoData.iCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
                lCodeIds: (woundInfoData.lCodeIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
                icdIds: (woundInfoData.icdIds || []).map(id => Number(id)).filter(id => !isNaN(id)),
                cpt: cptFormatted,
                eCode: woundInfoData.eCode? eCodesFormatted : '',
                iCode: woundInfoData.iCode? iCodesFormatted : '',
                lCode: woundInfoData.lCode? lCodesFormatted : '',
                icd10: icd10Formatted,
                otherDxCodes: woundInfoData.woundType === "Surgical Incision" ? icd10Formatted : woundInfoData.otherDxCodes,
                woundInfoKey: woundInfoKey,
                woundKeyDisplayValue: formatWoundName(woundInfoData.woundType, woundInfoKey)
            };
            if (currentWoundInfo) {
                const updatedWoundInfo = woundInfoRows.map((item) =>
                    item === currentWoundInfo ? updatedWoundInfoData2 : item
                );
                setWoundInfoRows(updatedWoundInfo);
                saveWoundInfoRows(updatedWoundInfo);
            } else {
                const newWoundRows = [...woundInfoRows, updatedWoundInfoData2]
                setWoundInfoRows(newWoundRows);
                saveWoundInfoRows(newWoundRows);
            }
            setShowWoundInfoPopup(false);
            setCurrentWoundInfo(null);
        }
    };

    const getWoundVolume = (wound: { length?: number | string; width?: number | string; depth?: number | string }) => {
        const length = Number(wound.length);
        const width = Number(wound.width);
        const depth = Number(wound.depth);
        if (isNaN(length) || isNaN(width) || isNaN(depth)) {
            return NaN;
        }
        return length * width * depth;
    };

    const calculatePatientWoundTotalSize = (woundInfo: WoundInfo[]) => {
        let totalValid = 0;
        woundInfo?.forEach((current) => {
            const volume = getWoundVolume(current);
            if (!isNaN(volume)) {
                totalValid += Math.round(volume * 100); //CS-1654
            }
        });
        totalValid = totalValid / 100; //CS-1654
        return totalValid;
    };

    const saveWoundInfoRows = async (woundInfoData: WoundInfo[], action?: string) => {
        const formattedWoundData = woundInfoData?.map(wound => {
            const {
                displayTotalSize,
                displayWoundDimensions,
                displayEstimateSurfaceArea,
                displayTotalWoundVolume,
                ...restWoundData
            } = wound;
            return restWoundData;
         });
        const woundInfo = {
            woundData: formattedWoundData,
            totalSizeOfAllWounds: calculatePatientWoundTotalSize(woundInfoData),
            maxWoundId: action === "DELETE" ? maxWoundRowIndex : maxWoundRowIndex + 1
        };

        if (patientEditDetails?.patientId && !isWoundInfoEdited) {
            const woundRequest: SaveWoundInfoRequest = {
                patientId: patientEditDetails.patientId,
                woundInfo: {
                    infoType: PATIENT_IVR_INFO_TYPES.WOUND_INFO,
                    isEdited: false,
                    patientinfoId: patientWoundInfo,
                    infoTypeData: {
                        woundInfo: woundInfo
                    }
                }
            }
            const res = await dispatch(saveWoundInfo(woundRequest));
            if (res) {
                if(res?.payload?.patientinfoId) {
                    setPatientWoundInfo(res?.payload?.patientinfoId);
                };
                setIsWoundInfoAlreadySaved(true);
            }
        }
    };

    useEffect(() => {
        const calculateTotalSize = () => {
            let totalValid = 0;
            let foundValidNumber = false;

            const woundData = woundInfoRows?.map((current) => {
                const volume = getWoundVolume(current);
                if (!isNaN(volume)) {
                    totalValid += Math.round(volume * 100); //CS-1654
                    foundValidNumber = true;
                }

                return {
                    woundType: current.woundType,
                    noOfApplications: current.noOfApplications,
                    cpt: current.cpt,
                    eCode: current.eCode,
                    iCode: current.iCode,
                    lCode: current.lCode,
                    otherDxCodes: current.otherDxCodes,
                    totalSize: current.totalSize?.toString(),
                };
            });
            totalValid = totalValid / 100; //CS-1654
            setValue("woundInfo.woundData", woundData);
            if (foundValidNumber) {
                setValue("woundInfo.totalSizeOfAllWounds", totalValid.toString());
            } else {
                setValue("woundInfo.totalSizeOfAllWounds", "");
            }
            trigger("woundInfo.totalSizeOfAllWounds");
            trigger("woundInfo.woundData");
        };

        calculateTotalSize();
    }, [woundInfoRows, setValue]);

    const handleEdit = () => {
        setShowInfoPopup({ message: "Change the Patient's name or DOB if you are sure. You are required to press SAVE button at the end of this form to confirm save changes.", show: true })
        setShowEditButton(false);
    }

    const checkPatientExistance = async (): Promise<boolean> => {
        const isCheckPatientRequiredFieldsFilled = !!getValues("practiceId") && !!getValues("patientInfo.FirstName") && !!getValues("patientInfo.LastName") && !!getValues("patientInfo.patientDOB");
        const isPatientDataEdited =
            getValues("patientInfo.FirstName").toLowerCase() !== patientCompleteData?.patientInfo?.FirstName?.toLowerCase() ||
            getValues("patientInfo.LastName").toLowerCase() !== patientCompleteData?.patientInfo?.LastName?.toLowerCase() ||
            getValues("patientInfo.patientDOB") !== patientCompleteData?.patientInfo?.patientDOB ||
            getValues("practiceId") !== patientCompleteData?.practiceId;

        if (location.state?.patientDetails && !isPatientDataEdited) {
            return false;
        }

        if (isCheckPatientRequiredFieldsFilled) {

            const dateOfBirth = getValues("patientInfo.patientDOB");
            const parsedDate = dayjs(dateOfBirth, "MM/DD/YYYY", true);

            if (!parsedDate.isValid()) {
                const alertObj: SingleAlertInfo = {
                    message: `Invalid date of Birth`,
                    alertType: "error",
                };
                dispatch(setSingleAlertObj(alertObj));
                return true;
            }

            const year = parsedDate.year();
            if (year < 1000 || year > new Date().getFullYear()) {
                const alertObj: SingleAlertInfo = {
                    message: `Invalid date of Birth`,
                    alertType: "error",
                };
                dispatch(setSingleAlertObj(alertObj));
                return true;
                
            }

            const formattedDate = parsedDate.format("MM/DD/YYYY");

            const data = {
                practiceId: Number(getValues('practiceId') ?? 0),
                firstName: getValues("patientInfo.FirstName"),
                lastName: getValues("patientInfo.LastName"),
                dateOfBirth: formattedDate
            }
            const response = await dispatch(checkPatientExist(data));
            if (response?.payload?.data?.message === "SUCCESS") {
                const patient = response?.payload?.data?.data;
                if (patient) {
                    const alertObj: SingleAlertInfo = {
                        message: `Patient ${patient.firstName + " " + patient.lastName} with DOB ${patient.birthDate}, already exists for the ${patient.practiceName}`,
                        alertType: "error",
                    };
                    dispatch(setSingleAlertObj(alertObj));
                    return true;
                }
            }
        }
        return false;
    }

    const onClickInfoPopup = () => {
        setShowInfoPopup({ message: "Change the Patient's name or DOB if you are sure. You are required to press SAVE button at the end of this form to confirm save changes.", show: false })
    }

    const handleClearSecondaryInsuranceData = useCallback(() => {
        setValue("insuranceInfo.secondaryInsuranceName", "");
        setValue("insuranceInfo.secondaryInsuranceCategory", ""); //Added secondary insurance category to clear the data
        setValue("insuranceInfo.secondaryInsurancePayerCode", "");
        setValue("insuranceInfo.secondaryPolicy", "");
        setValue("insuranceInfo.secondarypolicyholderFirstName", "");
        setValue("insuranceInfo.secondarypolicyholderMiddleName", "");
        setValue("insuranceInfo.secondarypolicyholderLastName", "");
        setValue("insuranceInfo.secondaryPolicyHolderDOB", "");
        setValue("insuranceInfo.secondaryInsuranceCards", []);
        setValue("insuranceInfo.isSecondaryInsuranceCardsSkipped", false);
        setUploadedSecondaryInsuranceFilesMetaData([]);
        dispatch(resetSecondaryInsuranceInfo());
        setIsSecondaryInsuranceInfoEdited(true);
    }, [dispatch, setValue]);

    const handleSecondaryInsuranceChange = () => {
        const newValue = !isSecondaryInsurance;
        setIsSecondaryInsurance(newValue);
        setIsSecondaryInsuranceInfoEdited(true);

        if (!newValue) {
            handleClearSecondaryInsuranceData();
        }
        checkInsuranceInfoValidity({ ...watch() });
    };
    const handleClick = () => {
        const newValue = !insuranceNameNotListed;
        setInsuranceNameNotListed(newValue);

    };
    const handleSecondaryInsuranceClick = () => {
        const newValue = !secondaryInsuranceNameNotListed;
        setSecondaryInsuranceNameNotListed(newValue);

    };

    const clickShowIncisionInfoPopup = () => {
        setShowIncisionInfoPopup(true);
    };

    useEffect(() => {
        const practiceId = getValues('practiceId');
        const practice = practiceByUserRoleOrderSlice?.find(practice => Number(practice.practiceId) === Number(practiceId));
        if (practice) {
            setSelectedPractice(practice);
            const requestId = ++practiceProvidersRequestRef.current;
            const requestedPracticeId = String(practice.practiceId);
            setPracticeProvidersLoadedFor(null);
            void Promise.resolve(
                dispatch(fetchActivePracticeProvidersData({ productId: practice.practiceId, onlyActiveRecords: true }))
            ).then(() => {
                if (practiceProvidersRequestRef.current !== requestId) return;
                setPracticeProvidersLoadedFor(requestedPracticeId);
            });
            setSelectedPracticeType(practice?.specialization || "");
        } else {
            setSelectedPractice(null);
            setSelectedPracticeType("");
            setPracticeProvidersLoadedFor(null);
        }
    }, [watch('practiceId'), practiceByUserRoleOrderSlice]);

    const practiceProvidersOptions = useMemo(() => {
        let options: { label: string; value: number }[] = [];
        practiceProvidersInfo?.map((option: any) => {
            options.push({
                label: `${option.title ? option.title : ""} ${option.firstName ? option.firstName : ""} ${option.middleName ? option.middleName + " " : ""
                    }${option.lastName ? option.lastName : ""}`,
                value: option.providerId,
            });
        });
        return options;
    }, [practiceProvidersInfo]);

    // Auto-select the only provider returned for the selected practice.
    // The provider query is already scoped to that practice, so the dropdown list is the source of truth.
    useEffect(() => {
        const practiceId = getValues("practiceId");
        if (
            practiceId == null ||
            practiceProvidersLoadedFor == null ||
            String(practiceId) !== String(practiceProvidersLoadedFor) ||
            practiceProvidersOptions.length !== 1
        ) {
            return;
        }

        const soleProviderId = practiceProvidersOptions[0].value;
        const currentProviderId = getValues("providerId");
        // The provider autocomplete writes "" when nothing is selected. That is still empty.
        if (currentProviderId != null && String(currentProviderId) !== "") {
            return;
        }

        setValue("providerId", soleProviderId);
        setPrevProviderId(soleProviderId);
        clearErrors("providerId");
        dispatch(getSurgicalTemplateBasedOnProvider(String(soleProviderId)));
        checkPatientInfoValidity(getValues());
    }, [practiceProvidersOptions, practiceProvidersLoadedFor, providerId, watch("practiceId")]);

    const practiceTypeChange = (prevType: string, newType: string) => {
        switch(newType) {
            case PRACTICE_TYPE.SURGICAL: {
                if(!prevType || prevType === PRACTICE_TYPE.WOUND_CARE || prevType === PRACTICE_TYPE.WOUND_CARE_AND_SURGICAL) {
                    return true;
                }
                return false;
            }
            case PRACTICE_TYPE.WOUND_CARE: {
                if (prevType === PRACTICE_TYPE.SURGICAL || prevType === PRACTICE_TYPE.WOUND_CARE_AND_SURGICAL) {
                    return true;
                }
                return false;
            }
            case PRACTICE_TYPE.WOUND_CARE_AND_SURGICAL: {
                return false;
            }
            default: {
                return false;
            }
        }   
    };

    const handlePracticeChange = (e: any) => {
        setValue('providerId', null);
        setPrevProviderId(null);
        setValue('providerTemplateId', null);
        setPrevProviderTemplateId(null);
        setValue('dateOfSurgery', "");
        checkPatientInfoValidity({ ...watch() });

        const prevPracticeType = selectedPracticeType;
        const prevPractice = selectedPractice;
        const practice = practiceByUserRoleOrderSlice?.find(practice => Number(practice.practiceId) === Number(e.value));

        const isTypeChange = practiceTypeChange(prevPracticeType, practice?.specialization || "");

        if(isTypeChange && woundInfoRows?.length > 0) {
        setShowOptionsPopup({
            message: "All Wound data will be cleared. Do You Really want to change the practice? ",
            show: true,
            variant: "confirm",
            buttons: [{ name: "Confirm", color: 'primary', onClick: () =>  confirmPracticeOptionPopup() }, { name: "Cancel", color: 'secondary', onClick: () => cancelPracticeOptionPopup(prevPractice?.practiceId || "") }]
        });
        }
    };

    const cancelPracticeOptionPopup = (practiceId: string) => {
        setShowOptionsPopup({ message: "", show: false });
        if(practiceId) {
            setValue('practiceId', Number(practiceId))
        } else {
            setValue('practiceId', null);
        }
    };

    const confirmPracticeOptionPopup = async () => {
        setWoundInfoRows([]);
        setShowOptionsPopup({ message: "", show: false });
        if (patientEditDetails?.patientId) {
            const response = await dispatch(inactivatePatientWoundInfo(patientEditDetails.patientId));
            if (response?.payload === RESPONSE_CODES.SUCCESS_CODE) {
                let alertMessage = "Wound data successfully from patient.";
                const alertObj: SingleAlertInfo = {
                    message: alertMessage,
                    alertType: "success",
                };
                dispatch(setSingleAlertObj(alertObj));
            }
        }
    };

    const providerTemplateConfirmation = () => {
        if(!(getValues('providerTemplateId') && woundInfoRows?.length > 0)){
            setPrevProviderTemplateId(getValues('providerTemplateId') || null);
            handleProviderTemplateChange();
            checkPatientInfoValidity({ ...watch() });
        } else {
            setShowOptionsPopup({
                show: true,
                variant: "error",
                message: (
                    <>
                        <strong>Changing Provider Template will erase all incision data.</strong>
                    </>
                ),
                buttons: [
                    {
                        name: "OK",
                        color: "success",
                        onClick: () => {
                            handleProviderTemplateChange();
                        },
                    },
                    {
                        name: "Cancel",
                        color: "error",
                        onClick: () => {
                            // setWoundInfoRows(prevWoundInfoRows);
                            setValue('providerTemplateId', prevProviderTemplateId);
                            setShowOptionsPopup({ show: false, message: "" });
                        },
                    },
                ],
            });
        }

    }

    const handleProviderTemplateChange = () => {
        fetchProviderTemplateData(getValues('providerTemplateId'), false);
        checkPatientInfoValidity({ ...watch() });
        setPrevProviderTemplateId(getValues('providerTemplateId') || null);
        setShowOptionsPopup({ show: false, message: "" });
    };

    return (
        <>
        {/* CS-1758 - Facesheet Extraction Result Popup */}
        {showFacesheetExtractionPopup && (
            <FacesheetExtractionPopup
                open={showFacesheetExtractionPopup}
                onClose={() => {
                    setShowFacesheetExtractionPopup(false);
                    setSelectedFacesheetReportData(null);
                    setSelectedFacesheetReportDocumentId(null);
                }}
                initialFacesheetData={selectedFacesheetReportData}
                patientId={patientInfoObject?.patientId || null}
                documentId={selectedFacesheetReportDocumentId}
            />
        )}
        {/* CS-1758 - Warn before closing the unsaved facesheet-created patient form */}
        {showFacesheetCancelWarning && (
            <ConfirmationActionModal
                open={showFacesheetCancelWarning}
                onClose={() => setShowFacesheetCancelWarning(false)}
                onConfirm={() => {
                    setShowFacesheetCancelWarning(false);
                    handleCancelNavigation();
                }}
                title="Warning"
                subtitle="Unsaved patient form"
                message={
                    <>
                        Are you sure you want to leave this page without saving? Any unsaved patient details will be lost.
                    </>
                }
                confirmText="OK"
                cancelText="Cancel"
                headerIcon={<WarningAmber sx={{ color: "orange" }} />}
                showCancelButton={true}
            />
        )}
        <Box sx={{
            margin: {
                xs: "20px 10px",
                sm: "20px",
            },
        }}>
            {showOptionPopup.show &&
                <OptionsPopup
                    open={showOptionPopup.show}
                    onClose={() => setShowOptionsPopup({ message: "", show: false })}
                    variant={showOptionPopup.variant}
                    message={<>{showOptionPopup.message}</>}
                    buttons={showOptionPopup.buttons}
                    title={showOptionPopup.title}
                    obj={showOptionPopup.obj}
                />
            }
            {showWoundInfoPopup &&
                <IVRFormWoundInfoPopup
                    open={showWoundInfoPopup}
                    onClose={() => {
                        setShowWoundInfoPopup(false);
                        setCurrentWoundInfo(null);
                    }}
                    currentWoundInfo={currentWoundInfo}
                    onAddWoundInfo={handleAddWoundInfo}
                    from={CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT}
                />}

            {showInfoPopup.show &&
                <InfoPopup
                    open={showInfoPopup.show}
                    onClose={() => setShowInfoPopup({ message: "", show: false })}
                    content={showInfoPopup.message}
                    severity="info"
                    title="Confirm Patient Changes"
                />
            }

            {showIncisionInfoPopup &&
                <IVRFormIncisionInfoPopup
                    open={showIncisionInfoPopup}
                    onClose={() => {
                        setShowIncisionInfoPopup(false);
                        setCurrentWoundInfo(null);
                    }}
                    currentIncisionInfo={currentWoundInfo}
                    onAddIncisionInfo={handleAddWoundInfo}
                    from={CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT}
                />
            }

            <Box mb={2} display="flex" alignItems="flex-start" gap={1.5}>
                <PageBackButton tooltip={null} />
                <Box>
                    <Typography
                        sx={{
                            fontSize: "0.7rem",
                            fontWeight: 700,
                            color: mTokens.textSecondary,
                            textTransform: "uppercase",
                            letterSpacing: "0.12em",
                            mb: 0.3,
                        }}
                    >
                        Operations / Patients
                    </Typography>
                    <Typography
                        component="h1"
                        sx={{
                            fontSize: "1.6rem",
                            fontWeight: 800,
                            color: mTokens.textPrimary,
                            lineHeight: 1.1,
                        }}
                    >
                        {patientEditDetails?.isPatientEdit ? "Patient Edit" : "Patient Registration"}
                    </Typography>
                </Box>
            </Box>
            <Box mb="20px">
                    <Box sx={{ mb: 2 }}>
                        <StickTopStepper
                            activeStep={activeStep}
                            setActiveStep={setActiveStep}
                            steps={steps}
                            isViewMobile={false}
                        />
                    </Box>
                    <form onSubmit={handleSubmit(onSubmit, onError)} autoComplete="off">
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                            <Box ref={patientInformationRef} sx={cardSx} data-testid="bordered-section">
                                <SectionHeader
                                    icon={<PersonOutlineOutlined fontSize="small" />}
                                    title="Patient Information"
                                    onHeaderClick={() => setPatientInfoExpanded(!patientInfoExpanded)}
                                    action={
                                        <IconButton
                                            size="small"
                                            aria-label={patientInfoExpanded ? "Collapse section" : "Expand section"}
                                            onClick={(e) => { e.stopPropagation(); setPatientInfoExpanded(!patientInfoExpanded); }}
                                            sx={collapseToggleSx}
                                        >
                                            {patientInfoExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                                        </IconButton>
                                    }
                                />
                                <Collapse in={patientInfoExpanded}>
                                <Box sx={sectionBodySx}>
                                    <Box sx={{ padding: 2, borderRadius: 3, border: `1px solid ${mTokens.border}` }}>
                                        <Grid container spacing={2}>
                                            <Grid item md={2.5} xs={12}>
                                                <FieldLabel label="Practice Name" required />
                                                <Box sx={dropdownFieldWrapSx(!!errors?.practiceId)}>
                                                    <CustomDropdownField
                                                        control={control}
                                                        name="practiceId"
                                                        label=""
                                                        size="small"
                                                        options={practiceOptions}
                                                        rules={{ required: 'Practice is required.' }}
                                                        onChangeSelect={handlePracticeChange}
                                                        onBlur={() => checkPatientExistance()}
                                                        disabled={practiceOptions?.length === 1}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item md={8.5} xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={4}>
                                                        <FieldLabel label="First Name" required />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FieldLabel label="Middle Name" />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FieldLabel label="Last Name" required />
                                                    </Grid>
                                                </Grid>
                                                <Box sx={textFieldWrapSx(!!(errors?.patientInfo?.FirstName || errors?.patientInfo?.LastName))}>
                                                    <CustomNametField
                                                        control={control}
                                                        name="patientInfo"
                                                        // context="Patient"
                                                        xs={12}
                                                        size="small"
                                                        isRequired={true}
                                                        label=""
                                                        usePlaceholder={true}
                                                        onChange={() => {
                                                            setNameChange(true);
                                                            checkPatientInfoValidity({ ...watch() });
                                                        }}
                                                        onBlur={() => checkPatientExistance()}
                                                    />
                                                </Box>
                                            </Grid>
                                            {/* <Grid item sx={{ display: "flex", alignItems: "center" }} xs={12} md={1}>
                                            {showEditButton && (
                                                <CustomIconButton
                                                    sx={{ ml: 2 }}
                                                    color="info"
                                                    onClick={() => {
                                                        setDisablePatientName(false);
                                                        checkPatientInfoValidity({ ...watch() });
                                                        handleEdit();
                                                    }}
                                                >
                                                    <ModeOutlined />
                                                </CustomIconButton>
                                            )}
                                            </Grid> */}
                                        </Grid>
                                        <Grid container spacing={2} alignItems="flex-start" sx={{ paddingTop: "15px" }}>
                                            <Grid item md={2} xs={12}>
                                                <FieldLabel label="DOB" required />
                                                <Box sx={dateFieldWrapSx(!!errors?.patientInfo?.patientDOB)}>
                                                    <CustomDatePicker
                                                        controllerName={`patientInfo.${"patientDOB"}`}
                                                        control={control}
                                                        label=""
                                                        size="small"
                                                        rules={{ required: "Patient's DOB is required." }}
                                                        onChange={(e) => {
                                                            handleBirthDayChange(e);
                                                            checkPatientInfoValidity({ ...watch() });
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>

                                            {!isMobile && (
                                                <Grid item md={1}></Grid>
                                            )}

                                            <Grid item md={3} xs={12}>
                                                <FieldLabel label="Gender" required />
                                                <CustomRadioButton
                                                    controllerName={`patientInfo.${"gender"}`}
                                                    control={control}
                                                    options={patientGenderOptions}
                                                    rules={{ required: "Gender is required." }}
                                                    onChange={() => {
                                                        checkPatientInfoValidity({ ...watch() })
                                                        checkPatientExistance()
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} alignItems="flex-start" sx={{ paddingTop: "15px" }}>
                                            {
                                                (selectedPracticeType !== PRACTICE_TYPE.WOUND_CARE) &&
                                                <Grid item md={2} xs={12}>
                                                    <FieldLabel label="Date of Surgery" />
                                                    <Box sx={dateFieldWrapSx(!!errors?.dateOfSurgery)}>
                                                        <CustomDatePicker
                                                            controllerName={`dateOfSurgery`}
                                                            control={control}
                                                            label=""
                                                            size="small"
                                                            onChange={(e) => {
                                                                handleDateOfSurgeryChange(e);
                                                                checkPatientInfoValidity({ ...watch() });
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>}

                                            <Grid item md={3} xs={12}>
                                                <FieldLabel label="Provider" required />
                                                <Box sx={dropdownFieldWrapSx(!!errors?.providerId)}>
                                                    <CustomDropdownField
                                                        name={`providerId`}
                                                        control={control}
                                                        options={practiceProvidersOptions}
                                                        label=""
                                                        size="small"
                                                        rules={{ required: "Provider is required." }}
                                                        onChangeSelect={(e) => {
                                                            providerChangeConfirmation(e);
                                                            checkPatientInfoValidity({ ...watch() });
                                                        }}
                                                        disabled={!selectedPractice}
                                                    />
                                                </Box>
                                            </Grid>
                                            {/* CS-1244 - Start */}
                                            {surgicalTemplateOptionData && surgicalTemplateOptionData?.length > 0 && (
                                                <Grid item md={3} xs={12}>
                                                    <FieldLabel label="Provider Template" />
                                                    <Box sx={dropdownFieldWrapSx(!!errors?.providerTemplateId)}>
                                                        <CustomDropdownField control={control} options={surgicalTemplateOptionData || []} label=""
                                                            size="small"
                                                            // rules={getValues("isAutoIVREnabled") ? { required: "Surgical Template is required." } : {}}
                                                            // disabled={!getValues("providerId")}
                                                            onChangeSelect={(e) => {
                                                                providerTemplateConfirmation();
                                                            }}
                                                            sortOptions={true}
                                                            name={"providerTemplateId"} />
                                                    </Box>
                                                </Grid>
                                            )}
                                            {/* CS-1244 - End */}
                                        </Grid>
                                    </Box>
                                    <Grid container spacing={2}>
                                        <Grid item md={12} xs={12} mt={1}>
                                            <Typography sx={{ fontSize: "0.92rem", fontWeight: 700, color: mTokens.textPrimary }}>Address</Typography>
                                        </Grid>

                                       <Grid item md={12} xs={12}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={4}>
                                                    <FieldLabel label="Street Address" required />
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FieldLabel label="Unit Number" />
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FieldLabel label="City" required />
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FieldLabel label="State" required />
                                                </Grid>
                                                <Grid item xs={12} md={2}>
                                                    <FieldLabel label="Zip Code" required />
                                                </Grid>
                                            </Grid>
                                            <Box sx={textFieldWrapSx(!!(errors?.patientInfo?.StreetAddress || errors?.patientInfo?.City || errors?.patientInfo?.State || errors?.patientInfo?.Zipcode))}>
                                                <CustomAddressTextField
                                                    control={control}
                                                    name="patientInfo"
                                                    useAutoComplete={true}
                                                    setValue={setValue}
                                                    // context="Patient"
                                                    size="small"
                                                    isRequired = {true}
                                                    usePlaceholder={true}
                                                    onChange={() => { checkPatientInfoValidity({ ...watch() });trigger(['patientInfo.City','patientInfo.Zipcode','patientInfo.State'])}} //CS-1335
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item md={3} xs={12} >
                                            <FieldLabel label="Email" />
                                            <Box sx={textFieldWrapSx(!!errors?.patientInfo?.patientEmail)}>
                                                <CustomTextField
                                                    control={control}
                                                    controllerName={`patientInfo.${"patientEmail"}`}
                                                    label=""
                                                    size="small"
                                                    rules={{
                                                        pattern: {
                                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                                                            message: "Invalid email.",
                                                        },
                                                    }}
                                                // isDisabled={disablePatientName}
                                                />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} mt={1}>
                                        <Grid item md={3} xs={12} mb={1}>
                                            <FieldLabel label="FaceSheet" required />
                                            <Dropzone
                                                control={control}
                                                rules={{ required: 'FaceSheet is required.' }}
                                                name={`patientInfo.${"faceSheet"}`}
                                                onFileChange={handleFaceSheetChange}
                                                //isDisabled={getValues("patientInfo.isFaceSheetSkipped") === true}
                                                isDisabled={false}
                                                label=""
                                                onDeleteFile={handleDeleteFacesheetDocument}
                                                holdOnChange={true}
                                                initialFilesMetaData={uploadedFacesheetFilesMetaData}
                                                // CS-1758 - Show "View Extraction Result" button inline with uploaded facesheet file
                                                renderExtraFileAction={
                                                    (file) => {
                                                        const fileDocumentId = file.documentId ? String(file.documentId) : "";
                                                        const facesheetDataFromLocationState =
                                                            location.state?.patientDetails?.facesheetDocumentId &&
                                                            String(location.state?.patientDetails?.facesheetDocumentId) === fileDocumentId
                                                                ? location.state?.patientDetails?.facesheetData
                                                                : null;
                                                        const facesheetAuditData =
                                                            auditDataByDocument.get(fileDocumentId) ||
                                                            facesheetDataFromLocationState;
                                                        //CS-1758 : Added token for facesheet extraction report access
                                                        if (!hasAccessToFacesheetExtractionReport || !facesheetAuditData) {
                                                            return null;
                                                        }

                                                        return (
                                                            <Tooltip title="Facesheet Report" placement="top" arrow>
                                                                <IconButton
                                                                    onClick={(e: React.MouseEvent) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();

                                                                        if (facesheetDataFromLocationState) {
                                                                            setSelectedFacesheetReportData(facesheetDataFromLocationState);
                                                                            setSelectedFacesheetReportDocumentId(
                                                                                file.documentId ? Number(file.documentId) : null
                                                                            );
                                                                            setShowFacesheetExtractionPopup(true);
                                                                            return;
                                                                        }

                                                                        handleOpenFacesheetReport(
                                                                            facesheetAuditData,
                                                                            file.documentId ? Number(file.documentId) : null
                                                                        );
                                                                    }}
                                                                    sx={{
                                                                        width: 35,
                                                                        height: 35,
                                                                        minWidth: 35,
                                                                        minHeight: 35,
                                                                        margin: "10px 5px 5px 5px",
                                                                        padding: 0,
                                                                        flexShrink: 0,
                                                                        alignSelf: "center",
                                                                        boxSizing: "border-box",
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        borderRadius: "5px",
                                                                        background: "transparent",
                                                                        border: `1px solid ${theme.palette.success.main}`,
                                                                        color: theme.palette.success.main,
                                                                        transition: "background-color 0.2s ease",
                                                                        "&:hover": {
                                                                            backgroundColor:
                                                                                theme.palette.mode === "dark"
                                                                                    ? "rgba(76, 175, 80, 0.14)"
                                                                                    : "rgba(76, 175, 80, 0.08)",
                                                                            border: `1px solid ${theme.palette.success.main}`,
                                                                        },
                                                                    }}
                                                                >
                                                                    <VisibilityOutlined sx={{ fontSize: 20, display: "block" }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )
                                                    }
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        {getValues("patientInfo.faceSheet")===undefined || (getValues("patientInfo.faceSheet") && getValues("patientInfo.faceSheet").length === 0) ?
                                            <Grid item md={12} xs={12}>
                                                <CustomCheckbox
                                                    control={control}
                                                    label="I acknowledge the information is on file, and not available for upload at this time."
                                                    controllerName={`patientInfo.${"isFaceSheetSkipped"}`}
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            clearErrors('patientInfo.faceSheet');
                                                            const faceSheetDocumentIds = getValues("patientInfo.faceSheet");
                                                            // Check if supportingDocsIds exists and has values before mapping
                                                            if (faceSheetDocumentIds && faceSheetDocumentIds.length > 0) {
                                                                const removePromises = faceSheetDocumentIds.map((id) =>
                                                                    dispatch(removeIVRDocument(id.toString()))
                                                                );
                                                            }
                                                            setValue("patientInfo.faceSheet", []);
                                                            setUploadedFacesheetFilesMetaData([]);
                                                        } else {
                                                            trigger('patientInfo.faceSheet');
                                                        }
                                                        checkPatientInfoValidity({ ...watch() });
                                                    }}
                                                // isDisabled={disablePatientName}
                                                />
                                            </Grid>
                                            : ""}
                                    </Grid>
                                </Box>
                                </Collapse>
                            </Box>

                            <Box ref={insuranceInformationRef} sx={cardSx} data-testid="bordered-section">
                                <SectionHeader
                                    icon={<HealthAndSafetyOutlined fontSize="small" />}
                                    title="Insurance Information"
                                    onHeaderClick={() => setInsuranceInfoExpanded(!insuranceInfoExpanded)}
                                    action={
                                        <IconButton
                                            size="small"
                                            aria-label={insuranceInfoExpanded ? "Collapse section" : "Expand section"}
                                            onClick={(e) => { e.stopPropagation(); setInsuranceInfoExpanded(!insuranceInfoExpanded); }}
                                            sx={collapseToggleSx}
                                        >
                                            {insuranceInfoExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                                        </IconButton>
                                    }
                                />
                                <Collapse in={insuranceInfoExpanded}>
                                <Box sx={sectionBodySx}>
                                    <Grid container spacing={2}>
                                        <Grid item md={12} xs={12}>
                                            <Typography sx={{ fontSize: "0.92rem", fontWeight: 700, color: mTokens.textPrimary }}>Primary Insurance</Typography>
                                        </Grid>
                                        <Grid
                                           item md={2} xs={12}
                                        >
                                            <FieldLabel label="Category" required />
                                            <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.insuranceCategory)}>
                                            <CustomDropdownField
                                                control={control}
                                                name={`insuranceInfo.${"insuranceCategory"}`}
                                                options={insuranceCategory}
                                                sortOptions={false}
                                                label=""
                                                size="small"
                                                onChangeSelect={(data) => {
                                                    if (data) {
                                                        // CS-1758 - When in facesheet flow, check if the selected category has
                                                        // cached AI-extracted data and restore it instead of clearing
                                                        const selectedCategory = data.value;
                                                        const cachedPrimary = createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET
                                                            ? facesheetPrimaryInsuranceCacheRef.current[selectedCategory]
                                                            : null;

                                                        if (cachedPrimary) {
                                                            // CS-1758 - Restore facesheet-extracted primary insurance values for this category
                                                            setValue("insuranceInfo.insuranceName", cachedPrimary.insuranceName || '');
                                                            setValue("insuranceInfo.insurancePayerCode", cachedPrimary.insurancePayerCode || '');
                                                            setValue("insuranceInfo.primaryCommercialInsuranceName", cachedPrimary.primaryCommercialInsuranceName || '');
                                                            setInsuranceNameNotListed(cachedPrimary.insuranceNameNotListed || false);
                                                            setValue("insuranceInfo.insuranceNameNotListed", cachedPrimary.insuranceNameNotListed || false);
                                                            if (cachedPrimary.policy) setValue("insuranceInfo.policy", cachedPrimary.policy);
                                                            // CS-1758 - Restore subscriber/policyholder info from cache
                                                            if (cachedPrimary.isPolicyUnderDifferentName && cachedPrimary.subscriberName) {
                                                                setValue("insuranceInfo.isPolicyUnderDifferentName", true);
                                                                setIsPolicyUnderDifferentNameCheck(true);
                                                                const nameParts = cachedPrimary.subscriberName.trim().split(/\s+/).filter(Boolean);
                                                                if (nameParts.length >= 1) setValue("insuranceInfo.policyholderFirstName", nameParts[0]);
                                                                if (nameParts.length === 2) setValue("insuranceInfo.policyholderLastName", nameParts[1]);
                                                                if (nameParts.length >= 3) {
                                                                    setValue("insuranceInfo.policyholderMiddleName", nameParts.slice(1, -1).join(" "));
                                                                    setValue("insuranceInfo.policyholderLastName", nameParts[nameParts.length - 1]);
                                                                }
                                                            }
                                                            // CS-1758 - Clear validation errors on restored fields so stale required errors disappear
                                                            clearErrors("insuranceInfo.primaryCommercialInsuranceName");
                                                            clearErrors("insuranceInfo.policy");
                                                            clearErrors("insuranceInfo.insurancePayerCode");
                                                        } else {
                                                            // CS-1758 - Normal reset for categories without cached facesheet data
                                                            setValue("insuranceInfo.insuranceName", '')
                                                            setValue("insuranceInfo.insurancePayerCode", '')
                                                            setValue("insuranceInfo.primaryCommercialInsuranceName", '')
                                                        }
                                                    }
                                                }}
                                               rules={{ required: "Category is required." }}
                                               disabled={false}
                                            />
                                            </Box>
                                        </Grid>
                                        <Grid item md={2} xs={12}>
                                        {/* <CustomTextField
                                                controllerName={`insuranceInfo.${"insuranceName"}`}
                                                control={control}
                                                label="Insurance Name"
                                                rules={{
                                                    validate: (value: any) => {
                                                        if (submitAction === "submitAction" && !value) {
                                                        return "Insurance Name is required.";
                                                        }
                                                        return true;
                                                    }
                                                }}
                                                onChange={() => { checkInsuranceInfoValidity({ ...watch() });}}
                                            /> */}
                                            <FieldLabel label="Plan" required />
                                            <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.insurancePayerCode)}>
                                            <CustomDropdownField
                                                control={control}
                                                name={`insuranceInfo.${"insurancePayerCode"}`}
                                                label=""
                                                size="small"
                                                options={primaryPayersOptions}
                                                sortOptions={false}
                                                onChangeSelect={(data) => {
                                                    // CS-1758 - When in facesheet flow and user re-selects the cached plan,
                                                    // restore all related fields (policy, subscriber, commercial plan name)
                                                    const currentCategory = getValues('insuranceInfo.insuranceCategory');
                                                    const cachedPrimary = createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET
                                                        ? facesheetPrimaryInsuranceCacheRef.current[currentCategory]
                                                        : null;
                                                    const isCachedPlan = cachedPrimary
                                                        && String(cachedPrimary.insurancePayerCode) === String(data?.value);

                                                    if (isCachedPlan) {
                                                        // CS-1758 - Restore all facesheet-extracted primary insurance fields for this plan
                                                        setValue("insuranceInfo.insuranceName", cachedPrimary.insuranceName || '');
                                                        setValue("insuranceInfo.insurancePayerCode", cachedPrimary.insurancePayerCode || '');
                                                        setValue("insuranceInfo.primaryCommercialInsuranceName", cachedPrimary.primaryCommercialInsuranceName || '');
                                                        setInsuranceNameNotListed(cachedPrimary.insuranceNameNotListed || false);
                                                        setValue("insuranceInfo.insuranceNameNotListed", cachedPrimary.insuranceNameNotListed || false);
                                                        if (cachedPrimary.policy) setValue("insuranceInfo.policy", cachedPrimary.policy);
                                                        if (cachedPrimary.isPolicyUnderDifferentName && cachedPrimary.subscriberName) {
                                                            setValue("insuranceInfo.isPolicyUnderDifferentName", true);
                                                            setIsPolicyUnderDifferentNameCheck(true);
                                                            const nameParts = cachedPrimary.subscriberName.trim().split(/\s+/).filter(Boolean);
                                                            if (nameParts.length >= 1) setValue("insuranceInfo.policyholderFirstName", nameParts[0]);
                                                            if (nameParts.length === 2) setValue("insuranceInfo.policyholderLastName", nameParts[1]);
                                                            if (nameParts.length >= 3) {
                                                                setValue("insuranceInfo.policyholderMiddleName", nameParts.slice(1, -1).join(" "));
                                                                setValue("insuranceInfo.policyholderLastName", nameParts[nameParts.length - 1]);
                                                            }
                                                        }
                                                        // CS-1758 - Clear validation errors on restored fields
                                                        clearErrors("insuranceInfo.primaryCommercialInsuranceName");
                                                        clearErrors("insuranceInfo.policy");
                                                        checkInsuranceInfoValidity({ ...watch() });
                                                    } else if (getValues('insuranceInfo.insuranceName')) {

                                                        setValue("insuranceInfo.insuranceName", data?.label);
                                                        setValue("insuranceInfo.insurancePayerCode", data?.value);
                                                        if (getValues("insuranceInfo.insuranceCategory") === "Commercial" && data?.label === "Other") {

                                                            setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                                            checkInsuranceInfoValidity({ ...watch() });
                                                        } else if (getValues("insuranceInfo.insuranceCategory") !== "Commercial" && data?.label) {

                                                            setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                                            setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                                            checkInsuranceInfoValidity({ ...watch() });
                                                        } else {

                                                            setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                                            setValue(`insuranceInfo.${"primaryCommercialInsuranceName"}`, '');
                                                            setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                                            checkInsuranceInfoValidity({ ...watch() });
                                                        }
                                                    } else {

                                                        if (getValues("insuranceInfo.insuranceCategory") === "Commercial" && data?.label === "Other") {

                                                            setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                                            checkInsuranceInfoValidity({ ...watch() });
                                                        } else if (getValues("insuranceInfo.insuranceCategory") !== "Commercial" && data?.label) {
                                                            setValue(`insuranceInfo.${"insuranceName"}`, data?.label);

                                                            setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                                            checkInsuranceInfoValidity({ ...watch() });
                                                        } else {

                                                            setValue(`insuranceInfo.${"insuranceName"}`, data?.label);
                                                            setValue(`insuranceInfo.${"primaryCommercialInsuranceName"}`, '');
                                                            setValue(`insuranceInfo.${"insurancePayerCode"}`, data?.value);
                                                            checkInsuranceInfoValidity({ ...watch() });
                                                        }
                                                    }


                                                }}
                                                // rules={{
                                                //     validate: (value: any) => {
                                                //         if (submitAction === "submitAction" && !getValues("insuranceInfo.insuranceName")) {
                                                //             return "Insurance Name is required.";
                                                //         }
                                                //         return true;
                                                //     }
                                                // }}
                                                // CS-1335 Start
                                                // CS-1758 - Surface required plan validation during the facesheet auto-fill flow without waiting for Save
                                                rules={{
                                                            required:
                                                            (submitAction === "submitAction" || showFacesheetValidation) &&
                                                            watch('insuranceInfo.insuranceCategory') &&
                                                            primaryPayersOptions?.length !== 1
                                                                ? "Plan is required."
                                                                : false
                                                }}
                                                // CS-1335 End

                                                disabled={!watch('insuranceInfo.insuranceCategory') || primaryPayersOptions?.length === 1}
                                            />
                                            </Box>
                                        </Grid>

                                        <Grid item md={2} xs={12}>
                                            <FieldLabel label="Policy #" required />
                                            <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.policy)}>
                                            <CustomTextField
                                                controllerName={`insuranceInfo.${"policy"}`}
                                                control={control}
                                                label=""
                                                size="small"
                                                inputProps={{ maxLength:watch('insuranceInfo.insuranceCategory')==="Medicare" && 11, style: { textTransform: 'uppercase' } }}
                                                // CS-1335 Start
                                                rules={{
                                                    // CS-1758 - Reuse submit-time policy validation when the user comes from facesheet extraction
                                                    validate: (value: any) => {
                                                        const isMedicare = watch('insuranceInfo.insuranceCategory') === "Medicare";
                                                        const shouldValidatePolicy = submitAction === "submitAction" || showFacesheetValidation;

                                                        if (shouldValidatePolicy && isMedicare) {
                                                            return validateMedicarePolicyNumber(value);
                                                        } else if (shouldValidatePolicy) {
                                                            if (!value) return "Policy # is required.";                                           
                                                        }

                                                        return true;
                                                    }
                                                }}
                                                // CS-1335 End
                                                onChange={() => { checkInsuranceInfoValidity({ ...watch() }); }}
                                            />
                                            </Box>
                                        </Grid>
                                        {(watch("insuranceInfo.primaryCommercialInsuranceName") ||
                                            (getValues("insuranceInfo.insuranceCategory") === "Commercial" && watch("insuranceInfo.insuranceName") === "Other")) && (
                                            <Grid item md="auto" xs={12}>
                                                <Box display="flex" alignItems="flex-start" gap={1}>
                                                    <Grid xs={6} md="auto">
                                                    <Typography sx={{ ...inlineLabelSx, mt: 3.2 }}>Plan:</Typography>
                                                    </Grid>
                                                    <Grid xs={6} md={10}>
                                                    <FieldLabel label="Plan" />
                                                    <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.primaryCommercialInsuranceName)}>
                                                    <CustomTextField
                                                        controllerName={`insuranceInfo.${"primaryCommercialInsuranceName"}`}
                                                        control={control}
                                                        label=""
                                                        size="small"
                                                        rules={{
                                                            // CS-1758 - Show the "Other" commercial plan requirement as soon as facesheet data is loaded
                                                            validate: (value: any) => {
                                                                if ((submitAction === "submitAction" || showFacesheetValidation) && !value) {
                                                                    return "Plan is required.";
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                        onChange={() => { checkInsuranceInfoValidity({ ...watch() }); }}
                                                    />
                                                    </Box>
                                                    </Grid>
                                                </Box>

                                            </Grid>
                                        )}
                                        <Grid
                                            item
                                            md={12}
                                            xs={12}
                                            sx={{
                                                display: {
                                                    xs: "block",
                                                    md: "flex",
                                                },
                                                alignItems: {
                                                    md: "center",
                                                },
                                            }}
                                        >
                                            <Typography sx={inlineLabelSx}>Plan is NOT listed</Typography>
                                            <CustomCheckbox
                                                control={control}
                                                label="Yes"
                                                name="insuranceNameNotListed"
                                                id="insuranceNameNotListed"
                                                controllerName={`insuranceInfo.${"insuranceNameNotListed"}`}
                                                checked={insuranceNameNotListed}
                                                onChange={() => { handleClick() }}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            md={12}
                                            xs={12}
                                            sx={{
                                                display: {
                                                    xs: "block",
                                                    md: "flex",
                                                },
                                                alignItems: {
                                                    md: "center",
                                                },
                                            }}
                                        >
                                            <Typography sx={inlineLabelSx}>
                                                Is the policy under a different name?
                                            </Typography>
                                            <CustomRadioButton
                                                control={control}
                                                options={policyOptions}
                                                controllerName={`insuranceInfo.${"isPolicyUnderDifferentName"}`}
                                                onChange={() => {
                                                    setInsurancePolicyNameChange();
                                                    checkInsuranceInfoValidity({ ...watch() });
                                                }}
                                                rules={{
                                                    required:
                                                        "Is the policy under a different name is required.",
                                                }}
                                            />
                                        </Grid>
                                        {isPolicyUnderDifferentNameCheck ? (
                                            <>
                                                <Grid item md={12} xs={12}>
                                                    <FieldLabel label="Policy Holder" required />
                                                    <Box sx={textFieldWrapSx(!!(errors?.insuranceInfo?.policyholderFirstName || errors?.insuranceInfo?.policyholderLastName))}>
                                                    <CustomNametField
                                                        control={control}
                                                        name="insuranceInfo"
                                                        context="policyHolder"
                                                        label="Policy Holder"
                                                        size="small"
                                                        usePlaceholder={true}
                                                        // CS-1335 Start
                                                        isRequired={isPolicyUnderDifferentNameCheck}
                                                        // CS-1335 End
                                                        onChange={() => { checkInsuranceInfoValidity({ ...watch() }); }}
                                                    />
                                                    </Box>
                                                </Grid>
                                                <Grid item md={2} xs={12}>
                                                    <FieldLabel label="Policy Holder DOB" required />
                                                    <Box sx={dateFieldWrapSx(!!errors?.insuranceInfo?.policyHolderDOB)}>
                                                    <CustomDatePicker
                                                        control={control}
                                                        controllerName={`insuranceInfo.${"policyHolderDOB"}`}
                                                        label=""
                                                        size="small"
                                                        rules={{
                                                            required: "Policy Holder DOB is required.", // CS-1335
                                                            validate: (value: any) => {
                                                                if (submitAction === "submitAction" && !value) {
                                                                    return "Policy Holder DOB is required.";
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                        onChange={() => { checkInsuranceInfoValidity({ ...watch() }); }}
                                                    />
                                                    </Box>
                                                </Grid>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </Grid>
                                    <Grid container spacing={2} mt={1}>
                                        <Grid item md={3} xs={12} mb={2}>
                                            <FieldLabel label="Insurance Cards" required />
                                            <Dropzone
                                                control={control}
                                                rules={{ required: "Insurance Cards are required." }}
                                                name={`insuranceInfo.${"insuranceCards"}`}
                                                onFileChange={handleInsuranceCardChange}
                                                label=""
                                                onDeleteFile={handleDeleteInsuranceDocument}
                                                holdOnChange={true}
                                                initialFilesMetaData={uploadedPrimaryInsuranceFilesMetaData}
                                                //isDisabled={getValues("insuranceInfo.isInsuranceCardsSkipped") === true}
                                                isDisabled={false}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        {getValues("insuranceInfo.insuranceCards")===undefined || (getValues("insuranceInfo.insuranceCards") && getValues("insuranceInfo.insuranceCards").length === 0) ?
                                            <Grid item md={5} xs={12}>
                                                <CustomCheckbox
                                                    control={control}
                                                    label="I acknowledge the information is on file, and not available for upload at this time."
                                                    controllerName={`insuranceInfo.${"isInsuranceCardsSkipped"}`}
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            clearErrors('insuranceInfo.insuranceCards');
                                                            const insuranceCardsIds = getValues("insuranceInfo.insuranceCards");
                                                            // Check if supportingDocsIds exists and has values before mapping
                                                            if (insuranceCardsIds && insuranceCardsIds.length > 0) {
                                                                const removePromises = insuranceCardsIds.map((id) =>
                                                                    dispatch(removeIVRDocument(id.toString()))
                                                                );
                                                            }
                                                            setValue("insuranceInfo.insuranceCards", []);
                                                            setUploadedPrimaryInsuranceFilesMetaData([]);
                                                        } else {
                                                            trigger('insuranceInfo.insuranceCards');
                                                        }
                                                        checkInsuranceInfoValidity({ ...watch() });
                                                    }}
                                                // isDisabled={isPatientInfoDisabled || disableAllFields}
                                                />
                                            </Grid>
                                            : ""}
                                    </Grid>
                                    <Grid container spacing={2} sx={{ marginTop: "2px", marginBottom: "5px" }}>
                                        <Grid
                                            item
                                            xs={12}
                                            md
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Typography sx={{ ...inlineLabelSx, fontSize: "0.92rem", fontWeight: 700, color: mTokens.textPrimary }}>Secondary Insurance</Typography>
                                            <CustomCheckbox
                                                control={control}
                                                label="Yes"
                                                name="secondaryInsurance"
                                                id="secondaryInsurance"
                                                controllerName={`insuranceInfo.${"isSecondaryInsurance"}`}
                                                checked={isSecondaryInsurance}
                                                onChange={() => {handleSecondaryInsuranceChange()}}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        {isSecondaryInsurance && (
                                            <>
                                                <Grid
                                                    item md={2} xs={12}
                                                >
                                                    <FieldLabel label="Category" required />
                                                    <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.secondaryInsuranceCategory)}>
                                                    <CustomDropdownField
                                                        control={control}
                                                        name={`insuranceInfo.${"secondaryInsuranceCategory"}`}
                                                        options={insuranceCategory}
                                                        label=""
                                                        size="small"
                                                        sortOptions={false}
                                                        onChangeSelect={(data) => {
                                                            if (data) {
                                                                // CS-1758 - When in facesheet flow, check if the selected category has
                                                                // cached AI-extracted data and restore it instead of clearing
                                                                const selectedCategory = data.value;
                                                                const cachedSecondary = createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET
                                                                    ? facesheetSecondaryInsuranceCacheRef.current[selectedCategory]
                                                                    : null;

                                                                if (cachedSecondary) {
                                                                    // CS-1758 - Restore facesheet-extracted secondary insurance values for this category
                                                                    setValue("insuranceInfo.secondaryInsuranceName", cachedSecondary.secondaryInsuranceName || '');
                                                                    setValue("insuranceInfo.secondaryInsurancePayerCode", cachedSecondary.secondaryInsurancePayerCode || '');
                                                                    setValue("insuranceInfo.secondaryCommercialInsuranceName", cachedSecondary.secondaryCommercialInsuranceName || '');
                                                                    setSecondaryInsuranceNameNotListed(cachedSecondary.secondaryInsuranceNameNotListed || false);
                                                                    setValue("insuranceInfo.secondaryInsuranceNameNotListed", cachedSecondary.secondaryInsuranceNameNotListed || false);
                                                                    if (cachedSecondary.secondaryPolicy) setValue("insuranceInfo.secondaryPolicy", cachedSecondary.secondaryPolicy);
                                                                    // CS-1758 - Restore secondary subscriber/policyholder info from cache
                                                                    if (cachedSecondary.isSecondaryPolicyUnderDifferentName && cachedSecondary.subscriberName) {
                                                                        setValue("insuranceInfo.isSecondaryPolicyUnderDifferentName", true);
                                                                        setIsPolicyUnderDifferentNameCheckSecondary(true);
                                                                        const secNameParts = cachedSecondary.subscriberName.trim().split(/\s+/).filter(Boolean);
                                                                        if (secNameParts.length >= 1) setValue("insuranceInfo.secondarypolicyholderFirstName", secNameParts[0]);
                                                                        if (secNameParts.length === 2) setValue("insuranceInfo.secondarypolicyholderLastName", secNameParts[1]);
                                                                        if (secNameParts.length >= 3) {
                                                                            setValue("insuranceInfo.secondarypolicyholderMiddleName", secNameParts.slice(1, -1).join(" "));
                                                                            setValue("insuranceInfo.secondarypolicyholderLastName", secNameParts[secNameParts.length - 1]);
                                                                        }
                                                                    }
                                                                    // CS-1758 - Clear validation errors on restored fields so stale required errors disappear
                                                                    clearErrors("insuranceInfo.secondaryCommercialInsuranceName");
                                                                    clearErrors("insuranceInfo.secondaryPolicy");
                                                                    clearErrors("insuranceInfo.secondaryInsurancePayerCode");
                                                                } else {
                                                                    // CS-1758 - Normal reset for categories without cached facesheet data
                                                                    setValue("insuranceInfo.secondaryInsuranceName", '')
                                                                    setValue("insuranceInfo.secondaryInsurancePayerCode", '')
                                                                    setValue("insuranceInfo.secondaryCommercialInsuranceName", '')
                                                                }
                                                                clearErrors("insuranceInfo.secondaryInsuranceCategory");
                                                                void trigger("insuranceInfo.secondaryInsuranceCategory");
                                                            }
                                                        }}
                                                        rules={{ required: "Category is required." }}
                                                        disabled={false}
                                                    />
                                                    </Box>
                                                </Grid>
                                                <Grid item md={2} xs={12}>
                                                {/* <CustomTextField
                                                        controllerName={`insuranceInfo.${"secondaryInsuranceName"}`}
                                                        control={control}
                                                        label="Insurance Name"
                                                        rules={{
                                                            validate: (value: any) => {
                                                                if (submitAction === "submitAction" && !value) {
                                                                return "Insurance Name is required.";
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                    />
                                                  */}
                                                    <FieldLabel label="Plan" required />
                                                    <Box sx={dropdownFieldWrapSx(!!errors?.insuranceInfo?.secondaryInsurancePayerCode)}>
                                                    <CustomDropdownField
                                                        control={control}
                                                        name={`insuranceInfo.${"secondaryInsurancePayerCode"}`}
                                                        label=""
                                                        size="small"
                                                        options={secondaryPayersOptions}
                                                        sortOptions={false}
                                                        onChangeSelect={(data) => {
                                                            // CS-1758 - When in facesheet flow and user re-selects the cached plan,
                                                            // restore all related fields (policy, subscriber, commercial plan name)
                                                            const currentCategory = getValues('insuranceInfo.secondaryInsuranceCategory');
                                                            const cachedSecondary = createPatientFlowSource === CREATE_PATIENT_FLOW_SOURCE.FACESHEET
                                                                ? facesheetSecondaryInsuranceCacheRef.current[currentCategory]
                                                                : null;
                                                            const isCachedPlan = cachedSecondary
                                                                && String(cachedSecondary.secondaryInsurancePayerCode) === String(data?.value);

                                                            if (isCachedPlan) {
                                                                // CS-1758 - Restore all facesheet-extracted secondary insurance fields for this plan
                                                                setValue("insuranceInfo.secondaryInsuranceName", cachedSecondary.secondaryInsuranceName || '');
                                                                setValue("insuranceInfo.secondaryInsurancePayerCode", cachedSecondary.secondaryInsurancePayerCode || '');
                                                                setValue("insuranceInfo.secondaryCommercialInsuranceName", cachedSecondary.secondaryCommercialInsuranceName || '');
                                                                setSecondaryInsuranceNameNotListed(cachedSecondary.secondaryInsuranceNameNotListed || false);
                                                                setValue("insuranceInfo.secondaryInsuranceNameNotListed", cachedSecondary.secondaryInsuranceNameNotListed || false);
                                                                if (cachedSecondary.secondaryPolicy) setValue("insuranceInfo.secondaryPolicy", cachedSecondary.secondaryPolicy);
                                                                if (cachedSecondary.isSecondaryPolicyUnderDifferentName && cachedSecondary.subscriberName) {
                                                                    setValue("insuranceInfo.isSecondaryPolicyUnderDifferentName", true);
                                                                    setIsPolicyUnderDifferentNameCheckSecondary(true);
                                                                    const secNameParts = cachedSecondary.subscriberName.trim().split(/\s+/).filter(Boolean);
                                                                    if (secNameParts.length >= 1) setValue("insuranceInfo.secondarypolicyholderFirstName", secNameParts[0]);
                                                                    if (secNameParts.length === 2) setValue("insuranceInfo.secondarypolicyholderLastName", secNameParts[1]);
                                                                    if (secNameParts.length >= 3) {
                                                                        setValue("insuranceInfo.secondarypolicyholderMiddleName", secNameParts.slice(1, -1).join(" "));
                                                                        setValue("insuranceInfo.secondarypolicyholderLastName", secNameParts[secNameParts.length - 1]);
                                                                    }
                                                                }
                                                                // CS-1758 - Clear validation errors on restored fields
                                                                clearErrors("insuranceInfo.secondaryCommercialInsuranceName");
                                                                clearErrors("insuranceInfo.secondaryPolicy");
                                                                checkInsuranceInfoValidity({ ...watch() });
                                                            } else if (getValues('insuranceInfo.secondaryInsuranceName')) {
        
                                                                setValue("insuranceInfo.secondaryInsuranceName", data?.label);
                                                                setValue("insuranceInfo.secondaryInsurancePayerCode", data?.value);
                                                                if (getValues("insuranceInfo.secondaryInsuranceCategory") === "Commercial" && data?.label === "Other") {
        
                                                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                                                    checkInsuranceInfoValidity({ ...watch() });
                                                                } else if (getValues("insuranceInfo.secondaryInsuranceCategory") !== "Commercial" && data?.label) {
        
                                                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                                                    checkInsuranceInfoValidity({ ...watch() });
                                                                } else {
        
                                                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                                                    setValue(`insuranceInfo.${"secondaryCommercialInsuranceName"}`, '');
                                                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                                                    checkInsuranceInfoValidity({ ...watch() });
                                                                }
                                                            } else {
        
                                                                if (getValues("insuranceInfo.secondaryInsuranceCategory") === "Commercial" && data?.label === "Other") {
        
                                                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                                                    checkInsuranceInfoValidity({ ...watch() });
                                                                } else if (getValues("insuranceInfo.secondaryInsuranceCategory") !== "Commercial" && data?.label) {
                                                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
        
                                                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                                                    checkInsuranceInfoValidity({ ...watch() });
                                                                } else {
        
                                                                    setValue(`insuranceInfo.${"secondaryInsuranceName"}`, data?.label);
                                                                    setValue(`insuranceInfo.${"secondaryCommercialInsuranceName"}`, '');
                                                                    setValue(`insuranceInfo.${"secondaryInsurancePayerCode"}`, data?.value);
                                                                    checkInsuranceInfoValidity({ ...watch() });
                                                                }
                                                            }
                                                        }}
                                                        // rules={{
                                                        //     validate: (value: any) => {
                                                        //         if (submitAction === "submitAction" &&  !getValues("insuranceInfo.secondaryInsuranceName")) {
                                                        //             return "Plan is required.";
                                                        //         }
                                                        //         return true;
                                                        //     }
                                                        // }}     
                                                        
                                                        // CS-1335 Start
                                                        // CS-1758 - Surface secondary plan validation during the facesheet auto-fill flow without waiting for Save
                                                        rules={{
                                                            required:
                                                            (submitAction === "submitAction" || showFacesheetValidation) &&
                                                            watch('insuranceInfo.secondaryInsuranceCategory') &&
                                                            secondaryPayersOptions?.length !== 1
                                                                ? "Plan is required."
                                                                : false
                                                        }}
                                                        // CS-1335 End
                                                        disabled={!watch('insuranceInfo.secondaryInsuranceCategory') || secondaryPayersOptions?.length === 1}
                                                    />
                                                    </Box>
                                                </Grid>
                                                <Grid item md={2} xs={12}>
                                                    <FieldLabel label="Policy #" />
                                                    <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.secondaryPolicy)}>
                                                    <CustomTextField
                                                        controllerName={`insuranceInfo.${"secondaryPolicy"}`}
                                                        control={control}
                                                        label=""
                                                        size="small"
                                                        inputProps={{ maxLength:watch('insuranceInfo.secondaryInsuranceCategory')==="Medicare" && 11, style: { textTransform: 'uppercase' } }}
                                                        rules={{
                                                            // validate: (value: any) => {
                                                            //     if (submitAction === "submitAction" && !value) {
                                                            //         return "Policy # is required.";
                                                            //     }
                                                            //     return true;
                                                            // }
                                                            // CS-1335 Start
                                                            // CS-1758 - Reuse submit-time secondary policy validation when the user comes from facesheet extraction
                                                            validate: (value: any) => {
                                                                const isMedicare = watch('insuranceInfo.secondaryInsuranceCategory') === "Medicare";
                                                                const shouldValidateSecondaryPolicy = submitAction === "submitAction" || showFacesheetValidation;

                                                                if (shouldValidateSecondaryPolicy && isMedicare) {
                                                                    return validateMedicarePolicyNumber(value);
                                                                } else if (shouldValidateSecondaryPolicy) {
                                                                    if (!value) return "Policy # is required.";
                                                            }
                                                                return true;
                                                            }
                                                            // CS-1335 End
                                                        }}
                                                    />
                                                    </Box>
                                                </Grid>
                                                {/* CS-1758 - Show secondary commercial plan field when secondaryCommercialInsuranceName has value from facesheet */}
                                                {(watch("insuranceInfo.secondaryCommercialInsuranceName") ||
                                                    (getValues("insuranceInfo.secondaryInsuranceCategory") === "Commercial" && watch("insuranceInfo.secondaryInsuranceName") === "Other")) && (
                                                    <Grid item md="auto" xs={12}>
                                                        <Box display="flex" alignItems="flex-start" gap={1}>
                                                            <Grid xs={6} md="auto">
                                                                <Typography sx={{ ...inlineLabelSx, mt: 3.2 }}>Plan:</Typography>
                                                            </Grid>
                                                            <Grid xs={6} md={10}>
                                                                <FieldLabel label="Plan" />
                                                                <Box sx={textFieldWrapSx(!!errors?.insuranceInfo?.secondaryCommercialInsuranceName)}>
                                                                <CustomTextField
                                                                    controllerName={`insuranceInfo.${"secondaryCommercialInsuranceName"}`}
                                                                    control={control}
                                                                    label=""
                                                                    size="small"
                                                                    rules={{
                                                                        // CS-1758 - Show the secondary "Other" commercial plan requirement after facesheet auto-fill
                                                                        validate: (value: any) => {
                                                                            if ((submitAction === "submitAction" || showFacesheetValidation) && !value) {
                                                                                return "Plan is required.";
                                                                            }
                                                                            return true;
                                                                        }
                                                                    }}
                                                                    onChange={() => { checkInsuranceInfoValidity({ ...watch() }); }}
                                                                />
                                                                </Box>
                                                            </Grid>
                                                        </Box>

                                                    </Grid>
                                                )}
                                                <Grid
                                                    item
                                                    md={12}
                                                    xs={12}
                                                    sx={{
                                                        display: {
                                                            xs: "block",
                                                            md: "flex",
                                                        },
                                                        alignItems: {
                                                            md: "center",
                                                        },
                                                    }}
                                                >
                                                    <Typography sx={inlineLabelSx}>Plan is NOT listed</Typography>
                                                    <CustomCheckbox
                                                        control={control}
                                                        label="Yes"
                                                        name="secondaryInsuranceNameNotListed"
                                                        id="secondaryInsuranceNameNotListed"
                                                        controllerName={`insuranceInfo.${"secondaryInsuranceNameNotListed"}`}
                                                        checked={secondaryInsuranceNameNotListed}
                                                        onChange={() => { handleSecondaryInsuranceClick() }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Typography sx={inlineLabelSx}>
                                                        Is the policy under a different name?
                                                    </Typography>
                                                    <CustomRadioButton
                                                        control={control}
                                                        options={policyOptions}
                                                        controllerName={`insuranceInfo.${"isSecondaryPolicyUnderDifferentName"}`}
                                                        onChange={setSecondaryInsurancePolicyNameChange}
                                                    />
                                                </Grid>
                                                {isPolicyUnderDifferentNameCheckSecondary ? (
                                                    <>
                                                        <Grid item md={12} xs={12}>
                                                            <FieldLabel label="Policy Holder" required />
                                                            <Box sx={textFieldWrapSx(!!(errors?.insuranceInfo?.secondarypolicyholderFirstName || errors?.insuranceInfo?.secondarypolicyholderLastName))}>
                                                            <CustomNametField
                                                                control={control}
                                                                context="secondaryPolicyHolder"
                                                                label="Policy Holder"
                                                                size="small"
                                                                name="insuranceInfo"
                                                                usePlaceholder={true}
                                                                // CS-1335 Start
                                                                isRequired={isPolicyUnderDifferentNameCheckSecondary}
                                                                // CS-1335 End
                                                            />
                                                            </Box>
                                                        </Grid>

                                                        <Grid item md={4} xs={12}>
                                                            <FieldLabel label="Policy Holder DOB" required />
                                                            <Box sx={dateFieldWrapSx(!!errors?.insuranceInfo?.secondaryPolicyHolderDOB)}>
                                                            <CustomDatePicker
                                                                control={control}
                                                                controllerName={`insuranceInfo.${"secondaryPolicyHolderDOB"}`}
                                                                label=""
                                                                size="small"
                                                                rules={{
                                                                    required: "Policy Holder DOB is required.", // CS-1335
                                                                    // validate: (value: any) => {
                                                                    //     if (submitAction === "submitAction" && !value) {
                                                                    //         return "Policy Holder DOB is required.";
                                                                    //     }
                                                                    //     return true;
                                                                    // }
                                                                }}
                                                            />
                                                            </Box>
                                                        </Grid>
                                                        <Grid item md={12} xs={12}></Grid>
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                                <Grid item md={12} xs={12}>
                                                    <Grid item md={3} xs={12}>
                                                        <FieldLabel label="Insurance Cards" required />
                                                        <Dropzone
                                                            control={control}
                                                            name={`insuranceInfo.${"secondaryInsuranceCards"}`}
                                                            onFileChange={handleSecondaryInsuranceCardChange}
                                                            label=""
                                                            onDeleteFile={
                                                                handleDeleteSecondaryInsuranceDocument
                                                            }
                                                            rules={{ required: "Secondary Insurance Cards are required." }}
                                                            initialFilesMetaData={uploadedSecondaryInsuranceFilesMetaData}
                                                            //isDisabled={getValues("insuranceInfo.isSecondaryInsuranceCardsSkipped") === true}
                                                            isDisabled={false}
                                                        />
                                                    </Grid>
                                                    {getValues("insuranceInfo.secondaryInsuranceCards") === undefined || (getValues("insuranceInfo.secondaryInsuranceCards") && getValues("insuranceInfo.secondaryInsuranceCards")?.length === 0) ?
                                                        <Grid item md={5} xs={12}>
                                                            <CustomCheckbox
                                                                control={control}
                                                                label="I acknowledge the information is on file, and not available for upload at this time."
                                                                controllerName={`insuranceInfo.${"isSecondaryInsuranceCardsSkipped"}`}
                                                                onChange={(e) => {
                                                                    if (e.target.checked === true) {
                                                                        clearErrors('insuranceInfo.secondaryInsuranceCards');
                                                                        const insuranceCardsIds = getValues("insuranceInfo.secondaryInsuranceCards");
                                                                        // Check if supportingDocsIds exists and has values before mapping
                                                                        if (insuranceCardsIds && insuranceCardsIds.length > 0) {
                                                                            const removePromises = insuranceCardsIds.map((id) =>
                                                                                dispatch(removeIVRDocument(id.toString()))
                                                                            );
                                                                        }
                                                                        setValue("insuranceInfo.secondaryInsuranceCards", []);

                                                                        setUploadedSecondaryInsuranceFilesMetaData([]);
                                                                    } else {
                                                                        trigger('insuranceInfo.secondaryInsuranceCards');
                                                                    }
                                                                    checkInsuranceInfoValidity({ ...watch() });
                                                                }}
                                                            // isDisabled={isPatientInfoDisabled || disableAllFields}
                                                            />
                                                        </Grid>
                                                        : ""}
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>
                                </Box>
                                </Collapse>
                            </Box>

                            <Box ref={supportingDocumentationRef} sx={cardSx} data-testid="bordered-section">
                                <SectionHeader
                                    icon={<AttachFileOutlined fontSize="small" />}
                                    title="Supporting Documentation"
                                    onHeaderClick={() => setSupportingDocsExpanded(!supportingDocsExpanded)}
                                    action={
                                        <IconButton
                                            size="small"
                                            aria-label={supportingDocsExpanded ? "Collapse section" : "Expand section"}
                                            onClick={(e) => { e.stopPropagation(); setSupportingDocsExpanded(!supportingDocsExpanded); }}
                                            sx={collapseToggleSx}
                                        >
                                            {supportingDocsExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                                        </IconButton>
                                    }
                                />
                                <Collapse in={supportingDocsExpanded}>
                                <Box sx={sectionBodySx}>
                                <Grid container spacing={2} alignItems="flex-end">
                                    <Grid item md={6} xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item md={6} xs={12}>
                                                <FieldLabel label="Medical Notes" required />
                                                <Dropzone
                                                    control={control}
                                                    name={`supportingDocumentation.${"supportingDocuments"}`}
                                                    rules={{
                                                        required: "Supporting Documents are required.",
                                                    }}
                                                    onFileChange={handleSupportingDocsChange}
                                                    label=""
                                                    onDeleteFile={handleDeleteSupportingDocument}
                                                    holdOnChange={true}
                                                    initialFilesMetaData={uploadedSupportingDocumentFilesMetaData}
                                                    //isDisabled={getValues("supportingDocumentation.isSupportingDocumentsSkipped") === true}
                                                    isDisabled={false}
                                                    showMedicalAuditButton={hasSubscribedAccessToMedicalAudit}
                                                    skipAuditStartedWaitContinuePopup={!patientEditDetails?.isPatientEdit}
                                                    patientId={patientInfoObject?.patientId || null}
                                                    patientName={[
                                                        getValues("patientInfo.FirstName"),
                                                        getValues("patientInfo.MiddleName"),
                                                        getValues("patientInfo.LastName"),
                                                    ]
                                                        .map((v) => (typeof v === "string" ? v.trim() : ""))
                                                        .filter(
                                                            (v) =>
                                                                v &&
                                                                v.toLowerCase() !== "null" &&
                                                                v.toLowerCase() !== "undefined",
                                                        )
                                                        .join(" ") || undefined}
                                                    docType="medical notes"
                                                    // CS-1594 - Pass audit data management props
                                                    auditDataByDocument={auditDataByDocument}
                                                    onAuditComplete={handleAuditComplete}
                                                />
                                            </Grid>
                                            {/* CS-1706 - Show Medical Note Audit Agreement button only when NOT signed */}
                                            {hasSubscribedAccessToMedicalAudit && 
                                             !userInfo?.subscribedServices?.includes(AI_SERVICE_NAME.MEDICAL_AUDIT_NOTE) && (
                                                <>
                                                    <Grid item md={6} xs={12} sx={{ alignSelf: "flex-start", marginTop: "5%" }}>
                                                        <AiMedicalAuditInfo
                                                            size="small"
                                                            serviceName={AI_SERVICE_NAME.MEDICAL_AUDIT_NOTE}
                                                            tooltipText="AI Medical Audit"
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid item md={12} xs={12}>
                                                {getValues("supportingDocumentation.supportingDocuments")===undefined || (getValues("supportingDocumentation.supportingDocuments") && getValues("supportingDocumentation.supportingDocuments").length === 0) ?
                                                    <CustomCheckbox
                                                        control={control}
                                                        label="I acknowledge the information is on file, and not available for upload at this time."
                                                        controllerName={`supportingDocumentation.${"isSupportingDocumentsSkipped"}`}
                                                        onChange={(e) => {
                                                            if (e.target.checked === true) {
                                                                clearErrors("supportingDocumentation.supportingDocuments");
                                                                const supportingDocsIds = getValues("supportingDocumentation.supportingDocuments");
                                                                // Check if supportingDocsIds exists and has values before mapping
                                                                if (supportingDocsIds && supportingDocsIds.length > 0) {
                                                                    const removePromises = supportingDocsIds.map((id) =>
                                                                        dispatch(removeIVRDocument(id.toString()))
                                                                    );
                                                                }
                                                                setValue("supportingDocumentation.supportingDocuments", []);
                                                                setUploadedSupportingDocumentFilesMetaData([]);
                                                            } else {
                                                                trigger("supportingDocumentation.supportingDocuments");
                                                            }
                                                            checkSupportingDocumentationValidity({ ...watch() });
                                                        }}
                                                    //   isDisabled={disableAllFields}
                                                    />
                                                    : ""}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item md={6} xs={12}>
                                                <FieldLabel label="Images of Wounds" required />
                                                <Dropzone
                                                    control={control}
                                                    name={`supportingDocumentation.${"imageOfWounds"}`}
                                                    rules={{ required: "Image of Wounds are required." }}
                                                    onFileChange={handleImageOfWoundsChange}
                                                    label=""
                                                    onDeleteFile={handleDeleteImageOfWoundsDocument}
                                                    holdOnChange={true}
                                                    initialFilesMetaData={uploadedWoundImageFilesMetaData}
                                                    //isDisabled={getValues("supportingDocumentation.isImageOfWoundsSkipped") === true}
                                                    isDisabled={false}
                                                />
                                            </Grid>
                                            <Grid item md={12} xs={12}>
                                                {getValues("supportingDocumentation.imageOfWounds")===undefined || (getValues("supportingDocumentation.imageOfWounds") && getValues("supportingDocumentation.imageOfWounds").length === 0) ?
                                                    <CustomCheckbox
                                                        control={control}
                                                        label="I acknowledge the information is on file, and not available for upload at this time."
                                                        controllerName={`supportingDocumentation.${"isImageOfWoundsSkipped"}`}
                                                        onChange={(e) => {
                                                            if (e.target.checked === true) {
                                                                clearErrors("supportingDocumentation.imageOfWounds");
                                                                const imageOfWoundsIds = getValues("supportingDocumentation.imageOfWounds");
                                                                // Check if supportingDocsIds exists and has values before mapping
                                                                if (imageOfWoundsIds && imageOfWoundsIds.length > 0) {
                                                                    const removePromises = imageOfWoundsIds.map((id) =>
                                                                        dispatch(removeIVRDocument(id.toString()))
                                                                    );
                                                                }
                                                                setValue("supportingDocumentation.imageOfWounds", []);
                                                                setUploadedWoundImageFilesMetaData([]);
                                                            } else {
                                                                trigger("supportingDocumentation.imageOfWounds");
                                                            }
                                                            checkSupportingDocumentationValidity({ ...watch() });
                                                        }}
                                                    // isDisabled={disableAllFields}
                                                    />
                                                    : ""}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                </Box>
                                </Collapse>
                            </Box>

                            <Box ref={woundDataRef} sx={cardSx} data-testid="bordered-section">
                                {/* CS-1404 - Label change according to stepper */}
                                <SectionHeader
                                    icon={<ContentPasteOutlined fontSize="small" />}
                                    title="Wound Data"
                                    onHeaderClick={() => setWoundDataExpanded(!woundDataExpanded)}
                                    action={
                                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                                            {selectedPracticeType !== PRACTICE_TYPE.SURGICAL && (
                                                <Button
                                                    variant="outlined"
                                                    removeUpperCase
                                                    startIcon={<AddCircleOutlineOutlined />}
                                                    onClick={(e) => { e.stopPropagation(); clickShowWoundInfoPopup(); }}
                                                    sx={sectionActionBtnSx(!!errors?.woundInfo?.woundData && !((getValues("woundInfo.woundData")?.length ?? 0) > 0))}
                                                >
                                                    Add Wound
                                                </Button>
                                            )}
                                            {(selectedPracticeType === PRACTICE_TYPE.SURGICAL || selectedPracticeType === PRACTICE_TYPE.WOUND_CARE_AND_SURGICAL) && (
                                                <Button
                                                    variant="outlined"
                                                    removeUpperCase
                                                    startIcon={<AddCircleOutlineOutlined />}
                                                    onClick={(e) => { e.stopPropagation(); clickShowIncisionInfoPopup(); }}
                                                    sx={sectionActionBtnSx(!!errors?.woundInfo?.woundData && !((getValues("woundInfo.woundData")?.length ?? 0) > 0))}
                                                >
                                                    Add Incision
                                                </Button>
                                            )}
                                            <IconButton
                                                size="small"
                                                aria-label={woundDataExpanded ? "Collapse section" : "Expand section"}
                                                onClick={(e) => { e.stopPropagation(); setWoundDataExpanded(!woundDataExpanded); }}
                                                sx={collapseToggleSx}
                                            >
                                                {woundDataExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                                            </IconButton>
                                        </Box>
                                    }
                                />
                                <Collapse in={woundDataExpanded}>
                                <Box sx={sectionBodySx}>
                                <Grid container spacing={2}>
                                    <Controller
                                        name={`woundInfo.woundData`}
                                        control={control}
                                        // rules={{
                                        //     validate: (value: any) => {
                                        //         if (submitAction === "submitAction" && value.length === 0) {
                                        //             return "At least 1 wound information is required.";
                                        //         }
                                        //         return true;
                                        //     }
                                        // }}
                                        render={({ field, fieldState }) => {
                                            return (
                                                <>
                                                    {fieldState.error && (
                                                        <Typography
                                                            color="error"
                                                            variant="body2"
                                                            style={{ marginTop: "1px", marginLeft: "15px" }}
                                                        >
                                                            {fieldState.error.message}
                                                        </Typography>
                                                    )}

                                                    <Grid item md={12} xs={12}>
                                                        {/* <LegacyToolBar items={legacyItems}/> */}
                                                        <CustomTable
                                                            columns={woundInfoTableColumns}
                                                            rows={woundInfoTableRows}
                                                            actionComponent={(row: any, rowIndex: number) =>
                                                                woundInfoActionComponent(row, rowIndex)
                                                            }
                                                            disablePagination={true}
                                                            showMenu={true}
                                                            sx={woundTableWrapSx}
                                                        />
                                                    </Grid>
                                                </>
                                            );
                                        }}
                                    />
                                    <Grid item md={2} xs={12}>
                                        <FieldLabel label="Total Volume of All Wounds (cm³)" />
                                        <Box sx={textFieldWrapSx(!!errors?.woundInfo?.totalSizeOfAllWounds)}>
                                        <CustomTextField
                                            controllerName={`woundInfo.${"totalSizeOfAllWounds"}`}
                                            control={control}
                                            label=""
                                            size="small"
                                            isNumberOnly={true} //CS-1605
                                            // rules={{
                                            //     validate: (value: string) => {
                                            //         if (submitAction === "submitAction" && !value) {
                                            //             return "Total Volume of all wounds is required.";
                                            //         }
                                            //         return true;
                                            //     }
                                            // }}
                                            onChange={(e) => {
                                                checkWoundInfoValidity({ ...watch() });
                                            }}
                                        // isDisabled={disableAllFields}
                                        />
                                        </Box>
                                    </Grid>
                                </Grid>
                                </Box>
                                </Collapse>
                            </Box>
                            {/* CS-1426 - Start */}
                            <Box
                                display="flex"
                                justifyContent="flex-end"
                                mt="0.5"
                                mb={4}
                                sx={{
                                    flexDirection: { xs: "column", sm: "row" },
                                    gap: 1.2,
                                    alignItems: "center",
                                }}
                            >
                                {patientInfoObject?.status !== PATIENT_STATUS.ACTIVE && patientInfoObject?.status !== PATIENT_STATUS.CLOSED && (
                                    <Button
                                        type="submit"
                                        startIcon={<SaveOutlined />}
                                        variant="outlined"
                                        onClick={() => { setSubmitAction('saveAction') }}
                                        removeUpperCase
                                        fullWidth
                                        sx={{
                                            ...cancelBtnSx,
                                            color: mTokens.accent,
                                            borderColor: `${mTokens.accent}8c`,
                                            backgroundColor: isDarkModal ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
                                            minWidth: { sm: 160 },
                                            width: { xs: "100%", sm: "auto" },
                                            "&:hover": {
                                                color: "#fff",
                                                borderColor: mTokens.accent,
                                                backgroundColor: mTokens.accent,
                                                boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
                                            },
                                            "& .MuiTypography-root": { color: "inherit", fontWeight: 700 },
                                            "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
                                        }}
                                    >
                                        Save As Draft
                                    </Button>
                                )}
                                <Button
                                    type="submit"
                                    startIcon={<ClassOutlined />}
                                    onClick={() => { setSubmitAction('submitAction') }}
                                    removeUpperCase
                                    fullWidth
                                    sx={{
                                        ...primaryBtnSx,
                                        minWidth: { sm: 160 },
                                        width: { xs: "100%", sm: "auto" },
                                        "& .MuiTypography-root": { color: "#fff", fontWeight: 700 },
                                        "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "#fff" },
                                    }}
                                >
                                    Save
                                </Button>
                                <Button
                                    variant="outlined"
                                    startIcon={<CancelOutlined />}
                                    onClick={onCancelClick}
                                    removeUpperCase
                                    fullWidth
                                    sx={{
                                        ...backBtnSx,
                                        minWidth: { sm: 140 },
                                        width: { xs: "100%", sm: "auto" },
                                        "& .MuiTypography-root": { color: "inherit", fontWeight: 700 },
                                        "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: "inherit" },
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Box>
                            {/* CS-1426 - End */}
                        </Box>
                    </form>
            </Box>
        </Box>
        </>
    );
}

export default CreatePatient;
